export default {
  'pages.404.buttonText': 'Back Home',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, workbench to use npm run ui to start the experience.',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.application.error.create': 'Failed to create application',
  'pages.application.error.delete': 'Failed to delete application',
  'pages.application.error.org': 'Failed to get organization information',
  'pages.application.error.project': 'Failed to get project information',
  'pages.application.error.update': 'Failed to update application',
  'pages.application.error.user': 'Failed to get user information',
  'pages.application.form.code.exists': 'Application code already exists',
  'pages.application.form.code.label': 'Application Code',
  'pages.application.form.code.placeholder':
    'Please enter application code, e.g. CRM',
  'pages.application.form.code.required': 'Please enter application code',
  'pages.application.form.desc.label': 'Description',
  'pages.application.form.desc.placeholder': 'Please enter description',
  'pages.application.form.name.label': 'Application Name',
  'pages.application.form.name.placeholder': 'Please enter application name',
  'pages.application.form.name.required': 'Please enter application name',
  'pages.application.form.type.label': 'Application Type',
  'pages.application.form.type.placeholder':
    'Please enter application type, e.g. web',
  'pages.application.form.url.label': 'Home URL',
  'pages.application.list.columns.action': 'Action',
  'pages.application.list.columns.code': 'Application Code',
  'pages.application.list.columns.home': 'Home Page',
  'pages.application.list.columns.name': 'Application Name',
  'pages.application.list.columns.type': 'Type',
  'pages.application.list.columns.updatedAt': 'Updated At',
  'pages.application.list.create': 'Create Application',
  'pages.application.list.delete': 'Delete',
  'pages.application.list.deleteConfirm':
    'Are you sure you want to delete this application?',
  'pages.application.list.edit': 'Edit',
  'pages.workspace.list.subTitle':
    'Manage project workspaces and repository boundaries',
  'pages.codebase.catalog.title': 'Code Repository',
  'pages.codebase.catalog.subTitle':
    'Manage project repositories and workspace ownership',
  'pages.customerIntelligence.customerList.boolean.yes': 'Yes',
  'pages.customerIntelligence.customerList.boolean.no': 'No',
  'pages.customerIntelligence.customerList.placeholder.empty': '-',
  'pages.customerIntelligence.customerList.columns.name': 'Customer Name',
  'pages.customerIntelligence.customerList.columns.owner': 'Owner',
  'pages.customerIntelligence.customerList.columns.mobile': 'Mobile',
  'pages.customerIntelligence.customerList.columns.email': 'Email',
  'pages.customerIntelligence.customerList.columns.followUpStatus':
    'Follow-up Status',
  'pages.customerIntelligence.customerList.columns.lockStatus': 'Locked',
  'pages.customerIntelligence.customerList.columns.dealStatus': 'Won',
  'pages.customerIntelligence.customerList.columns.contactLastTime':
    'Last Contact',
  'pages.customerIntelligence.customerList.columns.contactNextTime':
    'Next Contact',
  'pages.customerIntelligence.customerList.search.keyword': 'Keyword',
  'pages.customerIntelligence.customerList.alert.missingMember':
    'The current account is not bound to a member, so customers cannot be viewed or created.',
  'pages.customerIntelligence.customerList.alert.missingTenant':
    'No tenant is selected. Customer data may not load correctly.',
  'pages.customerIntelligence.customerList.create.button': 'Create Customer',
  'pages.customerIntelligence.customerList.create.success':
    'Customer created successfully',
  'pages.customerIntelligence.customerList.create.error':
    'Failed to create customer',
  'pages.customerIntelligence.customerList.create.modalTitle':
    'Create Customer',
  'pages.customerIntelligence.customerList.create.form.name': 'Customer Name',
  'pages.customerIntelligence.customerList.create.form.name.required':
    'Please enter customer name',
  'pages.customerIntelligence.customerList.create.form.name.placeholder':
    'Please enter customer name',
  'pages.customerIntelligence.customerList.create.form.mobile': 'Mobile',
  'pages.customerIntelligence.customerList.create.form.telephone': 'Telephone',
  'pages.customerIntelligence.customerList.create.form.email': 'Email',
  'pages.customerIntelligence.customerList.create.form.qq': 'QQ',
  'pages.customerIntelligence.customerList.create.form.wechat': 'WeChat',
  'pages.customerIntelligence.customerList.create.form.remark': 'Remark',
  'pages.customerIntelligence.customerList.empty': 'No customer data',
  'pages.customerIntelligence.customerList.detail.title': 'Customer Detail',
  'pages.application.list.subTitle':
    'Manage all applications under the project',
  'pages.application.list.title': 'Application List',
  'pages.application.success.create': 'Application created successfully',
  'pages.application.success.delete': 'Application deleted successfully',
  'pages.application.success.update': 'Application updated successfully',
  'pages.assetLibrary.columns.action': 'Action',
  'pages.assetLibrary.columns.action.delete': 'Delete',
  'pages.assetLibrary.columns.action.download': 'Download',
  'pages.assetLibrary.columns.action.preview': 'Preview',
  'pages.assetLibrary.columns.action.upload': 'Upload Asset',
  'pages.assetLibrary.columns.name': 'Asset Name',
  'pages.assetLibrary.columns.owner': 'Owner',
  'pages.assetLibrary.columns.size': 'Size',
  'pages.assetLibrary.columns.type': 'Type',
  'pages.assetLibrary.columns.updatedAt': 'Updated At',
  'pages.assetLibrary.folders': 'Folders',
  'pages.assetLibrary.folders.addSub': '新增子级文件夹',
  'pages.assetLibrary.folders.createSuccess': '文件夹创建成功',
  'pages.assetLibrary.folders.delete': '删除文件夹',
  'pages.assetLibrary.folders.deleteConfirm': '确定要删除该文件夹吗？',
  'pages.assetLibrary.folders.deleteSuccess': '文件夹删除成功',
  'pages.assetLibrary.folders.edit': '编辑文件夹',
  'pages.assetLibrary.folders.editSuccess': '文件夹更新成功',
  'pages.assetLibrary.list.subTitle':
    'Construction assets such as images and icons, with underlying file management integration',
  'pages.assetLibrary.list.title': 'Asset Library',
  'pages.assetLibrary.rootFolder': 'All Assets',
  'pages.assetLibrary.type.icon': 'Icon',
  'pages.assetLibrary.type.illustration': 'Illustration',
  'pages.assetLibrary.type.image': 'Image',
  'pages.auditLog.columns.action': 'Action',
  'pages.auditLog.columns.action.create': 'Create',
  'pages.auditLog.columns.action.delete': 'Delete',
  'pages.auditLog.columns.action.export': 'Export',
  'pages.auditLog.columns.action.import': 'Import',
  'pages.auditLog.columns.action.login': 'Login',
  'pages.auditLog.columns.action.logout': 'Logout',
  'pages.auditLog.columns.action.query': 'Query',
  'pages.auditLog.columns.action.update': 'Update',
  'pages.auditLog.columns.createdAt': 'Operation Time',
  'pages.auditLog.columns.description': 'Description',
  'pages.auditLog.columns.ip': 'IP Address',
  'pages.auditLog.columns.module': 'Module',
  'pages.auditLog.columns.modulePlaceholder': 'Enter module name',
  'pages.auditLog.columns.operation': 'Operation',
  'pages.auditLog.columns.operation.detail': 'Detail',
  'pages.auditLog.columns.resourceType': 'Resource Type',
  'pages.auditLog.columns.status': 'Status',
  'pages.auditLog.columns.status.failed': 'Failed',
  'pages.auditLog.columns.status.success': 'Success',
  'pages.auditLog.columns.username': 'User',
  'pages.auditLog.detail.errorMessage': 'Error Message',
  'pages.auditLog.detail.id': 'Operation ID',
  'pages.auditLog.detail.method': 'Request Method',
  'pages.auditLog.detail.path': 'Request Path',
  'pages.auditLog.detail.requestData': 'Request Data',
  'pages.auditLog.detail.resourceId': 'Resource ID',
  'pages.auditLog.detail.responseData': 'Response Data',
  'pages.auditLog.detail.title': 'Log Detail',
  'pages.auditLog.list.title': 'Operation Log List',
  'pages.auditLog.subtitle':
    'Record and trace key project operations, with filtering and audit data export.',
  'pages.auditLog.values.module.codebaseManagement': 'Codebase Management',
  'pages.auditLog.values.module.projectManagement': 'Project Management',
  'pages.auditLog.values.module.applicationManagement':
    'Application Management',
  'pages.auditLog.values.module.projectCommunication': 'Project Communication',
  'pages.auditLog.values.module.projectAnnouncement': 'Project Announcement',
  'pages.auditLog.values.module.gitlabSync': 'GitLab Sync',
  'pages.auditLog.values.module.gitlabMembers': 'GitLab Members',
  'pages.auditLog.values.module.gitlabInit': 'GitLab Init',
  'pages.auditLog.values.module.gitlabMigration': 'GitLab Migration',
  'pages.auditLog.values.resource.codebase': 'Codebase',
  'pages.auditLog.values.resource.project': 'Project',
  'pages.auditLog.values.resource.application': 'Application',
  'pages.auditLog.values.description.createCodebase': 'Create Codebase',
  'pages.auditLog.values.description.updateCodebase': 'Update Codebase',
  'pages.auditLog.values.description.deleteCodebase': 'Delete Codebase',
  'pages.auditLog.values.description.createProject': 'Create Project',
  'pages.auditLog.values.description.updateProject': 'Update Project',
  'pages.auditLog.values.description.deleteProject': 'Delete Project',
  'pages.auditLog.values.description.createApplication': 'Create Application',
  'pages.auditLog.values.description.updateApplication': 'Update Application',
  'pages.auditLog.values.description.deleteApplication': 'Delete Application',
  'pages.callback.processing': 'Processing login...',
  'pages.common.actionFailed': 'Action failed',
  'pages.common.createSuccess': 'Create successful',
  'pages.common.deleteConfirm':
    'This action will permanently delete this item. Continue?',
  'pages.common.deleteSuccess': 'Delete successful',
  'pages.common.updateSuccess': 'Update successful',
  'pages.communication.columns.action': 'Action',
  'pages.communication.columns.content': 'Content',
  'pages.communication.columns.date': 'Date',
  'pages.communication.columns.leader': 'Leader',
  'pages.communication.columns.location': 'Location/Link',
  'pages.communication.columns.method': 'Method',
  'pages.communication.columns.participants': 'Participants',
  'pages.communication.columns.status': 'Status',
  'pages.communication.columns.title': 'Topic',
  'pages.communication.create': 'New',
  'pages.communication.delete': 'Delete',
  'pages.communication.edit': 'Edit',
  'pages.communication.error.create': 'Add failed, please try again!',
  'pages.communication.error.delete': 'Delete failed, please try again',
  'pages.communication.error.update': 'Configuration failed, please try again!',
  'pages.communication.list': 'Query Table',
  'pages.communication.loading.create': 'Adding...',
  'pages.communication.loading.delete': 'Deleting...',
  'pages.communication.loading.update': 'Configuring...',
  'pages.communication.placeholder.content': 'Please enter content',
  'pages.communication.placeholder.richContent':
    'Please enter communication content',
  'pages.communication.placeholder.title': 'Please enter topic',
  'pages.communication.required': 'This field is required',
  'pages.communication.subTitle': 'Manage Project Communication Records',
  'pages.communication.success.create': 'Added successfully',
  'pages.communication.success.delete': 'Deleted successfully, refreshing...',
  'pages.communication.success.update': 'Configured successfully',
  'pages.communication.title': 'Communication Records',
  'pages.defectManagement.columns.id': 'Defect ID',
  'pages.defectManagement.columns.owner': 'Owner Team',
  'pages.defectManagement.columns.severity': 'Severity',
  'pages.defectManagement.columns.status': 'Status',
  'pages.defectManagement.columns.title': 'Defect Description',
  'pages.defectManagement.columns.updatedAt': 'Updated At',
  'pages.defectManagement.mock.backendTeam': 'Backend Team',
  'pages.defectManagement.mock.bug087.title':
    'Delayed unread count refresh in notification center',
  'pages.defectManagement.mock.bug099.title':
    'Misaligned style in requirement document export',
  'pages.defectManagement.mock.bug101.title':
    'Intermittent duplicate creation after order submission',
  'pages.defectManagement.mock.frontendTeam': 'Frontend Team',
  'pages.defectManagement.mock.platformTeam': 'Platform Team',
  'pages.defectManagement.severity.critical': 'Critical',
  'pages.defectManagement.severity.major': 'Major',
  'pages.defectManagement.severity.minor': 'Minor',
  'pages.defectManagement.status.closed': 'Closed',
  'pages.defectManagement.status.fixed': 'To Verify',
  'pages.defectManagement.status.open': 'To Fix',
  'pages.defectManagement.subTitle':
    'Track defect submission, assignment, fix verification, and closure',
  'pages.defectManagement.title': 'Defect Management',
  'pages.defectManagement.status.new': 'New',
  'pages.defectManagement.status.assigned': 'Assigned',
  'pages.defectManagement.status.inProgress': 'In Progress',
  'pages.defectManagement.status.resolved': 'To Verify',
  'pages.defectManagement.status.reopened': 'Reopened',
  'pages.defectManagement.columns.priority': 'Priority',
  'pages.defectManagement.columns.assignee': 'Assignee',
  'pages.defectManagement.columns.action': 'Action',
  'pages.defectManagement.columns.createdAt': 'Created At',
  'pages.defectManagement.action.create': 'Create Defect',
  'pages.defectManagement.action.edit': 'Edit',
  'pages.defectManagement.action.view': 'Detail',
  'pages.defectManagement.action.transition': 'Transition',
  'pages.defectManagement.action.comment': 'Add Comment',
  'pages.defectManagement.detail.comments': 'Comments',
  'pages.defectManagement.detail.operations': 'Operation History',
  'pages.defectManagement.redirectTip':
    'Opened from Test Management and redirected to the unified defect workspace',
  'pages.forgotPassword.backToLogin': 'Back to Sign In',
  'pages.forgotPassword.code.placeholder': 'Please enter verification code',
  'pages.forgotPassword.code.required': 'Please enter verification code.',
  'pages.forgotPassword.codeSendFailed': 'Failed to send verification code.',
  'pages.forgotPassword.codeSent': 'Verification code sent.',
  'pages.forgotPassword.confirmPassword.placeholder':
    'Please confirm new password',
  'pages.forgotPassword.confirmPassword.required':
    'Please confirm new password.',
  'pages.forgotPassword.errorMessage': 'Password reset failed',
  'pages.forgotPassword.failure': 'Password reset failed, please try again.',
  'pages.forgotPassword.getCode': 'Get verification code',
  'pages.forgotPassword.newPassword.minLength':
    'Password must be at least 6 characters.',
  'pages.forgotPassword.newPassword.placeholder': 'Please enter new password',
  'pages.forgotPassword.newPassword.required': 'Please enter new password.',
  'pages.forgotPassword.passwordMismatch': 'The two passwords do not match.',
  'pages.forgotPassword.phone.invalid': 'Invalid phone number format.',
  'pages.forgotPassword.phone.placeholder': 'Please enter your phone number',
  'pages.forgotPassword.phone.required': 'Please enter your phone number.',
  'pages.forgotPassword.success':
    'Password reset successfully, please sign in again.',
  'pages.forgotPassword.successMessage':
    'Password reset successfully, redirecting to sign-in page.',
  'pages.forgotPassword.title': 'Forgot Password',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.knowledgeBase.category.manual': 'Operation Manual',
  'pages.knowledgeBase.category.specification': 'Specification',
  'pages.knowledgeBase.category.template': 'Template',
  'pages.knowledgeBase.columns.category': 'Category',
  'pages.knowledgeBase.columns.option': 'Option',
  'pages.knowledgeBase.columns.owner': 'Owner',
  'pages.knowledgeBase.columns.title': 'Document Title',
  'pages.knowledgeBase.columns.updatedAt': 'Updated At',
  'pages.knowledgeBase.columns.version': 'Version',
  'pages.knowledgeBase.option.edit': 'Edit',
  'pages.knowledgeBase.option.view': 'View',
  'pages.knowledgeBase.subTitle':
    'Enterprise Knowledge Management System (File Management)',
  'pages.knowledgeBase.title': 'Knowledge Base',
  'pages.knowledgeBase.toolBar.create': 'Create Knowledge',
  'pages.knowledgeBase.toolBar.upload': 'Upload Document',
  'pages.layouts.userLayout.title': 'Hi~',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.loginWith': 'Login with :',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.redirecting': 'Redirecting to the login page...',
  'pages.login.redirectingHint':
    'If it does not redirect for a while, please check browser console.',
  'pages.login.registerAccount': 'Register Account',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.submit': 'Login',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please input your username!',
  'pages.prototypeDesign.columns.designer': 'Designer',
  'pages.prototypeDesign.columns.option': 'Operation',
  'pages.prototypeDesign.columns.pageName': 'Page Name',
  'pages.prototypeDesign.columns.reviewedAt': 'Review Time',
  'pages.prototypeDesign.columns.status': 'Status',
  'pages.prototypeDesign.columns.version': 'Version',
  'pages.prototypeDesign.mock.projectDetail': 'Project Detail Page',
  'pages.prototypeDesign.mock.projectList': 'Project List Page',
  'pages.prototypeDesign.mock.requirementDoc': 'Requirement Document Page',
  'pages.prototypeDesign.option.history': 'History',
  'pages.prototypeDesign.option.view': 'View',
  'pages.prototypeDesign.status.approved': 'Approved',
  'pages.prototypeDesign.status.draft': 'Draft',
  'pages.prototypeDesign.status.reviewing': 'Reviewing',
  'pages.prototypeDesign.subTitle':
    'Manage prototype versions, reviews and change records',
  'pages.prototypeDesign.title': 'Prototype Design',
  'pages.prototypeDesign.toolBar.create': 'New Prototype',
  'pages.prototypeDesign.toolBar.sync': 'Sync Design Platform',
  'pages.qualityManagement.columns.indicator': 'Indicator',
  'pages.qualityManagement.columns.score': 'Score',
  'pages.qualityManagement.columns.team': 'Responsible Team',
  'pages.qualityManagement.columns.trend': 'Trend',
  'pages.qualityManagement.columns.updatedAt': 'Updated At',
  'pages.qualityManagement.indicator.codeCompliance': 'Code Compliance Rate',
  'pages.qualityManagement.indicator.defectEscape': 'Defect Escape Rate',
  'pages.qualityManagement.indicator.testCoverage': 'Automation Test Coverage',
  'pages.qualityManagement.stats.closedIssues': 'Closed Issues',
  'pages.qualityManagement.stats.newIssues': 'New Issues This Week',
  'pages.qualityManagement.stats.overallScore': 'Overall Quality Score',
  'pages.qualityManagement.subTitle':
    'Quality Metrics, Check Results, and Continuous Improvement',
  'pages.qualityManagement.title': 'Quality Management',
  'pages.qualityManagement.trend.down': 'Down',
  'pages.qualityManagement.trend.flat': 'Flat',
  'pages.qualityManagement.trend.up': 'Up',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.config': 'Configuration',
  'pages.workbench.link': 'workbench',
  'pages.workbench.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.item': 'item',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.new': 'New',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.template.action.reset': 'Reset',
  'pages.template.action.submit': 'Submit',
  'pages.template.department.finance': 'Finance',
  'pages.template.department.hr': 'Human Resources',
  'pages.template.department.sales': 'Sales',
  'pages.template.department.tech': 'Technology',
  'pages.template.form.department': 'Department',
  'pages.template.form.email': 'Email',
  'pages.template.form.joinDate': 'Join Date',
  'pages.template.form.name': 'Name',
  'pages.template.form.remarks': 'Remarks',
  'pages.template.placeholder.department': 'Please select a department',
  'pages.template.placeholder.email': 'Please enter email',
  'pages.template.placeholder.name': 'Please enter name',
  'pages.template.placeholder.remarks': 'Please enter remarks',
  'pages.template.submit.success': 'Form submitted successfully!',
  'pages.template.title': 'Template',
  'pages.template.validation.departmentRequired': 'Please select a department',
  'pages.template.validation.emailInvalid': 'Invalid email format',
  'pages.template.validation.emailRequired': 'Please enter email',
  'pages.template.validation.joinDateRequired': 'Please select a join date',
  'pages.template.validation.nameRequired': 'Please enter name',
  'pages.testManagement.columns.caseName': 'Test Case',
  'pages.testManagement.columns.executor': 'Executor',
  'pages.testManagement.columns.lastRunAt': 'Last Run',
  'pages.testManagement.columns.level': 'Level',
  'pages.testManagement.columns.option': 'Option',
  'pages.testManagement.columns.status': 'Result',
  'pages.testManagement.option.defect': 'Related Defects',
  'pages.testManagement.option.report': 'Test Report',
  'pages.testManagement.status.blocked': 'Blocked',
  'pages.testManagement.status.failed': 'Failed',
  'pages.testManagement.status.passed': 'Passed',
  'pages.testManagement.subTitle':
    'Manage test plans, test case execution and defect association',
  'pages.testManagement.title': 'Test Management',
  'pages.testManagement.toolBar.createPlan': 'New Test Plan',
  'auto.pages.pages.System.Menu.1': '工作台',
  'auto.pages.pages.System.Menu.2': '系统管理',
  'auto.pages.pages.System.Role.1': '管理员',
  'auto.pages.pages.System.Role.2': '系统管理员',
  'auto.pages.pages.System.Role.3': '普通用户',
  'auto.pages.pages.System.Role.4': '普通用户',
  'auto.pages.pages.System.User.1': '管理员',
  'auto.pages.pages.System.User.2': '管理员',
  'auto.pages.pages.System.User.3': '启用',
  'auto.pages.pages.System.User.4': '用户1',
  'auto.pages.pages.System.User.5': '普通用户',
  'auto.pages.pages.System.User.6': '启用',
  'auto.pages.pages.System.User.7': '管理员',
  'auto.pages.pages.System.User.8': '普通用户',
  'auto.pages.pages.System.User.9': '管理员',
  'auto.pages.pages.System.User.10': '普通用户',
  'auto.pages.pages.System.User.11': '启用',
  'auto.pages.pages.System.User.12': '禁用',
  'auto.pages.pages.System.User.13': '启用',
  'auto.pages.pages.System.User.14': '禁用',
  'auto.pages.pages.System.User.15': '启用',
  'auto.pages.pages.System.User.16': '管理员',
  'auto.pages.pages.System.User.17': '普通用户',
  'auto.pages.pages.System.User.18': '启用',
  'auto.pages.pages.System.User.19': '禁用',
  'auto.pages.pages.api-management.quick-debug.index.1': '接口快速调试',
  'auto.pages.pages.api-management.quick-debug.index.2':
    '快速验证接口请求与响应',
  'auto.pages.pages.api-management.quick-debug.index.3':
    '可在此配置请求参数、Header 与鉴权信息，快速调试接口。',
  'auto.pages.pages.api-management.quick-debug.index.4': '调试面板',
  'auto.pages.pages.api-management.quick-debug.index.5':
    '后续可接入接口选择、请求体编辑、响应结果查看与历史记录。',
  'auto.pages.pages.api-management.quick-debug.index.6':
    '接口快速调试功能建设中',
  'auto.component.pages.application.components.CreateAppModal.1': '创建应用',
  'auto.component.pages.application.components.CreateAppModal.2': '确定',
  'auto.component.pages.application.components.CreateAppModal.3': '取消',
  'auto.component.pages.application.components.CreateAppModal.4': '应用类型',
  'auto.component.pages.application.components.CreateAppModal.5': '应用名称',
  'auto.component.pages.application.components.CreateAppModal.6':
    '请输入应用名称',
  'auto.component.pages.application.components.CreateAppModal.7':
    '例如：我的应用',
  'auto.component.pages.application.components.CreateAppModal.8': '应用标识符',
  'auto.component.pages.application.components.CreateAppModal.9':
    '请输入应用标识符',
  'auto.component.pages.application.components.CreateAppModal.10':
    '例如：MyApp',
  'auto.component.pages.application.components.CreateAppModal.11':
    '组件框架（可选）',
  'auto.component.pages.application.components.CreateAppModal.12':
    '选择组件框架',
  'auto.component.pages.application.components.CreateAppModal.13':
    '应用描述（可选）',
  'auto.component.pages.application.components.CreateAppModal.14':
    '请输入应用描述',
  'auto.component.pages.application.components.CreateAppModal.15': '选择模板',
  'auto.component.pages.application.components.CreateAppModal.16':
    '暂无可用模板',
  'auto.component.pages.application.components.CreateAppModal.17':
    '请从左侧选择应用类型',
  'auto.pages.pages.application.constants.1': 'React Web应用',
  'auto.pages.pages.application.constants.2': '使用React框架开发的Web应用程序',
  'auto.pages.pages.application.constants.3': 'React管理后台模板',
  'auto.pages.pages.application.constants.4': '基于Ant Design的管理后台模板',
  'auto.pages.pages.application.constants.5': 'React电商模板',
  'auto.pages.pages.application.constants.6': '电商网站模板',
  'auto.pages.pages.application.constants.7': 'Vue3 Web应用',
  'auto.pages.pages.application.constants.8': '使用Vue3框架开发的Web应用程序',
  'auto.pages.pages.application.constants.9': 'Vue3管理后台模板',
  'auto.pages.pages.application.constants.10': '基于ElementPlus的管理后台模板',
  'auto.pages.pages.application.constants.11': 'Vue2 Web应用',
  'auto.pages.pages.application.constants.12': '使用Vue2框架开发的Web应用程序',
  'auto.pages.pages.application.constants.13': 'Next.js应用',
  'auto.pages.pages.application.constants.14':
    '使用Next.js框架开发的React应用程序',
  'auto.pages.pages.application.constants.15': '若依管理后台应用（Vu3）',
  'auto.pages.pages.application.constants.16':
    '基于 Vue3 + element-plus 实现的管理后台',
  'auto.pages.pages.application.constants.17': '前端 微应用',
  'auto.pages.pages.application.constants.18': '用于珊瑚云平台的前端微应用',
  'auto.pages.pages.application.constants.19': '后端 微应用',
  'auto.pages.pages.application.constants.20': '用于珊瑚云平台的后端微应用',
  'auto.pages.pages.application.constants.21': '微信小程序',
  'auto.pages.pages.application.constants.22': '微信平台上的轻量级应用',
  'auto.pages.pages.application.constants.23': '支付宝小程序',
  'auto.pages.pages.application.constants.24': '支付宝平台上的轻量级应用',
  'auto.pages.pages.application.constants.25': '百度小程序',
  'auto.pages.pages.application.constants.26': '百度平台上的轻量级应用',
  'auto.pages.pages.application.constants.27': 'Uniapp应用',
  'auto.pages.pages.application.constants.28':
    '使用Vue.js开发所有前端应用的框架',
  'auto.pages.pages.application.constants.29': 'Taro应用',
  'auto.pages.pages.application.constants.30': '开放式跨端跨框架解决方案',
  'auto.pages.pages.application.constants.31': 'iOS应用',
  'auto.pages.pages.application.constants.32': 'iOS原生应用开发',
  'auto.pages.pages.application.constants.33': 'Android应用',
  'auto.pages.pages.application.constants.34': 'Android原生应用开发',
  'auto.pages.pages.application.constants.35': 'Java应用',
  'auto.pages.pages.application.constants.36': 'Java后端应用开发',
  'auto.pages.pages.application.constants.37': 'Node.js应用',
  'auto.pages.pages.application.constants.38': 'Node.js后端应用开发',
  'auto.pages.pages.application.constants.39': 'Python应用',
  'auto.pages.pages.application.constants.40': 'Python后端应用开发',
  'auto.pages.pages.application.constants.41': 'C/C++应用',
  'auto.pages.pages.application.constants.42': 'C/C++应用开发',
  'auto.pages.pages.application.constants.43': '若依管理后台应用',
  'auto.pages.pages.application.constants.44': '基于 Spring Boot 多模块架构',
  'auto.pages.pages.application.constants.45': 'Electron应用',
  'auto.pages.pages.application.constants.46': '使用Electron开发的桌面应用程序',
  'auto.pages.pages.application.constants.47': '桌面应用',
  'auto.pages.pages.application.constants.48': '原生桌面应用程序',
  'auto.pages.pages.application.constants.49': 'RESTful API服务',
  'auto.pages.pages.application.constants.50': 'GraphQL API服务',
  'auto.pages.pages.application.constants.51': '微服务',
  'auto.pages.pages.application.constants.52': '微服务架构应用',
  'auto.pages.pages.application.constants.53': '前端',
  'auto.pages.pages.application.constants.54': '小程序',
  'auto.pages.pages.application.constants.55': '移动端',
  'auto.pages.pages.application.constants.56': '后端',
  'auto.pages.pages.application.constants.57': '桌面应用',
  'auto.pages.pages.application.constants.58': 'API服务',
  'auto.pages.pages.application.constants.59': '珊瑚礁',
  'auto.pages.pages.application.constants.60': '微服务',
  'auto.pages.pages.application.constants.61': '移动端微应用',
  'auto.pages.pages.application.constants.62': '用于珊瑚云平台的移动端微应用',
  'auto.pages.pages.application.constants.63': 'Mobile Template',
  'auto.pages.pages.application.constants.64':
    'Mobile navigation app template based on React Native',
  'auto.pages.pages.application.constants.65': 'Frontend NPM Package',
  'auto.pages.pages.application.constants.66':
    'Storybook application for developing frontend components and publishing NPM packages',
  'auto.pages.pages.application.constants.67': 'Plugin App',
  'auto.pages.pages.application.constants.68':
    'Application for Coral Reef platform plugin extensions',
  'auto.pages.pages.application.index.1': '加载应用列表失败',
  'auto.pages.pages.application.index.2': '暂无应用描述',
  'auto.pages.pages.application.index.3': '更新:',
  'auto.pages.pages.application.index.4': '开发应用',
  'auto.pages.pages.application.index.5': '预览应用',
  'auto.pages.pages.application.index.6': '编辑应用',
  'auto.pages.pages.application.index.7': '确定',
  'auto.pages.pages.application.index.8': '取消',
  'auto.pages.pages.application.index.9': '删除应用',
  'auto.pages.pages.application.index.10': '搜索应用名称/标识符',
  'auto.pages.pages.application.index.11': '共 {p1} 个应用',
  'auto.pages.pages.application.index.12': '暂无应用数据',
  'auto.pages.pages.architecture.api-management.index.1': '项目管理',
  'auto.pages.pages.architecture.api-management.index.2': '查询项目列表',
  'auto.pages.pages.architecture.api-management.index.3': '需求管理',
  'auto.pages.pages.architecture.api-management.index.4': '创建需求项',
  'auto.pages.pages.architecture.api-management.index.5': '公告管理',
  'auto.pages.pages.architecture.api-management.index.6': '发布项目公告',
  'auto.pages.pages.architecture.api-management.index.7': '模块',
  'auto.pages.pages.architecture.api-management.index.8': '接口名称',
  'auto.pages.pages.architecture.api-management.index.9': '状态',
  'auto.pages.pages.architecture.api-management.index.10': '设计中',
  'auto.pages.pages.architecture.api-management.index.11': '开发中',
  'auto.pages.pages.architecture.api-management.index.12': '已发布',
  'auto.pages.pages.architecture.api-management.index.13': '接口管理',
  'auto.pages.pages.architecture.api-management.index.14':
    '接口定义、状态跟踪与版本协同',
  'auto.pages.pages.architecture.code-management.index.1': '前端组',
  'auto.pages.pages.architecture.code-management.index.2': '后端组',
  'auto.pages.pages.architecture.code-management.index.3': '平台组',
  'auto.pages.pages.architecture.code-management.index.4': '代码仓库',
  'auto.pages.pages.architecture.code-management.index.5': '主分支',
  'auto.pages.pages.architecture.code-management.index.6': '责任团队',
  'auto.pages.pages.architecture.code-management.index.7': '最近更新',
  'auto.pages.pages.architecture.code-management.index.8': '代码管理',
  'auto.pages.pages.architecture.code-management.index.9':
    '代码仓库、分支策略与模块归属管理',
  'auto.pages.pages.architecture.detail.index.1': '获取项目列表',
  'auto.pages.pages.architecture.detail.index.2': '保存需求概要',
  'auto.pages.pages.architecture.detail.index.3': '同步沟通记录',
  'auto.pages.pages.architecture.detail.index.4': '接口',
  'auto.pages.pages.architecture.detail.index.5': '服务',
  'auto.pages.pages.architecture.detail.index.6': '详细设计',
  'auto.pages.pages.architecture.detail.index.7':
    '接口、数据结构与关键流程的可实施说明',
  'auto.pages.pages.architecture.detail.index.8': '核心设计参数',
  'auto.pages.pages.architecture.detail.index.9': '事件最终一致性',
  'auto.pages.pages.architecture.detail.index.10': 'Redis 10 分钟缓存',
  'auto.pages.pages.architecture.detail.index.11': '全链路操作审计',
  'auto.pages.pages.architecture.detail.index.12': '鉴权方案',
  'auto.pages.pages.architecture.detail.index.13': '一致性策略',
  'auto.pages.pages.architecture.detail.index.14': '缓存策略',
  'auto.pages.pages.architecture.detail.index.15': '审计方案',
  'auto.pages.pages.architecture.detail.index.16': '接口清单',
  'auto.pages.pages.architecture.overview.index.1': '概要设计',
  'auto.pages.pages.architecture.overview.index.2':
    '系统边界、核心模块与关键技术选型',
  'auto.pages.pages.architecture.overview.index.3':
    '本页为架构总览，重点聚焦模块边界和交互关系。',
  'auto.pages.pages.architecture.overview.index.4': '系统概要',
  'auto.pages.pages.architecture.overview.index.5':
    '项目管理平台 + 记录易 + 知识管理系统',
  'auto.pages.pages.architecture.overview.index.6':
    '外部平台限流与权限同步延迟',
  'auto.pages.pages.architecture.overview.index.7': '系统边界',
  'auto.pages.pages.architecture.overview.index.8': '技术栈',
  'auto.pages.pages.architecture.overview.index.9': '可用性目标',
  'auto.pages.pages.architecture.overview.index.10': '部署方式',
  'auto.pages.pages.architecture.overview.index.11': '集成方式',
  'auto.pages.pages.architecture.overview.index.12': '主要风险',
  'auto.pages.pages.architecture.overview.index.13': '模块划分',
  'auto.pages.pages.architecture.overview.index.14':
    '1. 项目域：项目列表、项目详情、项目统计。 2.\n          需求域：需求概要、功能清单、需求文档。 3.\n          交付域：原型、架构、测试、质量。 4. 资产域：知识库、素材库、文件管理。',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.1':
    '默认字幕',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.2':
    '此文件格式暂不支持直接预览。',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.3':
    '下载文件',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.4':
    '预览',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.5':
    '关闭',
  'auto.component.pages.asset-library.components.PreviewMaterialModal.6':
    '下载',
  'auto.component.pages.asset-library.components.UploadMaterialModal.1':
    '请选择文件',
  'auto.component.pages.asset-library.components.UploadMaterialModal.2':
    '上传成功',
  'auto.component.pages.asset-library.components.UploadMaterialModal.3':
    '上传失败',
  'auto.component.pages.asset-library.components.UploadMaterialModal.4':
    '上传完成，但有 {p1} 个文件失败',
  'auto.component.pages.asset-library.components.UploadMaterialModal.5':
    '上传失败',
  'auto.component.pages.asset-library.components.UploadMaterialModal.6':
    '上传素材',
  'auto.component.pages.asset-library.components.UploadMaterialModal.7': '取消',
  'auto.component.pages.asset-library.components.UploadMaterialModal.8':
    '上传中',
  'auto.component.pages.asset-library.components.UploadMaterialModal.9':
    '开始上传',
  'auto.component.pages.asset-library.components.UploadMaterialModal.10':
    '上传目录',
  'auto.component.pages.asset-library.components.UploadMaterialModal.11':
    '选择上传目录',
  'auto.component.pages.asset-library.components.UploadMaterialModal.12':
    '存储配置',
  'auto.component.pages.asset-library.components.UploadMaterialModal.13':
    '请选择存储配置',
  'auto.component.pages.asset-library.components.UploadMaterialModal.14':
    '选择存储配置',
  'auto.component.pages.asset-library.components.UploadMaterialModal.15':
    '选择文件',
  'auto.component.pages.asset-library.components.UploadMaterialModal.16':
    '点击或拖拽文件到此区域上传',
  'auto.component.pages.asset-library.components.UploadMaterialModal.17':
    '支持批量上传',
  'auto.pages.pages.asset-library.index.1': '文件夹删除成功',
  'auto.pages.pages.asset-library.index.2': '删除失败',
  'auto.pages.pages.asset-library.index.3': '存储配置创建成功',
  'auto.pages.pages.asset-library.index.4': '创建存储配置失败',
  'auto.pages.pages.asset-library.index.5': '新增子集文件夹',
  'auto.pages.pages.asset-library.index.6': '编辑文件夹',
  'auto.pages.pages.asset-library.index.7': '确定要删除该文件夹吗？',
  'auto.pages.pages.asset-library.index.8': '删除文件夹',
  'auto.pages.pages.asset-library.index.9': '文件夹更新及排序成功',
  'auto.pages.pages.asset-library.index.10': '文件夹操作失败',
  'auto.pages.pages.asset-library.index.11': '文件夹更新成功',
  'auto.pages.pages.asset-library.index.12': '文件夹创建成功',
  'auto.pages.pages.asset-library.index.13': '操作失败',
  'auto.pages.pages.asset-library.index.14': '视频',
  'auto.pages.pages.asset-library.index.15': '文档',
  'auto.pages.pages.asset-library.index.16': '其他',
  'auto.pages.pages.asset-library.index.17': '预览',
  'auto.pages.pages.asset-library.index.18': '确认删除？',
  'auto.pages.pages.asset-library.index.19': '删除成功',
  'auto.pages.pages.asset-library.index.20': '删除',
  'auto.pages.pages.asset-library.index.21': '文件夹',
  'auto.pages.pages.asset-library.index.22': '取消选择',
  'auto.pages.pages.asset-library.index.23': '确认删除选中的 {p1} 个素材吗？',
  'auto.pages.pages.asset-library.index.24': '批量删除成功',
  'auto.pages.pages.asset-library.index.25': '批量删除失败',
  'auto.pages.pages.asset-library.index.26': '批量删除',
  'auto.pages.pages.asset-library.index.27': '编辑文件夹',
  'auto.pages.pages.asset-library.index.28': '新建文件夹',
  'auto.pages.pages.asset-library.index.29': '文件夹名称',
  'auto.pages.pages.asset-library.index.30': '请输入文件夹名称',
  'auto.pages.pages.asset-library.index.31': '请输入名称',
  'auto.pages.pages.asset-library.index.32': '上级文件夹',
  'auto.pages.pages.asset-library.index.33':
    '请选择上级文件夹（不选则为根目录）',
  'auto.pages.pages.asset-library.index.34': '排序',
  'auto.pages.pages.asset-library.index.35': '创建存储配置',
  'auto.pages.pages.asset-library.index.36': '配置名称',
  'auto.pages.pages.asset-library.index.37': '请输入配置名称',
  'auto.pages.pages.asset-library.index.38': '请输入配置名称',
  'auto.pages.pages.asset-library.index.39': '存储类型',
  'auto.pages.pages.asset-library.index.40': '请选择存储类型',
  'auto.pages.pages.asset-library.index.41': '请选择存储类型',
  'auto.pages.pages.asset-library.index.42': '端点地址',
  'auto.pages.pages.asset-library.index.43': '请输入端点地址',
  'auto.pages.pages.asset-library.index.44': '请输入端点地址',
  'auto.pages.pages.asset-library.index.45': '存储桶',
  'auto.pages.pages.asset-library.index.46': '请输入存储桶名称',
  'auto.pages.pages.asset-library.index.47': '请输入存储桶名称',
  'auto.pages.pages.asset-library.index.48': '区域',
  'auto.pages.pages.asset-library.index.49': '请输入区域（可选）',
  'auto.pages.pages.asset-library.index.50': '请输入 Access Key',
  'auto.pages.pages.asset-library.index.51': '请输入 Access Key',
  'auto.pages.pages.asset-library.index.52': '请输入 Secret Key',
  'auto.pages.pages.asset-library.index.53': '请输入 Secret Key',
  'auto.pages.pages.asset-library.index.54': '基础路径',
  'auto.pages.pages.asset-library.index.55': '请输入基础路径（可选）',
  'auto.pages.pages.asset-library.index.56': 'CDN 域名',
  'auto.pages.pages.asset-library.index.57': '请输入 CDN 域名（可选）',
  'auto.pages.pages.asset-library.index.58': '存储配额',
  'auto.pages.pages.asset-library.index.59': '请输入存储配额',
  'auto.pages.pages.asset-library.index.60': '单位',
  'auto.pages.pages.asset-library.index.61': '请选择单位',
  'auto.pages.pages.asset-library.index.62': '请选择单位',
  'auto.pages.pages.asset-library.index.63': '设为默认',
  'auto.pages.pages.asset-library.index.64': '管理员权限',
  'auto.pages.pages.asset-library.index.65': '只有管理员才能修改此配置',
  'auto.pages.pages.audit-log.index.1': '没有可导出的数据',
  'auto.pages.pages.audit-log.index.2': '导出成功',
  'auto.pages.pages.audit-log.index.3': '导出失败',
  'auto.pages.pages.audit-log.index.4': '导出为 XLSX',
  'auto.pages.pages.audit-log.index.5': '导出为 CSV',
  'auto.pages.pages.audit-log.index.6': '导出',
  'auto.pages.pages.code-management.dependency-analysis.index.1':
    '保持当前版本，定期关注安全公告',
  'auto.pages.pages.code-management.dependency-analysis.index.2':
    '建议升级至 4.17.21 以上以修复已知漏洞',
  'auto.pages.pages.code-management.dependency-analysis.index.3':
    '与团队规范版本统一，减少规则漂移',
  'auto.pages.pages.code-management.dependency-analysis.index.4': '依赖包',
  'auto.pages.pages.code-management.dependency-analysis.index.5': '版本',
  'auto.pages.pages.code-management.dependency-analysis.index.6': '类型',
  'auto.pages.pages.code-management.dependency-analysis.index.7': '生产依赖',
  'auto.pages.pages.code-management.dependency-analysis.index.8': '开发依赖',
  'auto.pages.pages.code-management.dependency-analysis.index.9': '风险等级',
  'auto.pages.pages.code-management.dependency-analysis.index.10': '高',
  'auto.pages.pages.code-management.dependency-analysis.index.11': '中',
  'auto.pages.pages.code-management.dependency-analysis.index.12': '低',
  'auto.pages.pages.code-management.dependency-analysis.index.13': '处理建议',
  'auto.pages.pages.code-management.dependency-analysis.index.14': '依赖分析',
  'auto.pages.pages.code-management.dependency-analysis.index.15':
    '分析项目依赖关系、风险等级与升级建议',
  'auto.pages.pages.communication-records.index.1': '会议',
  'auto.pages.pages.communication-records.index.2': '电话',
  'auto.pages.pages.communication-records.index.3': '邮件',
  'auto.pages.pages.communication-records.index.4': '微信',
  'auto.pages.pages.communication-records.index.5': '其他',
  'auto.pages.pages.communication-records.index.6': '待处理',
  'auto.pages.pages.communication-records.index.7': '进行中',
  'auto.pages.pages.communication-records.index.8': '已交付',
  'auto.pages.pages.communication-records.index.9': '已归档',
  'auto.pages.pages.communication-records.index.10': '待处理',
  'auto.pages.pages.communication-records.index.11': '进行中',
  'auto.pages.pages.communication-records.index.12': '已交付',
  'auto.pages.pages.communication-records.index.13': '已归档',
  'auto.pages.pages.communication-records.index.14': '会议',
  'auto.pages.pages.communication-records.index.15': '电话',
  'auto.pages.pages.communication-records.index.16': '邮件',
  'auto.pages.pages.communication-records.index.17': '微信',
  'auto.pages.pages.communication-records.index.18': '其他',
  'auto.pages.pages.communication-records.index.19': '待处理',
  'auto.pages.pages.communication-records.index.20': '进行中',
  'auto.pages.pages.communication-records.index.21': '已交付',
  'auto.pages.pages.communication-records.index.22': '已归档',
  'auto.pages.pages.communication-records.index.23': '会议',
  'auto.pages.pages.communication-records.index.24': '电话',
  'auto.pages.pages.communication-records.index.25': '邮件',
  'auto.pages.pages.communication-records.index.26': '微信',
  'auto.pages.pages.communication-records.index.27': '其他',
  'auto.pages.pages.communication-records.index.28': '待处理',
  'auto.pages.pages.communication-records.index.29': '进行中',
  'auto.pages.pages.communication-records.index.30': '已交付',
  'auto.pages.pages.communication-records.index.31': '已归档',
  'auto.pages.pages.daily-report-management.index.1': '张三',
  'auto.pages.pages.daily-report-management.index.2':
    '完成登录模块 SSO 对接并联调通过',
  'auto.pages.pages.daily-report-management.index.3': '待确认单点退出策略',
  'auto.pages.pages.daily-report-management.index.4': '李四',
  'auto.pages.pages.daily-report-management.index.5':
    '完成需求文档结构优化并同步评审意见',
  'auto.pages.pages.daily-report-management.index.6': '第三方接口返回字段变化',
  'auto.pages.pages.daily-report-management.index.7': '王五',
  'auto.pages.pages.daily-report-management.index.8':
    '推进核心流程自动化测试脚本编写',
  'auto.pages.pages.daily-report-management.index.9':
    '测试环境数据库数据不稳定',
  'auto.pages.pages.daily-report-management.index.10': '日期',
  'auto.pages.pages.daily-report-management.index.11': '汇报人',
  'auto.pages.pages.daily-report-management.index.12': '今日进展',
  'auto.pages.pages.daily-report-management.index.13': '风险/阻塞',
  'auto.pages.pages.daily-report-management.index.14': '状态',
  'auto.pages.pages.daily-report-management.index.15': '草稿',
  'auto.pages.pages.daily-report-management.index.16': '已提交',
  'auto.pages.pages.daily-report-management.index.17': '已审阅',
  'auto.pages.pages.daily-report-management.index.18': '日报管理',
  'auto.pages.pages.daily-report-management.index.19':
    '团队日报沉淀、风险同步与进展追踪',
  'auto.pages.pages.data-modeling.entity-management.index.1': '未命名项目',
  'auto.pages.pages.data-modeling.entity-management.index.2':
    '加载实体管理失败',
  'auto.pages.pages.data-modeling.entity-management.index.3':
    '当前未识别到项目，请先切换项目',
  'auto.pages.pages.data-modeling.entity-management.index.4': '保存成功',
  'auto.pages.pages.data-modeling.entity-management.index.5': '保存失败',
  'auto.pages.pages.data-modeling.entity-management.index.6':
    '当前未识别到项目，请先切换项目',
  'auto.pages.pages.data-modeling.entity-management.index.7': '已清空实体',
  'auto.pages.pages.data-modeling.entity-management.index.8': '清空失败',
  'auto.pages.pages.data-modeling.entity-management.index.9':
    '实体定义JSON中缺少 name（实体名称），无法保存',
  'auto.pages.pages.data-modeling.entity-management.index.10': '未填写',
  'auto.pages.pages.data-modeling.entity-management.index.11': '实体名称',
  'auto.pages.pages.data-modeling.entity-management.index.12': '未填写',
  'auto.pages.pages.data-modeling.entity-management.index.13': '实体标识符',
  'auto.pages.pages.data-modeling.entity-management.index.14': '应用UUID',
  'auto.pages.pages.data-modeling.entity-management.index.15': '实体UUID',
  'auto.pages.pages.data-modeling.entity-management.index.16': '实体定义JSON',
  'auto.pages.pages.data-modeling.entity-management.index.17': '操作',
  'auto.pages.pages.data-modeling.entity-management.index.18': '编辑',
  'auto.pages.pages.data-modeling.entity-management.index.19': '删除',
  'auto.pages.pages.data-modeling.entity-management.index.20': '实体管理',
  'auto.pages.pages.data-modeling.entity-management.index.21':
    '管理项目“{p1}”的实体定义',
  'auto.pages.pages.data-modeling.entity-management.index.22': '新增实体',
  'auto.pages.pages.data-modeling.entity-management.index.23': '保存',
  'auto.pages.pages.data-modeling.entity-management.index.24':
    '确认清空当前项目实体数据？',
  'auto.pages.pages.data-modeling.entity-management.index.25': '清空重置',
  'auto.pages.pages.data-modeling.entity-management.index.26': '删除选中（',
  'auto.pages.pages.data-modeling.entity-management.index.27':
    '暂无实体，点击“新增实体”开始',
  'auto.pages.pages.data-modeling.entity-management.index.28': '编辑实体',
  'auto.pages.pages.data-modeling.entity-management.index.29': '新增实体',
  'auto.pages.pages.data-modeling.entity-management.index.30': '确定',
  'auto.pages.pages.data-modeling.entity-management.index.31': '取消',
  'auto.pages.pages.data-modeling.entity-management.index.32':
    '应用UUID（可选）',
  'auto.pages.pages.data-modeling.entity-management.index.33': '实体定义JSON',
  'auto.pages.pages.data-modeling.entity-management.index.34':
    '请输入实体定义JSON',
  'auto.pages.pages.data-modeling.entity-management.index.35':
    'JSON 格式不合法',
  'auto.pages.pages.data-modeling.entity-management.index.36':
    '粘贴实体定义 JSON',
  'auto.pages.pages.data-modeling.entity-management.index.37':
    '提示：实体UUID、名称、标识符会在保存时从 JSON 自动解析。',
  'auto.pages.pages.data-modeling.entity-management.index.38': '失效 {p1}',
  'auto.pages.pages.data-modeling.entity-management.index.39': '实体定义JSON',
  'auto.pages.pages.data-modeling.entity-management.index.40': '关系定义',
  'auto.pages.pages.data-modeling.entity-management.index.41': '选择目标实体',
  'auto.pages.pages.data-modeling.entity-management.index.42': '关系名称',
  'auto.pages.pages.data-modeling.entity-management.index.43':
    '关系说明（可选）',
  'auto.pages.pages.data-modeling.entity-management.index.44': '新增关系',
  'auto.pages.pages.data-modeling.entity-management.index.45': '关系数',
  'auto.pages.pages.data-modeling.index.1': '未命名项目',
  'auto.pages.pages.data-modeling.index.2': '加载数据建模失败',
  'auto.pages.pages.data-modeling.index.3':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.4': '项目信息已保存',
  'auto.pages.pages.data-modeling.index.5': '保存项目信息失败',
  'auto.pages.pages.data-modeling.index.6':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.7':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.data-modeling.index.8': 'AI 生成失败',
  'auto.pages.pages.data-modeling.index.9':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.10': '请先勾选预览实体',
  'auto.pages.pages.data-modeling.index.11': '已添加并保存 {p1} 个实体',
  'auto.pages.pages.data-modeling.index.12': '添加失败',
  'auto.pages.pages.data-modeling.index.13':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.14': '保存成功',
  'auto.pages.pages.data-modeling.index.15': '保存失败',
  'auto.pages.pages.data-modeling.index.16':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.index.17': '已清空数据建模实体',
  'auto.pages.pages.data-modeling.index.18': '清空失败',
  'auto.pages.pages.data-modeling.index.19':
    '实体定义JSON中缺少 name（实体名称），无法保存',
  'auto.pages.pages.data-modeling.index.20': '未填写',
  'auto.pages.pages.data-modeling.index.21': '实体名称',
  'auto.pages.pages.data-modeling.index.22': '未填写',
  'auto.pages.pages.data-modeling.index.23': '实体标识符',
  'auto.pages.pages.data-modeling.index.24': '应用UUID',
  'auto.pages.pages.data-modeling.index.25': '实体UUID',
  'auto.pages.pages.data-modeling.index.26': '实体定义JSON',
  'auto.pages.pages.data-modeling.index.27': '操作',
  'auto.pages.pages.data-modeling.index.28': '编辑',
  'auto.pages.pages.data-modeling.index.29': '删除',
  'auto.pages.pages.data-modeling.index.30': '实体名称',
  'auto.pages.pages.data-modeling.index.31': '未填写',
  'auto.pages.pages.data-modeling.index.32': '实体标识符',
  'auto.pages.pages.data-modeling.index.33': '应用UUID',
  'auto.pages.pages.data-modeling.index.34': '实体UUID',
  'auto.pages.pages.data-modeling.index.35': '实体管理',
  'auto.pages.pages.data-modeling.index.36': 'AI辅助建模',
  'auto.pages.pages.data-modeling.index.37': '管理项目“{p1}”下的实体定义(JSON)',
  'auto.pages.pages.data-modeling.index.38':
    '基于项目“{p1}”进行实体拆解与字段AI辅助建模',
  'auto.pages.pages.data-modeling.index.39': 'AIAI辅助建模',
  'auto.pages.pages.data-modeling.index.40': '新增实体',
  'auto.pages.pages.data-modeling.index.41': '保存',
  'auto.pages.pages.data-modeling.index.42': '确认清空当前项目实体数据？',
  'auto.pages.pages.data-modeling.index.43': '清空重置',
  'auto.pages.pages.data-modeling.index.44': '删除选中（',
  'auto.pages.pages.data-modeling.index.45':
    '暂无实体，点击“AIAI辅助建模”或“新增实体”开始',
  'auto.pages.pages.data-modeling.index.46': '暂无实体，点击“新增实体”开始',
  'auto.pages.pages.data-modeling.index.47': '编辑实体',
  'auto.pages.pages.data-modeling.index.48': '新增实体',
  'auto.pages.pages.data-modeling.index.49': '确定',
  'auto.pages.pages.data-modeling.index.50': '取消',
  'auto.pages.pages.data-modeling.index.51': '应用UUID（可选）',
  'auto.pages.pages.data-modeling.index.52': '实体定义JSON',
  'auto.pages.pages.data-modeling.index.53': '请输入实体定义JSON',
  'auto.pages.pages.data-modeling.index.54': 'JSON 格式不合法',
  'auto.pages.pages.data-modeling.index.55': '粘贴实体定义 JSON',
  'auto.pages.pages.data-modeling.index.56':
    '提示：实体UUID、名称、标识符会在保存时从 JSON 自动解析。',
  'auto.pages.pages.data-modeling.index.57': 'AI AI辅助建模',
  'auto.pages.pages.data-modeling.index.58': '生成选项',
  'auto.pages.pages.data-modeling.index.59': '项目名称',
  'auto.pages.pages.data-modeling.index.60': '请输入项目名称',
  'auto.pages.pages.data-modeling.index.61': '请输入项目名称',
  'auto.pages.pages.data-modeling.index.62': '项目简介',
  'auto.pages.pages.data-modeling.index.63': '请输入项目简介',
  'auto.pages.pages.data-modeling.index.64': '提示信息（用于辅助生成）',
  'auto.pages.pages.data-modeling.index.65':
    '例如：重点分析主数据、交易数据、审计日志等实体',
  'auto.pages.pages.data-modeling.index.66': '拆解实体数量',
  'auto.pages.pages.data-modeling.index.67': '请输入拆解数量',
  'auto.pages.pages.data-modeling.index.68': '数量范围为 1-40',
  'auto.pages.pages.data-modeling.index.69':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.data-modeling.index.70': '保存项目信息',
  'auto.pages.pages.data-modeling.index.71': '取消',
  'auto.pages.pages.data-modeling.index.72': '生成预览',
  'auto.pages.pages.data-modeling.index.73': '预览结果',
  'auto.pages.pages.data-modeling.index.74': '勾选需要的实体后添加到列表',
  'auto.pages.pages.data-modeling.index.75': '点击“生成预览”后查看候选实体',
  'auto.pages.pages.data-modeling.index.76': '重名时覆盖已有实体',
  'auto.pages.pages.data-modeling.index.77': '添加选中到实体列表（',
  'auto.pages.pages.data-modeling.index.78': '失效 {p1}',
  'auto.pages.pages.data-modeling.index.79': '实体定义JSON',
  'auto.pages.pages.data-modeling.index.80': '关系定义',
  'auto.pages.pages.data-modeling.index.81': '选择目标实体',
  'auto.pages.pages.data-modeling.index.82': '关系名称',
  'auto.pages.pages.data-modeling.index.83': '关系说明（可选）',
  'auto.pages.pages.data-modeling.index.84': '新增关系',
  'auto.pages.pages.data-modeling.index.85': '关系数',
  'auto.pages.pages.data-modeling.index.86': '实体总数',
  'auto.pages.pages.data-modeling.index.87': '关系总数',
  'auto.pages.pages.data-modeling.index.88': '字段总数',
  'auto.pages.pages.data-modeling.index.89': '失效关系数',
  'auto.pages.pages.data-modeling.index.90': '最近更新时间',
  'auto.pages.pages.data-modeling.index.91': 'AI辅助区',
  'auto.pages.pages.data-modeling.index.92':
    '通过AI拆解实体、分析字段并应用到下方实体列表。',
  'auto.pages.pages.data-modeling.modeling-assistant.index.1':
    '建议字段包括：{p1}。',
  'auto.pages.pages.data-modeling.modeling-assistant.index.2': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.3': '未识别项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.4':
    '加载建模辅助失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.5':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.6': '项目信息已保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.7':
    '保存项目信息失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.8': '项目信息已保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.9':
    '保存项目信息失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.10':
    '实体信息已保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.11':
    '实体信息已保存到预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.12':
    '保存实体信息失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.13':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.14':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.data-modeling.modeling-assistant.index.15': 'AI 生成失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.16':
    '字段描述预览已生成',
  'auto.pages.pages.data-modeling.modeling-assistant.index.17':
    '生成字段描述失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.18':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.19':
    '请先生成字段描述预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.20':
    '缺少实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.21':
    '字段已保存：新增 {p1}，覆盖 {p2}，跳过 {p3}',
  'auto.pages.pages.data-modeling.modeling-assistant.index.22': '保存字段失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.23':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.24': '字段详情',
  'auto.pages.pages.data-modeling.modeling-assistant.index.25':
    '加载字段详情失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.26':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.27': '缺少实体名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.28':
    '请至少保留一个字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.29':
    '字段修改已保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.30': '保存字段失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.31':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.32':
    '请先勾选预览实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.33':
    '已添加并保存 {p1} 个实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.34': '添加失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.35':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.36': '保存成功',
  'auto.pages.pages.data-modeling.modeling-assistant.index.37': '保存失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.38':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.data-modeling.modeling-assistant.index.39':
    '已清空建模辅助列表',
  'auto.pages.pages.data-modeling.modeling-assistant.index.40': '清空失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.41': '实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.42': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.43': '实体英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.44': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.45': '主要字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.46': '未生成',
  'auto.pages.pages.data-modeling.modeling-assistant.index.47': '操作',
  'auto.pages.pages.data-modeling.modeling-assistant.index.48': '分析字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.49': '查看字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.50': '编辑',
  'auto.pages.pages.data-modeling.modeling-assistant.index.51': '删除',
  'auto.pages.pages.data-modeling.modeling-assistant.index.52': '实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.53': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.54': '实体英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.55': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.56': '主要字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.57': '未生成',
  'auto.pages.pages.data-modeling.modeling-assistant.index.58': '操作',
  'auto.pages.pages.data-modeling.modeling-assistant.index.59': '分析字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.60': '建模辅助',
  'auto.pages.pages.data-modeling.modeling-assistant.index.61':
    '基于项目名称、简介和功能清单，发现业务实体并逐个分析字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.62': 'AI建模辅助',
  'auto.pages.pages.data-modeling.modeling-assistant.index.63': '新增实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.64': '保存',
  'auto.pages.pages.data-modeling.modeling-assistant.index.65':
    '确认清空当前建模辅助列表？',
  'auto.pages.pages.data-modeling.modeling-assistant.index.66': '清空重置',
  'auto.pages.pages.data-modeling.modeling-assistant.index.67': '删除选中（',
  'auto.pages.pages.data-modeling.modeling-assistant.index.68':
    '暂无建模实体，点击“AI建模辅助”或“新增实体”开始',
  'auto.pages.pages.data-modeling.modeling-assistant.index.69': '编辑实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.70': '新增实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.71': '确定',
  'auto.pages.pages.data-modeling.modeling-assistant.index.72': '取消',
  'auto.pages.pages.data-modeling.modeling-assistant.index.73': '实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.74':
    '请输入实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.75': '实体英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.76': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.77': '主要字段描述',
  'auto.pages.pages.data-modeling.modeling-assistant.index.78':
    '例如：建议包含客户编号、状态、创建时间等字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.79': 'AI 建模辅助',
  'auto.pages.pages.data-modeling.modeling-assistant.index.80': '生成选项',
  'auto.pages.pages.data-modeling.modeling-assistant.index.81': '项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.82':
    '请输入项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.83':
    '请输入项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.84': '项目简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.85':
    '请输入项目简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.86':
    '提示信息（用于辅助生成）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.87':
    '例如：重点补充主数据、交易实体、结算实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.88': '拆解实体数量',
  'auto.pages.pages.data-modeling.modeling-assistant.index.89':
    '请输入拆解数量',
  'auto.pages.pages.data-modeling.modeling-assistant.index.90':
    '数量范围为 1-40',
  'auto.pages.pages.data-modeling.modeling-assistant.index.91':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.92': '保存项目信息',
  'auto.pages.pages.data-modeling.modeling-assistant.index.93': '取消',
  'auto.pages.pages.data-modeling.modeling-assistant.index.94': '生成预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.95': '预览结果',
  'auto.pages.pages.data-modeling.modeling-assistant.index.96':
    '勾选需要的实体后添加到列表',
  'auto.pages.pages.data-modeling.modeling-assistant.index.97':
    '点击“生成预览”后查看候选实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.98':
    '重名时覆盖已有实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.99':
    '添加选中到实体列表（',
  'auto.pages.pages.data-modeling.modeling-assistant.index.100': '分析字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.101': '分析选项',
  'auto.pages.pages.data-modeling.modeling-assistant.index.102': '项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.103':
    '请输入项目名称',
  'auto.pages.pages.data-modeling.modeling-assistant.index.104': '项目简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.105': '实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.106':
    '请输入实体中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.107': '实体英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.108': '实体简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.109': '主要字段描述',
  'auto.pages.pages.data-modeling.modeling-assistant.index.110':
    '提示信息（用于辅助分析）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.111':
    '例如：强调索引建议、状态流转字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.112': '数据库类型',
  'auto.pages.pages.data-modeling.modeling-assistant.index.113': '保存项目信息',
  'auto.pages.pages.data-modeling.modeling-assistant.index.114': '保存实体信息',
  'auto.pages.pages.data-modeling.modeling-assistant.index.115': '取消',
  'auto.pages.pages.data-modeling.modeling-assistant.index.116': '生成预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.117': '预览结果',
  'auto.pages.pages.data-modeling.modeling-assistant.index.118':
    '确认后存入独立字段分析表（不回写实体详细字段）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.119': '字段中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.120': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.121': '字段英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.122': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.123': 'MySQL类型',
  'auto.pages.pages.data-modeling.modeling-assistant.index.124': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.125': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.126': '未填写',
  'auto.pages.pages.data-modeling.modeling-assistant.index.127': '必填',
  'auto.pages.pages.data-modeling.modeling-assistant.index.128': '是',
  'auto.pages.pages.data-modeling.modeling-assistant.index.129': '否',
  'auto.pages.pages.data-modeling.modeling-assistant.index.130': '未定',
  'auto.pages.pages.data-modeling.modeling-assistant.index.131': '可空',
  'auto.pages.pages.data-modeling.modeling-assistant.index.132': '是',
  'auto.pages.pages.data-modeling.modeling-assistant.index.133': '否',
  'auto.pages.pages.data-modeling.modeling-assistant.index.134': '未定',
  'auto.pages.pages.data-modeling.modeling-assistant.index.135':
    '点击“生成预览”后查看字段建议',
  'auto.pages.pages.data-modeling.modeling-assistant.index.136': '覆盖',
  'auto.pages.pages.data-modeling.modeling-assistant.index.137': '追加',
  'auto.pages.pages.data-modeling.modeling-assistant.index.138':
    '追加时覆盖已有重名字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.139': '保存到字段库',
  'auto.pages.pages.data-modeling.modeling-assistant.index.140':
    '{p1} - 字段详情',
  'auto.pages.pages.data-modeling.modeling-assistant.index.141': '新增字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.142': '保存字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.143':
    '字段加载中...',
  'auto.pages.pages.data-modeling.modeling-assistant.index.144':
    '暂无字段，请点击“新增字段”或先执行AI分析',
  'auto.pages.pages.data-modeling.modeling-assistant.index.145': '字段中文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.146': '如：客户编号',
  'auto.pages.pages.data-modeling.modeling-assistant.index.147': '字段英文名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.148':
    '如：customerCode',
  'auto.pages.pages.data-modeling.modeling-assistant.index.149': 'MySQL类型',
  'auto.pages.pages.data-modeling.modeling-assistant.index.150':
    '如：varchar(255)',
  'auto.pages.pages.data-modeling.modeling-assistant.index.151': '简介',
  'auto.pages.pages.data-modeling.modeling-assistant.index.152': '字段说明',
  'auto.pages.pages.data-modeling.modeling-assistant.index.153': '必填',
  'auto.pages.pages.data-modeling.modeling-assistant.index.154': '可空',
  'auto.pages.pages.data-modeling.modeling-assistant.index.155': '操作',
  'auto.pages.pages.data-modeling.modeling-assistant.index.156': '下方插入',
  'auto.pages.pages.data-modeling.modeling-assistant.index.157': '删除',
  'auto.pages.pages.data-modeling.modeling-assistant.index.158':
    '请先输入至少一个实体名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.159':
    '人工录入完成，已生成 {p1} 个实体预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.160': '拆解模式',
  'auto.pages.pages.data-modeling.modeling-assistant.index.161': 'A、尽可能多',
  'auto.pages.pages.data-modeling.modeling-assistant.index.162': 'B、指定数量',
  'auto.pages.pages.data-modeling.modeling-assistant.index.163': 'C、人工录入',
  'auto.pages.pages.data-modeling.modeling-assistant.index.164': '人工录入实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.165':
    '每行输入一个实体名，提交后直接生成预览',
  'auto.pages.pages.data-modeling.modeling-assistant.index.166':
    '请输入人工录入内容',
  'auto.pages.pages.data-modeling.modeling-assistant.index.167':
    '例如：客户\n订单\n支付记录',
  'auto.pages.pages.data-modeling.modeling-assistant.index.168':
    '请先勾选至少一个实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.169':
    '批量拆解完成：成功 {p1} 个，失败 {p2} 个',
  'auto.pages.pages.data-modeling.modeling-assistant.index.170':
    '暂无可保存的批量字段结果',
  'auto.pages.pages.data-modeling.modeling-assistant.index.171':
    '批量保存完成：成功实体 {p1}，失败实体 {p2}，新增 {p3}，覆盖 {p4}，跳过 {p5}',
  'auto.pages.pages.data-modeling.modeling-assistant.index.172': '批量字段拆解',
  'auto.pages.pages.data-modeling.modeling-assistant.index.173':
    '批量字段拆解（{p1} 个实体）',
  'auto.pages.pages.data-modeling.modeling-assistant.index.174': '本次批量实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.175':
    '已选择 {p1} 个实体进行字段拆解',
  'auto.pages.pages.data-modeling.modeling-assistant.index.176': '字段拆解模式',
  'auto.pages.pages.data-modeling.modeling-assistant.index.177': '字段数量',
  'auto.pages.pages.data-modeling.modeling-assistant.index.178':
    '请输入字段数量',
  'auto.pages.pages.data-modeling.modeling-assistant.index.179': '人工录入字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.180':
    '每行输入一个字段名，保存前可在字段详情继续编辑',
  'auto.pages.pages.data-modeling.modeling-assistant.index.181':
    '请输入人工录入字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.182':
    '例如：客户编号\n客户名称\n客户状态',
  'auto.pages.pages.data-modeling.modeling-assistant.index.183':
    '成功，字段数 {p1}',
  'auto.pages.pages.data-modeling.modeling-assistant.index.184': '字段拆解失败',
  'auto.pages.pages.data-modeling.modeling-assistant.index.185':
    '点击“生成预览”后查看批量字段结果',
  'auto.pages.pages.data-modeling.modeling-assistant.index.200':
    '统一管理项目“{p1}”下的实体、字段与关系',
  'auto.pages.pages.data-modeling.modeling-assistant.index.201': '实体列表',
  'auto.pages.pages.data-modeling.modeling-assistant.index.202': '实体详情',
  'auto.pages.pages.data-modeling.modeling-assistant.index.203':
    '请先在左侧选择一个实体',
  'auto.pages.pages.data-modeling.modeling-assistant.index.204': '字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.205': '新增字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.206': '刷新字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.207': '保存字段',
  'auto.pages.pages.data-modeling.modeling-assistant.index.208': '字段名',
  'auto.pages.pages.data-modeling.modeling-assistant.index.209': '字段类型',
  'auto.pages.pages.data-modeling.modeling-assistant.index.210': '非空',
  'auto.pages.pages.data-modeling.modeling-assistant.index.211': '是',
  'auto.pages.pages.data-modeling.modeling-assistant.index.212': '否',
  'auto.pages.pages.data-modeling.modeling-assistant.index.213': '可空',
  'auto.pages.pages.data-modeling.modeling-assistant.index.214': '字段说明',
  'auto.pages.pages.data-modeling.modeling-assistant.index.215': '关系',
  'auto.pages.pages.data-modeling.modeling-assistant.index.216': '新增关系',
  'auto.pages.pages.data-modeling.modeling-assistant.index.217':
    '暂无关系，点击“新增关系”开始',
  'auto.pages.pages.data-modeling.modeling-assistant.index.218': '关系数',
  'auto.pages.pages.data-modeling.modeling-assistant.index.219': 'Association',
  'auto.pages.pages.data-modeling.modeling-assistant.index.220': 'Semantic',
  'auto.pages.pages.data-modeling.modeling-assistant.index.221': 'Foreign Key',
  'auto.pages.pages.data-modeling.modeling-assistant.index.222': 'Normal',
  'auto.pages.pages.data-modeling.modeling-assistant.index.223':
    'Target entity (optional)',
  'auto.pages.pages.data-modeling.modeling-assistant.index.224':
    'Off: semantic association only. On: allow foreign-key semantic fields (no real DB FK constraint).',
  'auto.pages.pages.data-modeling.modeling-assistant.index.225':
    'Generate foreign-key fields',
  'auto.pages.pages.data-modeling.modeling-assistant.index.226': 'Clear fields',
  'auto.pages.pages.data-modeling.modeling-assistant.index.227':
    'Clear all current fields?',
  'auto.pages.pages.data-modeling.modeling-assistant.index.228':
    'The field list is already empty',
  'auto.pages.pages.data-modeling.modeling-assistant.index.229':
    'Field list cleared',
  'auto.pages.pages.data-modeling.modeling-assistant.index.230':
    'Apply rule profile',
  'auto.pages.pages.data-modeling.modeling-assistant.index.231':
    'No relation suggestions',
  'auto.pages.pages.data-modeling.modeling-assistant.index.232':
    'Relation Type',
  'auto.pages.pages.data-modeling.modeling-assistant.index.233':
    'Target Entity',
  'auto.pages.pages.data-modeling.modeling-assistant.index.234':
    'Relation Name',
  'auto.pages.pages.data-modeling.modeling-assistant.index.235':
    'Fields saved, but relation save failed',
  'auto.pages.pages.data-modeling.modeling-assistant.index.236':
    'Relation save: added {p1}, skipped {p2}, invalid {p3}',
  'auto.pages.pages.external-redirect.index.1': '正在跳转...',
  'auto.pages.pages.knowledge-base.index.1': '项目需求分析模板',
  'auto.pages.pages.knowledge-base.index.2': '架构评审规范',
  'auto.pages.pages.knowledge-base.index.3': '架构组',
  'auto.pages.pages.knowledge-base.index.4': '上线回滚预案',
  'auto.pages.pages.knowledge-base.index.5': '文档标题',
  'auto.pages.pages.knowledge-base.index.6': '分类',
  'auto.pages.pages.knowledge-base.index.7': '模板',
  'auto.pages.pages.knowledge-base.index.8': '规范',
  'auto.pages.pages.knowledge-base.index.9': '运行手册',
  'auto.pages.pages.knowledge-base.index.10': '维护人',
  'auto.pages.pages.knowledge-base.index.11': '版本',
  'auto.pages.pages.knowledge-base.index.12': '更新时间',
  'auto.pages.pages.knowledge-base.index.13': '操作',
  'auto.pages.pages.knowledge-base.index.14': '查看',
  'auto.pages.pages.knowledge-base.index.15': '编辑',
  'auto.pages.pages.knowledge-base.index.16': '知识库',
  'auto.pages.pages.knowledge-base.index.17':
    '对接企业知识管理系统（文件管理）',
  'auto.pages.pages.knowledge-base.index.18': '上传文档',
  'auto.pages.pages.knowledge-base.index.19': '新建知识',
  'auto.pages.pages.knowledge-base.reference-materials.index.1':
    '参考链接已添加',
  'auto.pages.pages.knowledge-base.reference-materials.index.2':
    '参考文字已记录',
  'auto.pages.pages.knowledge-base.reference-materials.index.3': '参考资料',
  'auto.pages.pages.knowledge-base.reference-materials.index.4':
    '沉淀参考链接、文件/图片与文字记录（后续可对接记录易）',
  'auto.pages.pages.knowledge-base.reference-materials.index.5': '参考链接',
  'auto.pages.pages.knowledge-base.reference-materials.index.6':
    '请输入链接标题',
  'auto.pages.pages.knowledge-base.reference-materials.index.7': '标题',
  'auto.pages.pages.knowledge-base.reference-materials.index.8':
    '请输入链接地址',
  'auto.pages.pages.knowledge-base.reference-materials.index.9':
    '请输入有效 URL（含 http/https）',
  'auto.pages.pages.knowledge-base.reference-materials.index.10': '添加链接',
  'auto.pages.pages.knowledge-base.reference-materials.index.11':
    '暂无参考链接',
  'auto.pages.pages.knowledge-base.reference-materials.index.12': '链接',
  'auto.pages.pages.knowledge-base.reference-materials.index.13':
    '参考文件/图片',
  'auto.pages.pages.knowledge-base.reference-materials.index.14':
    '选择文件或图片',
  'auto.pages.pages.knowledge-base.reference-materials.index.15':
    '暂无已选择文件',
  'auto.pages.pages.knowledge-base.reference-materials.index.16': '文件',
  'auto.pages.pages.knowledge-base.reference-materials.index.17': '文字记录',
  'auto.pages.pages.knowledge-base.reference-materials.index.18': '参考说明',
  'auto.pages.pages.knowledge-base.reference-materials.index.19': '请输入内容',
  'auto.pages.pages.knowledge-base.reference-materials.index.20':
    '记录参考点、竞品优缺点、适配建议等',
  'auto.pages.pages.knowledge-base.reference-materials.index.21': '保存记录',
  'auto.pages.pages.knowledge-base.reference-materials.index.22':
    '暂无文字记录',
  'auto.pages.pages.knowledge-base.reference-materials.index.23': '文字',
  'auto.pages.pages.knowledge-base.reference-products.index.1': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.2': '竞品',
  'auto.pages.pages.knowledge-base.reference-products.index.3': '可替代方案',
  'auto.pages.pages.knowledge-base.reference-products.index.4': '国内',
  'auto.pages.pages.knowledge-base.reference-products.index.5': '国外',
  'auto.pages.pages.knowledge-base.reference-products.index.6': '高',
  'auto.pages.pages.knowledge-base.reference-products.index.7': '中',
  'auto.pages.pages.knowledge-base.reference-products.index.8': '低',
  'auto.pages.pages.knowledge-base.reference-products.index.9': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.10': '竞品',
  'auto.pages.pages.knowledge-base.reference-products.index.11': '可替代方案',
  'auto.pages.pages.knowledge-base.reference-products.index.12': '国内',
  'auto.pages.pages.knowledge-base.reference-products.index.13': '国外',
  'auto.pages.pages.knowledge-base.reference-products.index.14': '高',
  'auto.pages.pages.knowledge-base.reference-products.index.15': '中',
  'auto.pages.pages.knowledge-base.reference-products.index.16': '低',
  'auto.pages.pages.knowledge-base.reference-products.index.17': '未命名项目',
  'auto.pages.pages.knowledge-base.reference-products.index.18':
    '加载参考产品失败',
  'auto.pages.pages.knowledge-base.reference-products.index.19':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.20':
    '项目信息已保存',
  'auto.pages.pages.knowledge-base.reference-products.index.21':
    '保存项目信息失败',
  'auto.pages.pages.knowledge-base.reference-products.index.22':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.23':
    'AI 生成完成（参考功能项 {p1} 条），请勾选后添加',
  'auto.pages.pages.knowledge-base.reference-products.index.24': 'AI 生成失败',
  'auto.pages.pages.knowledge-base.reference-products.index.25':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.26':
    '请先勾选预览产品',
  'auto.pages.pages.knowledge-base.reference-products.index.27':
    '已添加并保存 {p1} 个参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.28': '添加失败',
  'auto.pages.pages.knowledge-base.reference-products.index.29':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.30': '保存成功',
  'auto.pages.pages.knowledge-base.reference-products.index.31': '保存失败',
  'auto.pages.pages.knowledge-base.reference-products.index.32':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.33':
    '已清空参考产品数据',
  'auto.pages.pages.knowledge-base.reference-products.index.34': '清空失败',
  'auto.pages.pages.knowledge-base.reference-products.index.35':
    '当前未识别到项目，请先从左侧切换到一个项目',
  'auto.pages.pages.knowledge-base.reference-products.index.36': '修改已保存',
  'auto.pages.pages.knowledge-base.reference-products.index.37': '新增已保存',
  'auto.pages.pages.knowledge-base.reference-products.index.38': '修改保存失败',
  'auto.pages.pages.knowledge-base.reference-products.index.39': '新增保存失败',
  'auto.pages.pages.knowledge-base.reference-products.index.40': '未填写',
  'auto.pages.pages.knowledge-base.reference-products.index.41': '中',
  'auto.pages.pages.knowledge-base.reference-products.index.42': '产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.43': '未填写',
  'auto.pages.pages.knowledge-base.reference-products.index.44': '类型',
  'auto.pages.pages.knowledge-base.reference-products.index.45': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.46': '区域',
  'auto.pages.pages.knowledge-base.reference-products.index.47': '未区分',
  'auto.pages.pages.knowledge-base.reference-products.index.48': '相关度',
  'auto.pages.pages.knowledge-base.reference-products.index.49': '关注度',
  'auto.pages.pages.knowledge-base.reference-products.index.50': '厂商',
  'auto.pages.pages.knowledge-base.reference-products.index.51': '官网',
  'auto.pages.pages.knowledge-base.reference-products.index.52': '未填写',
  'auto.pages.pages.knowledge-base.reference-products.index.53': '核心能力',
  'auto.pages.pages.knowledge-base.reference-products.index.54': '可借鉴点',
  'auto.pages.pages.knowledge-base.reference-products.index.55': '适用场景',
  'auto.pages.pages.knowledge-base.reference-products.index.56': '收费模式',
  'auto.pages.pages.knowledge-base.reference-products.index.57': '备注',
  'auto.pages.pages.knowledge-base.reference-products.index.58': '操作',
  'auto.pages.pages.knowledge-base.reference-products.index.59': '编辑',
  'auto.pages.pages.knowledge-base.reference-products.index.60': '删除',
  'auto.pages.pages.knowledge-base.reference-products.index.61': '列显示',
  'auto.pages.pages.knowledge-base.reference-products.index.62': '重置',
  'auto.pages.pages.knowledge-base.reference-products.index.63': '产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.64': '未填写',
  'auto.pages.pages.knowledge-base.reference-products.index.65': '类型',
  'auto.pages.pages.knowledge-base.reference-products.index.66': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.67': '区域',
  'auto.pages.pages.knowledge-base.reference-products.index.68': '未区分',
  'auto.pages.pages.knowledge-base.reference-products.index.69': '相关度',
  'auto.pages.pages.knowledge-base.reference-products.index.70': '关注度',
  'auto.pages.pages.knowledge-base.reference-products.index.71': '厂商',
  'auto.pages.pages.knowledge-base.reference-products.index.72': '核心能力',
  'auto.pages.pages.knowledge-base.reference-products.index.73': '可借鉴点',
  'auto.pages.pages.knowledge-base.reference-products.index.74': '适用场景',
  'auto.pages.pages.knowledge-base.reference-products.index.75': '参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.76':
    '基于项目“{p1}”沉淀可借鉴产品与竞品分析',
  'auto.pages.pages.knowledge-base.reference-products.index.77': '搜索产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.78': 'AI分析',
  'auto.pages.pages.knowledge-base.reference-products.index.79': '新增',
  'auto.pages.pages.knowledge-base.reference-products.index.80': '保存',
  'auto.pages.pages.knowledge-base.reference-products.index.81':
    '确认清空当前项目参考产品数据？',
  'auto.pages.pages.knowledge-base.reference-products.index.82': '清空',
  'auto.pages.pages.knowledge-base.reference-products.index.83': '删除（',
  'auto.pages.pages.knowledge-base.reference-products.index.84': '刷新',
  'auto.pages.pages.knowledge-base.reference-products.index.85': '紧凑',
  'auto.pages.pages.knowledge-base.reference-products.index.86': '默认',
  'auto.pages.pages.knowledge-base.reference-products.index.87': '宽松',
  'auto.pages.pages.knowledge-base.reference-products.index.88': '调节蜜度',
  'auto.pages.pages.knowledge-base.reference-products.index.89': '列设置',
  'auto.pages.pages.knowledge-base.reference-products.index.90':
    '暂无参考产品数据，点击“AI参考产品分析”或“新增产品”开始',
  'auto.pages.pages.knowledge-base.reference-products.index.91': '共 {p1} 条',
  'auto.pages.pages.knowledge-base.reference-products.index.92': '编辑参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.93': '新增参考产品',
  'auto.pages.pages.knowledge-base.reference-products.index.94': '确定',
  'auto.pages.pages.knowledge-base.reference-products.index.95': '取消',
  'auto.pages.pages.knowledge-base.reference-products.index.96': '产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.97':
    '请输入产品名称',
  'auto.pages.pages.knowledge-base.reference-products.index.98':
    '例如：Jira Software',
  'auto.pages.pages.knowledge-base.reference-products.index.99': '产品类型',
  'auto.pages.pages.knowledge-base.reference-products.index.100':
    '请选择产品类型',
  'auto.pages.pages.knowledge-base.reference-products.index.101': '区域',
  'auto.pages.pages.knowledge-base.reference-products.index.102': '请选择区域',
  'auto.pages.pages.knowledge-base.reference-products.index.103': '相关度',
  'auto.pages.pages.knowledge-base.reference-products.index.104':
    '请选择相关度',
  'auto.pages.pages.knowledge-base.reference-products.index.105': '关注度',
  'auto.pages.pages.knowledge-base.reference-products.index.106':
    '请选择关注度',
  'auto.pages.pages.knowledge-base.reference-products.index.107': '厂商',
  'auto.pages.pages.knowledge-base.reference-products.index.108':
    '例如：Atlassian',
  'auto.pages.pages.knowledge-base.reference-products.index.109': '官网链接',
  'auto.pages.pages.knowledge-base.reference-products.index.110': '产品定位',
  'auto.pages.pages.knowledge-base.reference-products.index.111': '核心能力',
  'auto.pages.pages.knowledge-base.reference-products.index.112': '可借鉴点',
  'auto.pages.pages.knowledge-base.reference-products.index.113': '适用场景',
  'auto.pages.pages.knowledge-base.reference-products.index.114': '收费模式',
  'auto.pages.pages.knowledge-base.reference-products.index.115':
    '例如：按用户订阅',
  'auto.pages.pages.knowledge-base.reference-products.index.116': '备注',
  'auto.pages.pages.knowledge-base.reference-products.index.117':
    'AI 参考产品分析',
  'auto.pages.pages.knowledge-base.reference-products.index.118': '生成选项',
  'auto.pages.pages.knowledge-base.reference-products.index.119': '项目名称',
  'auto.pages.pages.knowledge-base.reference-products.index.120':
    '请输入项目名称',
  'auto.pages.pages.knowledge-base.reference-products.index.121':
    '请输入项目名称',
  'auto.pages.pages.knowledge-base.reference-products.index.122': '项目简介',
  'auto.pages.pages.knowledge-base.reference-products.index.123':
    '请输入项目简介',
  'auto.pages.pages.knowledge-base.reference-products.index.124':
    '提示信息（用于辅助生成）',
  'auto.pages.pages.knowledge-base.reference-products.index.125':
    '例如：重点覆盖国内可落地产品，并说明可借鉴能力',
  'auto.pages.pages.knowledge-base.reference-products.index.126':
    '推荐产品数量',
  'auto.pages.pages.knowledge-base.reference-products.index.127': '请输入数量',
  'auto.pages.pages.knowledge-base.reference-products.index.128':
    '数量范围为 1-20',
  'auto.pages.pages.knowledge-base.reference-products.index.129':
    '参考功能清单（若项目已有功能清单）',
  'auto.pages.pages.knowledge-base.reference-products.index.130':
    '保存项目信息',
  'auto.pages.pages.knowledge-base.reference-products.index.131': '取消',
  'auto.pages.pages.knowledge-base.reference-products.index.132': '生成预览',
  'auto.pages.pages.knowledge-base.reference-products.index.133': '预览结果',
  'auto.pages.pages.knowledge-base.reference-products.index.134':
    '勾选需要的产品后添加到列表',
  'auto.pages.pages.knowledge-base.reference-products.index.135':
    '点击“生成预览”后查看候选产品',
  'auto.pages.pages.knowledge-base.reference-products.index.136':
    '重名时覆盖已有产品',
  'auto.pages.pages.knowledge-base.reference-products.index.137':
    '添加选中到产品列表（',
  'auto.pages.pages.knowledge-base.reference-products.index.138':
    'Generation strategy',
  'auto.pages.pages.knowledge-base.reference-products.index.139':
    'A. As many as possible',
  'auto.pages.pages.knowledge-base.reference-products.index.140':
    'B. Specified quantity',
  'auto.pages.pages.knowledge-base.reference-products.index.141':
    'C. Manual input',
  'auto.pages.pages.knowledge-base.reference-products.index.142':
    'Manual product list',
  'auto.pages.pages.knowledge-base.reference-products.index.143':
    'Please enter at least one product name',
  'auto.pages.pages.knowledge-base.reference-products.index.144':
    'Enter one product name per line, e.g. Jira Software',
  'auto.pages.pages.knowledge-base.reference-products.index.145':
    '{p1} manually entered candidates generated, select and add',
  'auto.pages.pages.knowledge-base.reference-products.index.146':
    'No valid product names found (check duplicates with existing products)',
  'auto.pages.pages.project.layout.1': '未命名页面',
  'auto.pages.pages.project-home.index.1': '项目主页',
  'auto.pages.pages.project-home.index.2': '项目全局概览与最近动态',
  'auto.pages.pages.project-home.index.3': '应用数',
  'auto.pages.pages.project-home.index.4': '个',
  'auto.pages.pages.project-home.index.5': '代码总行数',
  'auto.pages.pages.project-home.index.6': '行',
  'auto.pages.pages.project-home.index.7': '生成代码总行数',
  'auto.pages.pages.project-home.index.8': '行',
  'auto.pages.pages.project-home.index.9': '代码行数较昨日新增',
  'auto.pages.pages.project-home.index.10': '行',
  'auto.pages.pages.project-home.index.11': '一级功能模块数',
  'auto.pages.pages.project-home.index.12': '个',
  'auto.pages.pages.project-home.index.13': '功能数',
  'auto.pages.pages.project-home.index.14': '个',
  'auto.pages.pages.project-home.index.15': '功能点数',
  'auto.pages.pages.project-home.index.16': '个',
  'auto.pages.pages.project-home.index.17': '角色数',
  'auto.pages.pages.project-home.index.18': '个',
  'auto.pages.pages.project-home.index.19': '概念数',
  'auto.pages.pages.project-home.index.20': '个',
  'auto.pages.pages.project-home.index.21': '项目概况',
  'auto.pages.pages.project-home.index.22': '项目名称',
  'auto.pages.pages.project-home.index.23': '英文名称',
  'auto.pages.pages.project-home.index.24': '标识符',
  'auto.pages.pages.project-home.index.25': '项目简介',
  'auto.pages.pages.project-home.index.26': '创建时间',
  'auto.pages.pages.project-home.index.27': '最近更新',
  'auto.pages.pages.project-home.index.28': '未设置',
  'auto.pages.pages.project-home.index.29': '项目约定',
  'auto.pages.pages.project-home.index.30':
    '当前项目启用中的目标愿景、原则要求与注意事项',
  'auto.pages.pages.project-home.index.31': '当前暂无启用中的项目约定',
  'auto.pages.pages.project-home.index.32': '目标愿景',
  'auto.pages.pages.project-home.index.33': '原则要求',
  'auto.pages.pages.project-home.index.34': '注意事项',
  'auto.pages.pages.project-home.index.35': '验收标准',
  'auto.pages.pages.project-home.index.36': '暂无验收标准',
  'auto.pages.pages.project-home.index.37': '最近操作记录',
  'auto.pages.pages.project-home.index.38': '当前暂无最近操作记录',
  'auto.pages.pages.project-home.index.39': '编辑基本信息',
  'auto.pages.pages.project-home.index.40': '编辑项目概况',
  'auto.pages.pages.project-home.index.41': '请输入项目名称',
  'auto.pages.pages.project-home.index.42': '请输入项目名称',
  'auto.pages.pages.project-home.index.43': '请输入英文名称',
  'auto.pages.pages.project-home.index.44': '请输入标识符',
  'auto.pages.pages.project-home.index.45': '该标识符已存在',
  'auto.pages.pages.project-home.index.46': '未找到当前项目，无法保存',
  'auto.pages.pages.project-home.index.47': '项目基本信息已更新',
  'auto.pages.pages.project-home.index.48': '请输入项目简介',
  'auto.pages.pages.project-settings.developer-options.index.1': '开发者选项',
  'auto.pages.pages.project-settings.developer-options.index.2':
    '开发工具与扩展能力配置',
  'auto.pages.pages.project-settings.developer-options.index.3':
    '开发者选项页面建设中',
  'auto.pages.pages.project-settings.project-announcement.index.1': '项目公告',
  'auto.pages.pages.project-settings.project-announcement.index.2':
    '项目公告发布与历史公告管理',
  'auto.pages.pages.project-settings.project-announcement.index.3':
    '项目公告页面建设中',
  'auto.pages.pages.project-settings.project-collaboration.index.1': '项目协同',
  'auto.pages.pages.project-settings.project-collaboration.index.2':
    '项目协同规则与工作流设置',
  'auto.pages.pages.project-settings.project-collaboration.index.3':
    '项目协同设置页面建设中',
  'auto.pages.pages.project-settings.project-member.index.1': '项目与成员',
  'auto.pages.pages.project-settings.project-member.index.2':
    '项目基本信息与成员协作配置',
  'auto.pages.pages.project-settings.project-member.index.3':
    '项目与成员设置页面建设中',
  'auto.pages.pages.projects.data.1': '解析用户信息失败',
  'auto.pages.pages.projects.estimation-standards.detail.1':
    '估算标准不存在或已删除',
  'auto.pages.pages.projects.estimation-standards.detail.2': '加载标准详情失败',
  'auto.pages.pages.projects.estimation-standards.detail.3': 'AI已生成评分标准',
  'auto.pages.pages.projects.estimation-standards.detail.4':
    'AI生成评分标准失败',
  'auto.pages.pages.projects.estimation-standards.detail.5': 'AI已调整角色比例',
  'auto.pages.pages.projects.estimation-standards.detail.6':
    'AI调整角色比例失败',
  'auto.pages.pages.projects.estimation-standards.detail.7': 'AI已估算基准工时',
  'auto.pages.pages.projects.estimation-standards.detail.8':
    'AI估算基准工时失败',
  'auto.pages.pages.projects.estimation-standards.detail.9':
    'AI标准生成完成：{p1}/{p2}',
  'auto.pages.pages.projects.estimation-standards.detail.10':
    '批量AI生成评分标准失败',
  'auto.pages.pages.projects.estimation-standards.detail.11':
    'AI比例调整完成：{p1}/{p2}',
  'auto.pages.pages.projects.estimation-standards.detail.12':
    '批量AI调整比例失败',
  'auto.pages.pages.projects.estimation-standards.detail.13':
    'AI工时估算完成：{p1}/{p2}',
  'auto.pages.pages.projects.estimation-standards.detail.14':
    '批量AI估算工时失败',
  'auto.pages.pages.projects.estimation-standards.detail.15': '评分标准',
  'auto.pages.pages.projects.estimation-standards.detail.16': '角色比例',
  'auto.pages.pages.projects.estimation-standards.detail.17': '基准工时',
  'auto.pages.pages.projects.estimation-standards.detail.18': '功能点类型代码',
  'auto.pages.pages.projects.estimation-standards.detail.19': '分类',
  'auto.pages.pages.projects.estimation-standards.detail.20': '基准工时',
  'auto.pages.pages.projects.estimation-standards.detail.21':
    '角色比例(%)  P=产品 F=前端 B=后端 T=测试',
  'auto.pages.pages.projects.estimation-standards.detail.22': '操作',
  'auto.pages.pages.projects.estimation-standards.detail.23': '完成',
  'auto.pages.pages.projects.estimation-standards.detail.24': '改',
  'auto.pages.pages.projects.estimation-standards.detail.25':
    '确认删除 {p1} 配置吗？',
  'auto.pages.pages.projects.estimation-standards.detail.26':
    '已删除，保存后生效',
  'auto.pages.pages.projects.estimation-standards.detail.27': '删',
  'auto.pages.pages.projects.estimation-standards.detail.28': 'AI生成评分标准',
  'auto.pages.pages.projects.estimation-standards.detail.29': 'AI标准',
  'auto.pages.pages.projects.estimation-standards.detail.30': 'AI调整角色比例',
  'auto.pages.pages.projects.estimation-standards.detail.31': 'AI比例',
  'auto.pages.pages.projects.estimation-standards.detail.32': 'AI估算基准工时',
  'auto.pages.pages.projects.estimation-standards.detail.33': 'AI工时',
  'auto.pages.pages.projects.estimation-standards.detail.34':
    '标准参数保存成功',
  'auto.pages.pages.projects.estimation-standards.detail.35':
    '保存标准参数失败',
  'auto.pages.pages.projects.estimation-standards.detail.36': '标准参数：{p1}',
  'auto.pages.pages.projects.estimation-standards.detail.37': '标准参数',
  'auto.pages.pages.projects.estimation-standards.detail.38': '版本 v{p1}',
  'auto.pages.pages.projects.estimation-standards.detail.39': '返回列表',
  'auto.pages.pages.projects.estimation-standards.detail.40': 'AI批量标准',
  'auto.pages.pages.projects.estimation-standards.detail.41': 'AI批量比例',
  'auto.pages.pages.projects.estimation-standards.detail.42': 'AI批量工时',
  'auto.pages.pages.projects.estimation-standards.detail.43': '保存参数',
  'auto.pages.pages.projects.estimation-standards.detail.44':
    '复杂度判定标准（可编辑）',
  'auto.pages.pages.projects.estimation-standards.detail.45': '备注',
  'auto.pages.pages.projects.estimation-standards.detail.46': '可选',
  'auto.pages.pages.projects.estimation-standards.detail.47': 'AI{p1}分析',
  'auto.pages.pages.projects.estimation-standards.detail.48': '开始分析',
  'auto.pages.pages.projects.estimation-standards.detail.49': '取消',
  'auto.pages.pages.projects.estimation-standards.detail.50': '目标：',
  'auto.pages.pages.projects.estimation-standards.detail.51': '全部 {p1} 项',
  'auto.pages.pages.projects.estimation-standards.detail.52':
    '请输入你的意见建议，例如：优先稳定性、强调后端性能、提高测试覆盖、避免复杂实现等',
  'auto.pages.pages.projects.estimation-standards.detail.53':
    'AI会在分析时优先考虑你输入的意见；不填则按系统默认规则分析。',
  'auto.pages.pages.projects.estimation-standards.index.1': '加载估算标准失败',
  'auto.pages.pages.projects.estimation-standards.index.2': '估算标准更新成功',
  'auto.pages.pages.projects.estimation-standards.index.3': '估算标准创建成功',
  'auto.pages.pages.projects.estimation-standards.index.4': '保存估算标准失败',
  'auto.pages.pages.projects.estimation-standards.index.5': '标准名称',
  'auto.pages.pages.projects.estimation-standards.index.6': '范围',
  'auto.pages.pages.projects.estimation-standards.index.7': '项目级',
  'auto.pages.pages.projects.estimation-standards.index.8': '全局',
  'auto.pages.pages.projects.estimation-standards.index.9': '状态',
  'auto.pages.pages.projects.estimation-standards.index.10': '启用',
  'auto.pages.pages.projects.estimation-standards.index.11': '禁用',
  'auto.pages.pages.projects.estimation-standards.index.12': '默认',
  'auto.pages.pages.projects.estimation-standards.index.13': '默认',
  'auto.pages.pages.projects.estimation-standards.index.14': '操作',
  'auto.pages.pages.projects.estimation-standards.index.15': '详情',
  'auto.pages.pages.projects.estimation-standards.index.16': '编辑',
  'auto.pages.pages.projects.estimation-standards.index.17':
    '确认删除此估算标准吗？',
  'auto.pages.pages.projects.estimation-standards.index.18': '删除成功',
  'auto.pages.pages.projects.estimation-standards.index.19': '删除',
  'auto.pages.pages.projects.estimation-standards.index.20': '工时评估标准管理',
  'auto.pages.pages.projects.estimation-standards.index.21': '标准列表',
  'auto.pages.pages.projects.estimation-standards.index.22': '刷新',
  'auto.pages.pages.projects.estimation-standards.index.23': '新建标准',
  'auto.pages.pages.projects.estimation-standards.index.24': '编辑估算标准',
  'auto.pages.pages.projects.estimation-standards.index.25': '新建估算标准',
  'auto.pages.pages.projects.estimation-standards.index.26': '标准名称',
  'auto.pages.pages.projects.estimation-standards.index.27': '请输入标准名称',
  'auto.pages.pages.projects.estimation-standards.index.28':
    '例如：中小企业轻量HR/ERP',
  'auto.pages.pages.projects.estimation-standards.index.29': '描述',
  'auto.pages.pages.projects.estimation-standards.index.30': '版本',
  'auto.pages.pages.projects.estimation-standards.index.31': '状态',
  'auto.pages.pages.projects.estimation-standards.index.32': '启用',
  'auto.pages.pages.projects.estimation-standards.index.33': '禁用',
  'auto.pages.pages.projects.estimation-standards.index.34':
    '项目UUID（空表示全局）',
  'auto.pages.pages.projects.estimation-standards.index.35': '可选',
  'auto.pages.pages.projects.estimation-standards.index.36': '设为默认',
  'auto.pages.pages.projects.index.1': '解析用户信息失败',
  'auto.pages.pages.projects.index.2': '项目列表加载失败',
  'auto.pages.pages.projects.index.3': '项目删除成功',
  'auto.pages.pages.projects.index.4': '项目删除失败',
  'auto.pages.pages.projects.index.5': '项目更新成功',
  'auto.pages.pages.projects.index.6': '项目创建成功',
  'auto.pages.pages.projects.index.7': '编辑',
  'auto.pages.pages.projects.index.8': '确认删除该项目吗？',
  'auto.pages.pages.projects.index.9': '删除',
  'auto.pages.pages.projects.index.10': '取消',
  'auto.pages.pages.projects.index.11': '删除',
  'auto.pages.pages.projects.index.12': '前缀',
  'auto.pages.pages.projects.index.13': '创建 {p1} ｜ 更新 {p2}',
  'auto.pages.pages.projects.index.14': '创建 {p1}',
  'auto.pages.pages.projects.index.15': '更新 {p1}',
  'auto.pages.pages.projects.index.16': '项目管理',
  'auto.pages.pages.projects.index.17': '选择一个项目进入详情工作台',
  'auto.pages.pages.projects.index.18': '搜索项目名称/中文名/标识符',
  'auto.pages.pages.projects.index.19': '刷新',
  'auto.pages.pages.projects.index.20': '新建项目',
  'auto.pages.pages.projects.index.21': '暂无项目数据',
  'auto.pages.pages.projects.index.22': '共 {p1} 个项目',
  'auto.pages.pages.projects.index.23': '编辑项目',
  'auto.pages.pages.projects.index.24': '新建项目',
  'auto.pages.pages.projects.index.25': '项目中文名',
  'auto.pages.pages.projects.index.26': '请输入项目中文名',
  'auto.pages.pages.projects.index.27': '请输入项目中文名',
  'auto.pages.pages.projects.index.28': '项目英文名',
  'auto.pages.pages.projects.index.29': '请输入项目英文名',
  'auto.pages.pages.projects.index.30': '项目标识符',
  'auto.pages.pages.projects.index.31': '请输入项目标识符',
  'auto.pages.pages.projects.index.32': '该标识符已存在',
  'auto.pages.pages.projects.index.33': '例如：PROJ-001',
  'auto.pages.pages.projects.index.34': '项目前缀',
  'auto.pages.pages.projects.index.35': '例如：PROJ',
  'auto.pages.pages.projects.index.36': '项目 Logo',
  'auto.pages.pages.projects.index.37': '请输入 Logo URL',
  'auto.pages.pages.projects.index.38': '项目描述',
  'auto.pages.pages.projects.index.39': '请输入项目描述',
  'auto.pages.pages.projects.index.40': 'Batch move groups ({p1})',
  'auto.pages.pages.projects.index.41': 'Group management',
  'auto.pages.pages.projects.index.42': 'Tag management',
  'auto.pages.pages.projects.index.43': 'Keyword',
  'auto.pages.pages.projects.index.44': 'Project tags',
  'auto.pages.pages.projects.index.45': 'Please select project tags',
  'auto.pages.pages.projects.index.46': 'Sort field',
  'auto.pages.pages.projects.index.47': 'Created time',
  'auto.pages.pages.projects.index.48': 'Updated time',
  'auto.pages.pages.projects.index.49': 'Name',
  'auto.pages.pages.projects.index.50': 'Status',
  'auto.pages.pages.projects.index.51': 'Priority',
  'auto.pages.pages.projects.index.52': 'Group',
  'auto.pages.pages.projects.index.53': 'Please select a sort field',
  'auto.pages.pages.projects.index.54': 'Sort direction',
  'auto.pages.pages.projects.index.55': 'Please select a sort direction',
  'auto.pages.pages.projects.index.56': 'Expand',
  'auto.pages.pages.projects.index.57': 'Collapse',
  'auto.pages.pages.projects.index.58': 'New group',
  'auto.pages.pages.projects.index.59': 'Please enter the project name first',
  'auto.pages.pages.projects.index.60': 'Project identifier generated',
  'auto.pages.pages.projects.index.61':
    'Failed to generate the project identifier with AI. Please try again later',
  'auto.pages.pages.projects.index.62': 'AI generate identifier',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.1': '未填写',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.2':
    '加载页面设计列表失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.3': '保存成功',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.4': '保存失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.5': '示例项目',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.6':
    '一个现代化的项目管理平台',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.7':
    'AI 已识别 {p1} 个功能点，并建议了 {p2} 个页面',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.8':
    '生成页面建议失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.9':
    '页面组件方案生成完成',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.10':
    '页面组件方案生成失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.11':
    '分析结果已保存',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.12': '包含：{p1}',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.13':
    '应用分析结果失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.14':
    '获取组件详情失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.15':
    '请先分析该页面的组件方案，再查看草图',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.16':
    '生成原型草图失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.17': '删除成功',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.18': '删除失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.19':
    '请选择要导出的数据',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.20': '页面设计',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.21':
    '页面设计导出_{p1}.xlsx',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.22':
    '请选择要导出的数据',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.23':
    '# 页面设计导出\n\n| 页面名称 | 页面描述 | 核心组件概括 |\n| --- | --- | --- |\n',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.24':
    '页面设计导出_{p1}.md',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.25':
    '请选择要导出的数据',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.26':
    '页面设计方案',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.27': '页面设计',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.28': '核心组件',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.29': '核心组件',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.30':
    '页面设计导出_{p1}.xmind',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.31':
    '导出 XMind 失败',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.32': '导出 Excel',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.33':
    '导出 Markdown',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.34': '导出 XMind',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.35': '页面名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.36': '页面描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.37':
    '核心组件概括',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.38': '未分析',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.39': '操作',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.40': '分析组件',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.41': '查看草图',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.42': '编辑',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.43':
    '确定删除吗？',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.44': '删除',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.45':
    'AI 生成页面',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.46': '手工添加',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.47':
    '保存当前列表',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.48': '批量导出',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.49': '清空列表',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.50':
    'AI 辅助设计方案',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.51':
    '确认并保存到项目',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.52': '需求场景',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.53': '项目名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.54':
    '输入项目名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.55': '项目描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.56':
    '描述核心功能、目标用户...',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.57':
    '建议页面数量',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.58':
    'AI 补充指令',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.59':
    '例如：偏重移动端、采用极简风格、需要深色模式建议...',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.60':
    '开始 AI 生成',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.61':
    '建议页面列表',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.62': '页面名',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.63': '描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.64':
    '点击左侧开始生成页面方案',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.65':
    'AI 页面组件分析',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.66': '关闭',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.67':
    '应用并保存结果',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.68': '页面名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.69':
    '补充分析需求',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.70':
    '例如：分析需要包含哪些具体交互逻辑...',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.71':
    '一键分析核心组件',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.72': '组件名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.73': '组件类型',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.74': '功能描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.75':
    '页面组件详情 - {p1}',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.76': '名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.77': '类型',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.78': '描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.79':
    '页面原型草图 - {p1}',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.80': '关闭',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.81':
    '代码已复制到剪贴板',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.82': '复制代码',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.83':
    'AI 正在极速生成原型草图代码...',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.84':
    '未能生成有效代码',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.85': '编辑页面',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.86': '新增页面',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.87': '页面名称',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.88': '页面描述',
  'auto.pages.pages.prototype-design.ai-assisted-design.index.89': '组件概要',
  'auto.pages.pages.prototype-design.index.1': '项目列表页',
  'auto.pages.pages.prototype-design.index.2': '项目详情页',
  'auto.pages.pages.prototype-design.index.3': '需求文档页',
  'auto.pages.pages.prototype-design.index.4': '页面',
  'auto.pages.pages.prototype-design.index.5': '版本',
  'auto.pages.pages.prototype-design.index.6': '设计师',
  'auto.pages.pages.prototype-design.index.7': '评审时间',
  'auto.pages.pages.prototype-design.index.8': '状态',
  'auto.pages.pages.prototype-design.index.9': '草稿',
  'auto.pages.pages.prototype-design.index.10': '评审中',
  'auto.pages.pages.prototype-design.index.11': '已通过',
  'auto.pages.pages.prototype-design.index.12': '操作',
  'auto.pages.pages.prototype-design.index.13': '查看',
  'auto.pages.pages.prototype-design.index.14': '历史版本',
  'auto.pages.pages.prototype-design.index.15': '页面设计',
  'auto.pages.pages.prototype-design.index.16': '管理原型版本、评审与变更记录',
  'auto.pages.pages.prototype-design.index.17': '新建原型',
  'auto.pages.pages.prototype-design.index.18': '同步设计平台',
  'auto.pages.pages.prototype-design.theme-design.index.1': '主色',
  'auto.pages.pages.prototype-design.theme-design.index.2': '成功色',
  'auto.pages.pages.prototype-design.theme-design.index.3': '警告色',
  'auto.pages.pages.prototype-design.theme-design.index.4': '错误色',
  'auto.pages.pages.prototype-design.theme-design.index.5': '圆角',
  'auto.pages.pages.prototype-design.theme-design.index.6': '基础字号',
  'auto.pages.pages.prototype-design.theme-design.index.7': '字体',
  'auto.pages.pages.prototype-design.theme-design.index.8': '紧凑模式',
  'auto.pages.pages.prototype-design.theme-design.index.9': '启用阴影',
  'auto.pages.pages.prototype-design.theme-design.index.10':
    'Ant Design 主题配置已保存（示例）',
  'auto.pages.pages.prototype-design.theme-design.index.11': '保存主题',
  'auto.pages.pages.prototype-design.theme-design.index.12': '重置',
  'auto.pages.pages.prototype-design.theme-design.index.13': '实时预览',
  'auto.pages.pages.prototype-design.theme-design.index.14': '项目管理工作台',
  'auto.pages.pages.prototype-design.theme-design.index.15':
    '基于 Token 的主题展示，支持主色、字号、圆角与阴影开关。',
  'auto.pages.pages.prototype-design.theme-design.index.16':
    'Element Plus 变量',
  'auto.pages.pages.prototype-design.theme-design.index.17':
    '主色 --el-color-primary',
  'auto.pages.pages.prototype-design.theme-design.index.18':
    '成功色 --el-color-success',
  'auto.pages.pages.prototype-design.theme-design.index.19':
    '警告色 --el-color-warning',
  'auto.pages.pages.prototype-design.theme-design.index.20':
    '危险色 --el-color-danger',
  'auto.pages.pages.prototype-design.theme-design.index.21':
    '信息色 --el-color-info',
  'auto.pages.pages.prototype-design.theme-design.index.22':
    '圆角 --el-border-radius-base',
  'auto.pages.pages.prototype-design.theme-design.index.23':
    '字体 --el-font-family',
  'auto.pages.pages.prototype-design.theme-design.index.24': '深色菜单',
  'auto.pages.pages.prototype-design.theme-design.index.25':
    'Element Plus 主题配置已保存（示例）',
  'auto.pages.pages.prototype-design.theme-design.index.26': '保存主题',
  'auto.pages.pages.prototype-design.theme-design.index.27': '实时预览',
  'auto.pages.pages.prototype-design.theme-design.index.28':
    '使用 CSS 变量映射 Element Plus\n              主题：`--el-color-primary`、`--el-font-family` 等。',
  'auto.pages.pages.prototype-design.theme-design.index.29': '主题设计',
  'auto.pages.pages.prototype-design.theme-design.index.30':
    '辅助设计系统主题（颜色、字体、圆角等），提供 Ant Design 与 Element Plus 两套配置',
  'auto.pages.pages.prototype-design.theme-design.index.31':
    'Ant Design 主题编辑器',
  'auto.pages.pages.quality-management.index.1': '代码规范符合率',
  'auto.pages.pages.quality-management.index.2': '前端组',
  'auto.pages.pages.quality-management.index.3': '需求缺陷逃逸率',
  'auto.pages.pages.quality-management.index.4': '产品组',
  'auto.pages.pages.quality-management.index.5': '自动化测试覆盖率',
  'auto.pages.pages.quality-management.index.6': '测试组',
  'auto.pages.pages.quality-management.index.7': '指标',
  'auto.pages.pages.quality-management.index.8': '责任团队',
  'auto.pages.pages.quality-management.index.9': '得分',
  'auto.pages.pages.quality-management.index.10': '更新时间',
  'auto.pages.pages.quality-management.index.11': '趋势',
  'auto.pages.pages.quality-management.index.12': '上升',
  'auto.pages.pages.quality-management.index.13': '下降',
  'auto.pages.pages.quality-management.index.14': '持平',
  'auto.pages.pages.quality-management.index.15': '质量管理',
  'auto.pages.pages.quality-management.index.16':
    '质量度量、检查结果与持续改进闭环',
  'auto.pages.pages.quality-management.index.17': '综合质量分',
  'auto.pages.pages.quality-management.index.18': '本周新增问题',
  'auto.pages.pages.quality-management.index.19': '已关闭问题',
  'auto.pages.pages.quote-management.index.1': '华东零售集团',
  'auto.pages.pages.quote-management.index.2': '北方制造有限公司',
  'auto.pages.pages.quote-management.index.3': '华南物流科技',
  'auto.pages.pages.quote-management.index.4': '报价单号',
  'auto.pages.pages.quote-management.index.5': '客户名称',
  'auto.pages.pages.quote-management.index.6': '报价金额',
  'auto.pages.pages.quote-management.index.7': '版本',
  'auto.pages.pages.quote-management.index.8': '状态',
  'auto.pages.pages.quote-management.index.9': '草稿',
  'auto.pages.pages.quote-management.index.10': '已提交',
  'auto.pages.pages.quote-management.index.11': '已确认',
  'auto.pages.pages.quote-management.index.12': '更新时间',
  'auto.pages.pages.quote-management.index.13': '报价管理',
  'auto.pages.pages.quote-management.index.14':
    '生成报价单并跟踪报价版本与状态',
  'auto.pages.pages.quote-management.index.15': '本月报价单',
  'auto.pages.pages.quote-management.index.16': '待确认报价',
  'auto.pages.pages.quote-management.index.17': '报价转化率',
  'auto.pages.pages.quote-management.index.18': 'Channel Expansion',
  'auto.pages.pages.quote-management.index.19': 'Key Account Push',
  'auto.pages.pages.quote-management.index.20': 'Existing Customer Renewal',
  'auto.pages.pages.quote-management.index.21': 'Initial Contact',
  'auto.pages.pages.quote-management.index.22': 'Solution Review',
  'auto.pages.pages.quote-management.index.23': 'Commercial Negotiation',
  'auto.pages.pages.quote-management.index.24': 'Pipeline',
  'auto.pages.pages.quote-management.index.25': 'Stage',
  'auto.pages.pages.requirements.application-analysis.index.1': 'Web',
  'auto.pages.pages.requirements.application-analysis.index.2': 'iOS',
  'auto.pages.pages.requirements.application-analysis.index.3': 'Android',
  'auto.pages.pages.requirements.application-analysis.index.4': 'Mini Program',
  'auto.pages.pages.requirements.application-analysis.index.5': 'Desktop',
  'auto.pages.pages.requirements.application-analysis.index.6': 'Embedded',
  'auto.pages.pages.requirements.application-analysis.index.7': 'In-Vehicle',
  'auto.pages.pages.requirements.application-analysis.index.8': 'TV',
  'auto.pages.pages.requirements.application-analysis.index.9': 'IoT',
  'auto.pages.pages.requirements.application-analysis.index.10': 'Open API',
  'auto.pages.pages.requirements.application-analysis.index.11': 'Other',
  'auto.pages.pages.requirements.application-analysis.index.12':
    'Unnamed Project',
  'auto.pages.pages.requirements.application-analysis.index.13':
    'LoadApplication AnalysisFailed',
  'auto.pages.pages.requirements.application-analysis.index.14':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.application-analysis.index.15':
    'Project information saved',
  'auto.pages.pages.requirements.application-analysis.index.16':
    'Failed to save project information',
  'auto.pages.pages.requirements.application-analysis.index.17':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.application-analysis.index.18':
    'AI GenerateCompleted（referenced feature items {p1} ）, Please select',
  'auto.pages.pages.requirements.application-analysis.index.19': 'AI Failed',
  'auto.pages.pages.requirements.application-analysis.index.20':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.application-analysis.index.21':
    'Please Preview',
  'auto.pages.pages.requirements.application-analysis.index.22': 'Save {p1}',
  'auto.pages.pages.requirements.application-analysis.index.23': 'Failed',
  'auto.pages.pages.requirements.application-analysis.index.24':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.application-analysis.index.25':
    'Saved successfully',
  'auto.pages.pages.requirements.application-analysis.index.26': 'Save failed',
  'auto.pages.pages.requirements.application-analysis.index.27':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.application-analysis.index.28':
    'ClearApply Analyze',
  'auto.pages.pages.requirements.application-analysis.index.29': 'Clear failed',
  'auto.pages.pages.requirements.application-analysis.index.30': 'Not filled',
  'auto.pages.pages.requirements.application-analysis.index.31':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.32': 'Not filled',
  'auto.pages.pages.requirements.application-analysis.index.33':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.34': 'Not filled',
  'auto.pages.pages.requirements.application-analysis.index.35': 'English Name',
  'auto.pages.pages.requirements.application-analysis.index.36':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.37':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.38':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.39':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.40':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.41':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.42':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.43': 'Feature',
  'auto.pages.pages.requirements.application-analysis.index.44':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.45':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.46': 'Status',
  'auto.pages.pages.requirements.application-analysis.index.47': 'Actions',
  'auto.pages.pages.requirements.application-analysis.index.48': 'Edit',
  'auto.pages.pages.requirements.application-analysis.index.49': 'Delete',
  'auto.pages.pages.requirements.application-analysis.index.50':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.51': 'Not filled',
  'auto.pages.pages.requirements.application-analysis.index.52':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.53': 'Not filled',
  'auto.pages.pages.requirements.application-analysis.index.54':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.55':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.56':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.57':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.58':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.59':
    'Application Analysis',
  'auto.pages.pages.requirements.application-analysis.index.60':
    'Identify target clients for project "{p1}" ({p2})',
  'auto.pages.pages.requirements.application-analysis.index.61': 'AIApply',
  'auto.pages.pages.requirements.application-analysis.index.62':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.63': 'Save',
  'auto.pages.pages.requirements.application-analysis.index.64':
    'ConfirmClearCurrentProjectApply Analyze ？',
  'auto.pages.pages.requirements.application-analysis.index.65': 'Clear',
  'auto.pages.pages.requirements.application-analysis.index.66': 'Delete （',
  'auto.pages.pages.requirements.application-analysis.index.67':
    'Apply Analyze , “AIApplication Analysis” “ ”Start',
  'auto.pages.pages.requirements.application-analysis.index.68': 'EditApply',
  'auto.pages.pages.requirements.application-analysis.index.69': 'Apply',
  'auto.pages.pages.requirements.application-analysis.index.70':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.71': 'Cancel',
  'auto.pages.pages.requirements.application-analysis.index.72': '（Medium ）',
  'auto.pages.pages.requirements.application-analysis.index.73': 'please enter',
  'auto.pages.pages.requirements.application-analysis.index.74':
    'Example: Web 、iOS 、',
  'auto.pages.pages.requirements.application-analysis.index.75':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.76':
    'please select',
  'auto.pages.pages.requirements.application-analysis.index.77':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.78': '（ ）',
  'auto.pages.pages.requirements.application-analysis.index.79':
    'Example: Web Admin Console',
  'auto.pages.pages.requirements.application-analysis.index.80':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.81': 'Example: WAC',
  'auto.pages.pages.requirements.application-analysis.index.82':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.83':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.84':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.85': 'row /',
  'auto.pages.pages.requirements.application-analysis.index.86':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.87':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.88': 'Feature',
  'auto.pages.pages.requirements.application-analysis.index.89':
    'Translated text',
  'auto.pages.pages.requirements.application-analysis.index.90':
    'Example: MVP、Phase-2',
  'auto.pages.pages.requirements.application-analysis.index.91': 'Status',
  'auto.pages.pages.requirements.application-analysis.index.92': 'AI Apply',
  'auto.pages.pages.requirements.application-analysis.index.93': 'items',
  'auto.pages.pages.requirements.application-analysis.index.94': 'Project Name',
  'auto.pages.pages.requirements.application-analysis.index.95':
    'Please enter project name',
  'auto.pages.pages.requirements.application-analysis.index.96':
    'Please enter project name',
  'auto.pages.pages.requirements.application-analysis.index.97':
    'Project Description',
  'auto.pages.pages.requirements.application-analysis.index.98':
    'Please enter project description',
  'auto.pages.pages.requirements.application-analysis.index.99':
    'Prompt （ Generate）',
  'auto.pages.pages.requirements.application-analysis.index.100':
    'Example: 、 、',
  'auto.pages.pages.requirements.application-analysis.index.101':
    'Breakdown Count',
  'auto.pages.pages.requirements.application-analysis.index.102':
    'Please enter breakdown count',
  'auto.pages.pages.requirements.application-analysis.index.103':
    'CountScope 1-20',
  'auto.pages.pages.requirements.application-analysis.index.104':
    'Feature List（ Project Feature List）',
  'auto.pages.pages.requirements.application-analysis.index.105':
    'Save Project Info',
  'auto.pages.pages.requirements.application-analysis.index.106': 'Cancel',
  'auto.pages.pages.requirements.application-analysis.index.107': 'Preview',
  'auto.pages.pages.requirements.application-analysis.index.108': 'Preview',
  'auto.pages.pages.requirements.application-analysis.index.109': 'Column',
  'auto.pages.pages.requirements.application-analysis.index.110':
    '“GeneratePreview”',
  'auto.pages.pages.requirements.application-analysis.index.111': 'Details',
  'auto.pages.pages.requirements.application-analysis.index.112':
    'Medium Column （',
  'auto.pages.pages.requirements.application-analysis.index.113':
    'Please enter at least one app name (one per line)',
  'auto.pages.pages.requirements.application-analysis.index.114':
    'Generated {p1} app preview items from manual input',
  'auto.pages.pages.requirements.application-analysis.index.115':
    'Breakdown mode: as many as possible (max 20)',
  'auto.pages.pages.requirements.application-analysis.index.116':
    'Breakdown mode: specified count ({p1})',
  'auto.pages.pages.requirements.application-analysis.index.117':
    'Breakdown mode',
  'auto.pages.pages.requirements.application-analysis.index.118':
    'A. As many as possible',
  'auto.pages.pages.requirements.application-analysis.index.119':
    'B. Specified count',
  'auto.pages.pages.requirements.application-analysis.index.120':
    'C. Manual input',
  'auto.pages.pages.requirements.application-analysis.index.121':
    'Manual input',
  'auto.pages.pages.requirements.application-analysis.index.122':
    'Please enter manual app list',
  'auto.pages.pages.requirements.application-analysis.index.123':
    'One app name per line',
  'auto.pages.pages.requirements.application-analysis.index.124':
    'Example:\nWeb Admin Console\niOS App\nMini Program',
  'auto.pages.pages.requirements.application-analysis.index.125':
    'Optional: provide extra guidance to improve AI breakdown',
  'auto.pages.pages.requirements.application-analysis.index.126':
    'Project info (optional)',
  'auto.pages.pages.requirements.application-analysis.index.127':
    'Preview Manual Input',
  'auto.pages.pages.requirements.application-analysis.index.128':
    'Reference materials (optional)',
  'auto.pages.pages.requirements.application-analysis.index.129':
    'Paste background notes, constraints, or historical examples to improve AI breakdown quality',
  'auto.pages.pages.requirements.application-analysis.index.130':
    'Example:\n- Terminal policy: Web first for admin, mobile first for field users\n- Benchmark: System X uses Web + App + Mini Program collaboration',
  'auto.pages.pages.requirements.application-analysis.index.131': 'Delete',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.1': 'Project',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.2':
    'Requirement、Apply',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.3': 'Apply',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.4':
    'Project Feature',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.5':
    'Requirement',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.6':
    'Requirement',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.7':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.8': 'Low',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.9':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index-copy-2.10':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.1': 'Project',
  'auto.pages.pages.requirements.concept-analysis.index.2': 'Load Failed',
  'auto.pages.pages.requirements.concept-analysis.index.3':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.concept-analysis.index.4': 'Project Save',
  'auto.pages.pages.requirements.concept-analysis.index.5':
    'Save Project InfoFailed',
  'auto.pages.pages.requirements.concept-analysis.index.6':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.concept-analysis.index.7':
    'AI GenerateCompleted（referenced feature items {p1} ）, Please select',
  'auto.pages.pages.requirements.concept-analysis.index.8': 'AI Failed',
  'auto.pages.pages.requirements.concept-analysis.index.9':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.concept-analysis.index.10': 'Please Preview',
  'auto.pages.pages.requirements.concept-analysis.index.11': 'Save {p1}',
  'auto.pages.pages.requirements.concept-analysis.index.12': 'Failed',
  'auto.pages.pages.requirements.concept-analysis.index.13':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.concept-analysis.index.14':
    'Saved successfully',
  'auto.pages.pages.requirements.concept-analysis.index.15': 'Save failed',
  'auto.pages.pages.requirements.concept-analysis.index.16':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.concept-analysis.index.17': 'Clear',
  'auto.pages.pages.requirements.concept-analysis.index.18': 'Clear failed',
  'auto.pages.pages.requirements.concept-analysis.index.19': 'Not filled',
  'auto.pages.pages.requirements.concept-analysis.index.20': 'Chinese Name',
  'auto.pages.pages.requirements.concept-analysis.index.21': 'Not filled',
  'auto.pages.pages.requirements.concept-analysis.index.22': 'English Name',
  'auto.pages.pages.requirements.concept-analysis.index.23': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.24': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.25': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.26': 'FeatureScope',
  'auto.pages.pages.requirements.concept-analysis.index.27': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.28': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.29': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.30': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.31': 'Status',
  'auto.pages.pages.requirements.concept-analysis.index.32': 'Actions',
  'auto.pages.pages.requirements.concept-analysis.index.33': 'Edit',
  'auto.pages.pages.requirements.concept-analysis.index.34': 'Delete',
  'auto.pages.pages.requirements.concept-analysis.index.35': 'Chinese Name',
  'auto.pages.pages.requirements.concept-analysis.index.36': 'Not filled',
  'auto.pages.pages.requirements.concept-analysis.index.37': 'English Name',
  'auto.pages.pages.requirements.concept-analysis.index.38': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.39': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.40': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.41': 'FeatureScope',
  'auto.pages.pages.requirements.concept-analysis.index.42': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.43': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.44': 'Project“{p1}”',
  'auto.pages.pages.requirements.concept-analysis.index.45': 'AI',
  'auto.pages.pages.requirements.concept-analysis.index.46': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.47': 'Save',
  'auto.pages.pages.requirements.concept-analysis.index.48':
    'ConfirmClearCurrentProject ？',
  'auto.pages.pages.requirements.concept-analysis.index.49': 'Clear',
  'auto.pages.pages.requirements.concept-analysis.index.50': 'Delete （',
  'auto.pages.pages.requirements.concept-analysis.index.51':
    'Concept Analysis , “AIConcept Analysis” “ ”Start',
  'auto.pages.pages.requirements.concept-analysis.index.52': 'Edit',
  'auto.pages.pages.requirements.concept-analysis.index.53': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.54': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.55': 'Cancel',
  'auto.pages.pages.requirements.concept-analysis.index.56': 'Chinese Name',
  'auto.pages.pages.requirements.concept-analysis.index.57':
    'please enter Chinese Name',
  'auto.pages.pages.requirements.concept-analysis.index.58':
    'Example: Requirement',
  'auto.pages.pages.requirements.concept-analysis.index.59': 'English Name',
  'auto.pages.pages.requirements.concept-analysis.index.60':
    'Example: Requirement Item',
  'auto.pages.pages.requirements.concept-analysis.index.61': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.62': 'Example: RI',
  'auto.pages.pages.requirements.concept-analysis.index.63': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.64': 'please enter',
  'auto.pages.pages.requirements.concept-analysis.index.65': '（ ）',
  'auto.pages.pages.requirements.concept-analysis.index.66': 'FeatureScope',
  'auto.pages.pages.requirements.concept-analysis.index.67': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.68': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.69': 'Translated text',
  'auto.pages.pages.requirements.concept-analysis.index.70': '（ ）',
  'auto.pages.pages.requirements.concept-analysis.index.71': 'Status',
  'auto.pages.pages.requirements.concept-analysis.index.72': 'AI',
  'auto.pages.pages.requirements.concept-analysis.index.73': 'items',
  'auto.pages.pages.requirements.concept-analysis.index.74': 'Project Name',
  'auto.pages.pages.requirements.concept-analysis.index.75':
    'Please enter project name',
  'auto.pages.pages.requirements.concept-analysis.index.76':
    'Please enter project name',
  'auto.pages.pages.requirements.concept-analysis.index.77':
    'Project Description',
  'auto.pages.pages.requirements.concept-analysis.index.78':
    'Please enter project description',
  'auto.pages.pages.requirements.concept-analysis.index.79':
    'Prompt （ Generate）',
  'auto.pages.pages.requirements.concept-analysis.index.80': 'Example: 、',
  'auto.pages.pages.requirements.concept-analysis.index.81': 'Breakdown Count',
  'auto.pages.pages.requirements.concept-analysis.index.82':
    'Please enter breakdown count',
  'auto.pages.pages.requirements.concept-analysis.index.83': 'CountScope 1-50',
  'auto.pages.pages.requirements.concept-analysis.index.84':
    'Feature List（ Project Feature List）',
  'auto.pages.pages.requirements.concept-analysis.index.85':
    'Save Project Info',
  'auto.pages.pages.requirements.concept-analysis.index.86': 'Cancel',
  'auto.pages.pages.requirements.concept-analysis.index.87': 'Preview',
  'auto.pages.pages.requirements.concept-analysis.index.88': 'Preview',
  'auto.pages.pages.requirements.concept-analysis.index.89': 'Column',
  'auto.pages.pages.requirements.concept-analysis.index.90':
    '“GeneratePreview”',
  'auto.pages.pages.requirements.concept-analysis.index.91': 'Details',
  'auto.pages.pages.requirements.concept-analysis.index.92': 'Medium Column （',
  'auto.pages.pages.requirements.document.index.1': 'Requirement',
  'auto.pages.pages.requirements.document.index.2': 'Requirement',
  'auto.pages.pages.requirements.document.index.3': 'Translated text',
  'auto.pages.pages.requirements.document.index.4': 'Project111',
  'auto.pages.pages.requirements.document.index.5': 'Translated text',
  'auto.pages.pages.requirements.document.index.6': 'Translated text',
  'auto.pages.pages.requirements.document.index.7': 'Translated text',
  'auto.pages.pages.requirements.document.index.8': 'Translated text',
  'auto.pages.pages.requirements.document.index.9': 'Project',
  'auto.pages.pages.requirements.document.index.10': 'Translated text',
  'auto.pages.pages.requirements.document.index.11': 'Translated text',
  'auto.pages.pages.requirements.document.index.12': 'Translated text',
  'auto.pages.pages.requirements.document.index.13': 'Status',
  'auto.pages.pages.requirements.document.index.14': 'Translated text',
  'auto.pages.pages.requirements.document.index.15': 'Translated text',
  'auto.pages.pages.requirements.document.index.16': 'RequirementConfirm',
  'auto.pages.pages.requirements.document.index.17': 'Confirm',
  'auto.pages.pages.requirements.document.index.18':
    'CompletedRequirementScopeConfirm',
  'auto.pages.pages.requirements.document.index.19': 'Translated text',
  'auto.pages.pages.requirements.document.index.20': 'Translated text',
  'auto.pages.pages.requirements.document.index.21': 'Translated text',
  'auto.pages.pages.requirements.document.index.22': 'Translated text',
  'auto.pages.pages.requirements.document.index.23': 'Translated text',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.1':
    'LoadMind Map Failed',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.2':
    'LoadMind Map Failed',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.3':
    'FeatureRequirement',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.4':
    'Title cannot be empty',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.5':
    'Update',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.6':
    'Update Failed',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.7':
    'Update Failed',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.8':
    'Details',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.9':
    'Details',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.10':
    'Edit',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.11':
    'Title',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.12':
    'please enter Title',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.13':
    'please enter Title',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.14':
    'Description',
  'auto.component.pages.requirements.feature-list.components.RequirementMindMapView.15':
    'please enter Description',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.1':
    'Completed',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.2':
    'In Progress',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.3':
    'Draft',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.4':
    'Load Failed',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.5':
    'Load Failed',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.6':
    'LoadFeature Point TypeFailed:',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.7':
    'LoadEstimation StandardParametersFailed:',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.8':
    'Module',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.9':
    'Feature',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.10':
    'Feature Point',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.11':
    'Feature Point Type',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.12':
    'Feature PointComplexity',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.13':
    'EstimatedHours',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.14':
    'Description',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.15':
    'Status',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.16':
    'Draft',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.17':
    'In Progress',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.18':
    'Confirmed',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.19':
    'Completed',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.20':
    'StatusOnly supports: Draft/In Progress/Completed（ 0/1/2）',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.21':
    'Feature Point EditEstimatedHours',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.22':
    'EstimatedHours',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.23':
    'SaveFailed {p1}  items',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.24':
    'Save',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.25':
    'Feature Point EditFeature Point Type Complexity',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.26':
    'Update',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.27':
    'Failed to update',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.28':
    'Title cannot be empty',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.29':
    'Please Medium row',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.30':
    'row Save',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.31':
    'rowFailed',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.32':
    'rowFailed',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.33':
    'Please Medium row',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.34':
    'Medium items',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.35':
    'ConfirmDelete',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.36':
    'Delete“{p1}” ？',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.37':
    'DeleteSuccess',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.38':
    'Please Medium row',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.39':
    'Medium items',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.40':
    '{p1}（ ）',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.41':
    'Succeeded',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.42':
    'Failed',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.43':
    'Failed',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.44':
    'Module row',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.45':
    'Medium items level',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.46':
    'Medium items level',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.47':
    'row',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.48':
    'Delete row',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.49':
    'Load',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.50':
    'Current Requirement',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.51':
    'row',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.52':
    'Delete row',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.53':
    'High',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.54':
    'Module row',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.55':
    'Medium items level',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.56':
    'Medium items level',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.57':
    'Title',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.58':
    'please enter Title',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.59':
    'please enter Requirement ItemTitle',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.60':
    'Description',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.61':
    'please enter Requirement ItemDescription',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.62':
    'EditFeature Point Type',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.63':
    'EditComplexity',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.64':
    'please select Feature Point Type',
  'auto.component.pages.requirements.feature-list.components.RequirementTableView.65':
    'please select Complexity',
  'auto.pages.pages.requirements.feature-list.index.1': 'Completed',
  'auto.pages.pages.requirements.feature-list.index.2': 'In Progress',
  'auto.pages.pages.requirements.feature-list.index.3': 'Draft',
  'auto.pages.pages.requirements.feature-list.index.4': 'Module',
  'auto.pages.pages.requirements.feature-list.index.5': 'Sub-module',
  'auto.pages.pages.requirements.feature-list.index.6': 'Feature',
  'auto.pages.pages.requirements.feature-list.index.7': 'Sub-feature',
  'auto.pages.pages.requirements.feature-list.index.8': 'Feature Point',
  'auto.pages.pages.requirements.feature-list.index.9': 'Task',
  'auto.pages.pages.requirements.feature-list.index.10': 'Translated text',
  'auto.pages.pages.requirements.feature-list.index.11': 'Title',
  'auto.pages.pages.requirements.feature-list.index.12': 'Translated text',
  'auto.pages.pages.requirements.feature-list.index.13': 'Translated text',
  'auto.pages.pages.requirements.feature-list.index.14': 'Translated text',
  'auto.pages.pages.requirements.feature-list.index.15': 'Translated text',
  'auto.pages.pages.requirements.feature-list.index.16': 'Project',
  'auto.pages.pages.requirements.feature-list.index.17': 'Module',
  'auto.pages.pages.requirements.feature-list.index.18': 'Level-1Module',
  'auto.pages.pages.requirements.feature-list.index.19': 'Module',
  'auto.pages.pages.requirements.feature-list.index.20': 'Feature',
  'auto.pages.pages.requirements.feature-list.index.21': 'Feature',
  'auto.pages.pages.requirements.feature-list.index.22': 'Feature',
  'auto.pages.pages.requirements.feature-list.index.23': 'Feature Point',
  'auto.pages.pages.requirements.feature-list.index.24': 'Feature Point',
  'auto.pages.pages.requirements.feature-list.index.25': 'Feature Point',
  'auto.pages.pages.requirements.feature-list.index.26': 'ModuleDescription',
  'auto.pages.pages.requirements.feature-list.index.27':
    'Level-1ModuleDescription',
  'auto.pages.pages.requirements.feature-list.index.28': 'FeatureDescription',
  'auto.pages.pages.requirements.feature-list.index.29':
    'levelFeatureDescription',
  'auto.pages.pages.requirements.feature-list.index.30':
    'Feature PointDescription',
  'auto.pages.pages.requirements.feature-list.index.31':
    'levelFeature PointDescription',
  'auto.pages.pages.requirements.feature-list.index.32': 'Description',
  'auto.pages.pages.requirements.feature-list.index.33': 'Translated text',
  'auto.pages.pages.requirements.feature-list.index.34': 'FeatureRequirement',
  'auto.pages.pages.requirements.feature-list.index.35':
    'LoadFeature Point Type Failed',
  'auto.pages.pages.requirements.feature-list.index.36':
    'LoadEstimation StandardFailed:',
  'auto.pages.pages.requirements.feature-list.index.37':
    'Please select an estimation standard first',
  'auto.pages.pages.requirements.feature-list.index.38':
    'Estimate items Feature Point Hours, HoursEstimate, rowFeatureBreakdown',
  'auto.pages.pages.requirements.feature-list.index.39':
    'EstimateChildFeature PointHours: Succeeded {p1}, Failed {p2}, {p3}',
  'auto.pages.pages.requirements.feature-list.index.40':
    'ChildFeature PointEstimateFailed:',
  'auto.pages.pages.requirements.feature-list.index.41':
    'ChildFeature PointEstimateFailed',
  'auto.pages.pages.requirements.feature-list.index.42':
    'Feature Point itemsHoursEstimate',
  'auto.pages.pages.requirements.feature-list.index.43':
    'Estimate: {p1} = {p2}h（{p3} / L{p4}）',
  'auto.pages.pages.requirements.feature-list.index.44': 'items',
  'auto.pages.pages.requirements.feature-list.index.45': 'itemsEstimateFailed',
  'auto.pages.pages.requirements.feature-list.index.46':
    'itemsHoursEstimateFailed',
  'auto.pages.pages.requirements.feature-list.index.47':
    'itemsHoursEstimateFailed',
  'auto.pages.pages.requirements.feature-list.index.48':
    'Please create a requirement list first',
  'auto.pages.pages.requirements.feature-list.index.49':
    'Please select an estimation standard first',
  'auto.pages.pages.requirements.feature-list.index.50':
    'Please select a module on the page first',
  'auto.pages.pages.requirements.feature-list.index.51':
    'Please select a feature on the page first',
  'auto.pages.pages.requirements.feature-list.index.52': 'Estimate...',
  'auto.pages.pages.requirements.feature-list.index.53': 'Estimating......',
  'auto.pages.pages.requirements.feature-list.index.54':
    'Estimate Feature Point',
  'auto.pages.pages.requirements.feature-list.index.55':
    'BatchEstimate itemsFailed',
  'auto.pages.pages.requirements.feature-list.index.56':
    'BatchEstimateCompleted: Succeeded {p1}, Failed {p2}, {p3}',
  'auto.pages.pages.requirements.feature-list.index.57': 'Load Failed:',
  'auto.pages.pages.requirements.feature-list.index.58': 'LoadProject Failed',
  'auto.pages.pages.requirements.feature-list.index.59':
    'Read Requirement ListFailed',
  'auto.pages.pages.requirements.feature-list.index.60': 'URL Requirement List',
  'auto.pages.pages.requirements.feature-list.index.61':
    'LoadFeature ListFailed:',
  'auto.pages.pages.requirements.feature-list.index.62':
    'LoadFeature ListFailed',
  'auto.pages.pages.requirements.feature-list.index.63': '[Default]',
  'auto.pages.pages.requirements.feature-list.index.64':
    'MissingProjectID, CreateList',
  'auto.pages.pages.requirements.feature-list.index.65': 'Project',
  'auto.pages.pages.requirements.feature-list.index.66':
    'Please select a list first',
  'auto.pages.pages.requirements.feature-list.index.67':
    'MissingProjectID, SaveList',
  'auto.pages.pages.requirements.feature-list.index.68':
    'Please select a list first',
  'auto.pages.pages.requirements.feature-list.index.69':
    'Please enter List Version',
  'auto.pages.pages.requirements.feature-list.index.70': 'ListCreateSuccess',
  'auto.pages.pages.requirements.feature-list.index.71': 'ListUpdateSuccess',
  'auto.pages.pages.requirements.feature-list.index.72':
    'SaveRequirement ListFailed:',
  'auto.pages.pages.requirements.feature-list.index.73':
    'SaveRequirement ListFailed',
  'auto.pages.pages.requirements.feature-list.index.74':
    'SwitchRequirement ListFailed:',
  'auto.pages.pages.requirements.feature-list.index.75':
    'SwitchRequirement ListFailed',
  'auto.pages.pages.requirements.feature-list.index.76':
    'CurrentList DefaultList',
  'auto.pages.pages.requirements.feature-list.index.77': 'DefaultList',
  'auto.pages.pages.requirements.feature-list.index.78': 'DefaultListFailed',
  'auto.pages.pages.requirements.feature-list.index.79': 'DefaultListFailed',
  'auto.pages.pages.requirements.feature-list.index.80':
    'DefaultList Delete, Please Switch List Default',
  'auto.pages.pages.requirements.feature-list.index.81': 'ListDeleteSuccess',
  'auto.pages.pages.requirements.feature-list.index.82': 'DeleteListFailed:',
  'auto.pages.pages.requirements.feature-list.index.83': 'DeleteListFailed',
  'auto.pages.pages.requirements.feature-list.index.84':
    'LoadFeatureColumn Failed',
  'auto.pages.pages.requirements.feature-list.index.85':
    'LoadFeatureColumn Failed',
  'auto.pages.pages.requirements.feature-list.index.86':
    'LoadFeature PointColumn Failed',
  'auto.pages.pages.requirements.feature-list.index.87':
    'LoadFeature PointColumn Failed',
  'auto.pages.pages.requirements.feature-list.index.88':
    'Please create a requirement list first',
  'auto.pages.pages.requirements.feature-list.index.89':
    'ClearCompleted: Delete {p1}  items',
  'auto.pages.pages.requirements.feature-list.index.90': 'ScopeClear failed',
  'auto.pages.pages.requirements.feature-list.index.91': 'Failed to clear',
  'auto.pages.pages.requirements.feature-list.index.92':
    'DeleteScope Requirement Item Child, Delete This action cannot be undone',
  'auto.pages.pages.requirements.feature-list.index.93': 'Clear',
  'auto.pages.pages.requirements.feature-list.index.94': 'Cancel',
  'auto.pages.pages.requirements.feature-list.index.95':
    'Missing project information',
  'auto.pages.pages.requirements.feature-list.index.96':
    'Project name cannot be empty',
  'auto.pages.pages.requirements.feature-list.index.97': 'Project Save',
  'auto.pages.pages.requirements.feature-list.index.98':
    'Save Project InfoFailed:',
  'auto.pages.pages.requirements.feature-list.index.99':
    'Save Project InfoFailed',
  'auto.pages.pages.requirements.feature-list.index.100':
    'Missing requirement list information',
  'auto.pages.pages.requirements.feature-list.index.101':
    'Feature point level does not support further breakdown',
  'auto.pages.pages.requirements.feature-list.index.102':
    'Currently only supports breakdown to feature-point level',
  'auto.pages.pages.requirements.feature-list.index.103':
    'Please enter at least one line in manual input first',
  'auto.pages.pages.requirements.feature-list.index.104': '{p1} Child',
  'auto.pages.pages.requirements.feature-list.index.105':
    'Project Name: {p1}\\nProject Description: {p2}',
  'auto.pages.pages.requirements.feature-list.index.106':
    'Identify 1-3 core business objects first, then split CRUD into 4 independent feature items (create/read/update/delete separately; never merge as "XX CRUD"). After that, extend with process/governance capabilities (workflow, analytics, import/export, permission, audit, notification). For non-CRUD modules (dashboard/reporting/monitoring/workbench), switch to: config-query-analysis-export-subscription/alert-audit.\\\\n{p1}',
  'auto.pages.pages.requirements.feature-list.index.107': 'AIBreakdownFailed',
  'auto.pages.pages.requirements.feature-list.index.108': 'AIBreakdownFailed',
  'auto.pages.pages.requirements.feature-list.index.109':
    'AI breakdown returned no result',
  'auto.pages.pages.requirements.feature-list.index.110':
    'SucceededBreakdown {p1} Requirement Item',
  'auto.pages.pages.requirements.feature-list.index.111':
    'AIBreakdown completed',
  'auto.pages.pages.requirements.feature-list.index.112':
    'Missing requirement list information',
  'auto.pages.pages.requirements.feature-list.index.113':
    'No breakdown results to confirm',
  'auto.pages.pages.requirements.feature-list.index.114': 'BreakdownSuccess',
  'auto.pages.pages.requirements.feature-list.index.115':
    'Not generated Save Requirement Item',
  'auto.pages.pages.requirements.feature-list.index.116':
    'SuccessApply {p1} Breakdown Results',
  'auto.pages.pages.requirements.feature-list.index.117':
    'ApplyBreakdown ResultsFailed:',
  'auto.pages.pages.requirements.feature-list.index.118':
    'SaveBreakdown ResultsFailed',
  'auto.pages.pages.requirements.feature-list.index.119':
    'Please select a requirement list first',
  'auto.pages.pages.requirements.feature-list.index.120': 'Module',
  'auto.pages.pages.requirements.feature-list.index.121': 'Feature',
  'auto.pages.pages.requirements.feature-list.index.122': 'Feature Point',
  'auto.pages.pages.requirements.feature-list.index.123': 'Description',
  'auto.pages.pages.requirements.feature-list.index.124': 'Feature Point',
  'auto.pages.pages.requirements.feature-list.index.125': 'HoursEstimated',
  'auto.pages.pages.requirements.feature-list.index.126': 'Status',
  'auto.pages.pages.requirements.feature-list.index.127': 'Feature List',
  'auto.pages.pages.requirements.feature-list.index.128':
    'Feature List-{p1}.xlsx',
  'auto.pages.pages.requirements.feature-list.index.129':
    'Excel exported successfully',
  'auto.pages.pages.requirements.feature-list.index.130': 'ExportExcelFailed:',
  'auto.pages.pages.requirements.feature-list.index.131': 'ExportExcelFailed',
  'auto.pages.pages.requirements.feature-list.index.132':
    'Please select a requirement list first',
  'auto.pages.pages.requirements.feature-list.index.133':
    'Feature List-{p1}.xmind',
  'auto.pages.pages.requirements.feature-list.index.134':
    'Mind map exported successfully',
  'auto.pages.pages.requirements.feature-list.index.135':
    'ExportMind MapFailed:',
  'auto.pages.pages.requirements.feature-list.index.136':
    'ExportMind MapFailed',
  'auto.pages.pages.requirements.feature-list.index.137':
    'Please select a requirement list first',
  'auto.pages.pages.requirements.feature-list.index.138':
    '\\n <html>\\n <head>\\n <meta charset="UTF-8">\\n <style>\\n body {{\\n font-family: "Microsoft YaHei", " ", sans-serif;\\n font-size: 14pt; /* */\\n line-height: 1.75;\\n color: #111;\\n }}\\n h1, h2, h3, h4 {{\\n font-family: "Microsoft YaHei", " ", sans-serif;\\n font-weight: 700;\\n margin: 16pt 0 8pt 0;\\n text-indent: 0;\\n line-height: 1.4;\\n }}\\n h1 {{ font-size: 22pt; }}\\n h2 {{ font-size: 18pt; }}\\n h3 {{ font-size: 16pt; }}\\n h4 {{ font-size: 15pt; }}\\n p {{\\n margin: 6pt 0;\\n text-indent: 2em;\\n font-size: 14pt;\\n line-height: 150%;\\n mso-line-height-rule: exactly;\\n mso-line-height-alt: 150%;\\n text-align: justify;\\n text-justify: inter-ideograph;\\n }}\\n </style>\\n </head>\\n <body>\\n <h1>FeatureRequirement</h1>\\n {p1}\\n </body>\\n </html>',
  'auto.pages.pages.requirements.feature-list.index.139':
    'Feature List-{p1}.doc',
  'auto.pages.pages.requirements.feature-list.index.140':
    'Word exported successfully',
  'auto.pages.pages.requirements.feature-list.index.141': 'ExportWordFailed:',
  'auto.pages.pages.requirements.feature-list.index.142': 'ExportWordFailed',
  'auto.pages.pages.requirements.feature-list.index.143': 'Read Failed',
  'auto.pages.pages.requirements.feature-list.index.144': '{p1} Column - {p2}',
  'auto.pages.pages.requirements.feature-list.index.145': '( )',
  'auto.pages.pages.requirements.feature-list.index.146':
    'Please create and select a requirement list first',
  'auto.pages.pages.requirements.feature-list.index.147': 'Draft',
  'auto.pages.pages.requirements.feature-list.index.148': 'In Progress',
  'auto.pages.pages.requirements.feature-list.index.149': 'Confirmed',
  'auto.pages.pages.requirements.feature-list.index.150': 'Completed',
  'auto.pages.pages.requirements.feature-list.index.151':
    'ImportCompleted: Module {p1}, Feature {p2}, Feature Point {p3}, DescriptionUpdate {p4}（ {p5}）, row {p6}, MissingModule {p7}, row {p8}',
  'auto.pages.pages.requirements.feature-list.index.152': 'ExcelImport failed:',
  'auto.pages.pages.requirements.feature-list.index.153': 'ExcelImport failed',
  'auto.pages.pages.requirements.feature-list.index.154':
    'Please create and select a requirement list first',
  'auto.pages.pages.requirements.feature-list.index.155':
    'Only .xlsx / .xls files are supported',
  'auto.pages.pages.requirements.feature-list.index.156':
    'No importable data found in the Excel file',
  'auto.pages.pages.requirements.feature-list.index.157': 'ReadExcelFailed:',
  'auto.pages.pages.requirements.feature-list.index.158': 'ReadExcelFailed',
  'auto.pages.pages.requirements.feature-list.index.159':
    'Please upload an Excel file first',
  'auto.pages.pages.requirements.feature-list.index.160':
    'Ignored row count is out of range. Adjust and retry.',
  'auto.pages.pages.requirements.feature-list.index.161':
    'Please configure module column mapping first',
  'auto.pages.pages.requirements.feature-list.index.162':
    'No importable data found in the Excel file',
  'auto.pages.pages.requirements.feature-list.index.163':
    'Title cannot be empty',
  'auto.pages.pages.requirements.feature-list.index.164':
    'Requirement Item Update',
  'auto.pages.pages.requirements.feature-list.index.165':
    'UpdateRequirement ItemFailed:',
  'auto.pages.pages.requirements.feature-list.index.166':
    'UpdateRequirement ItemFailed',
  'auto.pages.pages.requirements.feature-list.index.167': 'SortUpdateSuccess',
  'auto.pages.pages.requirements.feature-list.index.168':
    'SortFailed to update:',
  'auto.pages.pages.requirements.feature-list.index.169':
    'SortFailed to update',
  'auto.pages.pages.requirements.feature-list.index.170':
    'Title cannot be empty',
  'auto.pages.pages.requirements.feature-list.index.171': 'Requirement Item',
  'auto.pages.pages.requirements.feature-list.index.172': 'Failed:',
  'auto.pages.pages.requirements.feature-list.index.173': 'Failed',
  'auto.pages.pages.requirements.feature-list.index.174':
    'Missing requirement list information',
  'auto.pages.pages.requirements.feature-list.index.175':
    'Please select a module, or choose "All project features" in the dialog',
  'auto.pages.pages.requirements.feature-list.index.176':
    'No break-downable requirement items in current column',
  'auto.pages.pages.requirements.feature-list.index.177':
    'Feature point level does not support further breakdown',
  'auto.pages.pages.requirements.feature-list.index.178':
    'Currently only supports breakdown to feature-point level',
  'auto.pages.pages.requirements.feature-list.index.179':
    'Split CRUD into independent feature items by core business object (create/read/update/delete separately; no "XX CRUD" merged naming), then add process/governance capabilities. For non-CRUD modules, use: config-query-analysis-export-subscription/alert-audit and state the reason in description.',
  'auto.pages.pages.requirements.feature-list.index.180': 'AIBreakdownFailed',
  'auto.pages.pages.requirements.feature-list.index.181':
    'AI breakdown returned no result',
  'auto.pages.pages.requirements.feature-list.index.182': 'BreakdownSuccess',
  'auto.pages.pages.requirements.feature-list.index.183':
    'Not generated Save Requirement Item',
  'auto.pages.pages.requirements.feature-list.index.184':
    'BatchBreakdownFailed: {p1}',
  'auto.pages.pages.requirements.feature-list.index.185':
    'BatchBreakdown completed: Success {p1}  items, Failed {p2}  items',
  'auto.pages.pages.requirements.feature-list.index.186':
    'Missing requirement list information',
  'auto.pages.pages.requirements.feature-list.index.187':
    'Delete {p1} Requirement Item（ Child）',
  'auto.pages.pages.requirements.feature-list.index.188':
    'DeleteRequirement ItemFailed:',
  'auto.pages.pages.requirements.feature-list.index.189':
    'DeleteRequirement ItemFailed',
  'auto.pages.pages.requirements.feature-list.index.190': 'Delete「{p1}」？',
  'auto.pages.pages.requirements.feature-list.index.191':
    'Delete items ChildRequirement Item, Delete This action cannot be undone',
  'auto.pages.pages.requirements.feature-list.index.192': 'Delete',
  'auto.pages.pages.requirements.feature-list.index.193': 'Cancel',
  'auto.pages.pages.requirements.feature-list.index.194': 'Feature :',
  'auto.pages.pages.requirements.feature-list.index.195': 'Complexity Level: L',
  'auto.pages.pages.requirements.feature-list.index.196': 'EstimatedHours:',
  'auto.pages.pages.requirements.feature-list.index.197': 'Move to Top',
  'auto.pages.pages.requirements.feature-list.index.198': 'Move Up',
  'auto.pages.pages.requirements.feature-list.index.199': 'Move Down',
  'auto.pages.pages.requirements.feature-list.index.200': 'Move to Bottom',
  'auto.pages.pages.requirements.feature-list.index.201': 'Delete',
  'auto.pages.pages.requirements.feature-list.index.202': 'Estimate',
  'auto.pages.pages.requirements.feature-list.index.203': 'Translated text',
  'auto.pages.pages.requirements.feature-list.index.204': 'Breakdown',
  'auto.pages.pages.requirements.feature-list.index.205': 'Feature List',
  'auto.pages.pages.requirements.feature-list.index.206':
    'AnalyzeProject FeatureRequirement , levelBreakdown Feature',
  'auto.pages.pages.requirements.feature-list.index.207': 'Feature List',
  'auto.pages.pages.requirements.feature-list.index.208': 'CreateList',
  'auto.pages.pages.requirements.feature-list.index.209': 'Module :',
  'auto.pages.pages.requirements.feature-list.index.210': 'BreakdownModule:',
  'auto.pages.pages.requirements.feature-list.index.211': 'Feature :',
  'auto.pages.pages.requirements.feature-list.index.212': 'BreakdownFeature',
  'auto.pages.pages.requirements.feature-list.index.213': 'Feature Point :',
  'auto.pages.pages.requirements.feature-list.index.214':
    'EstimateFeature Point',
  'auto.pages.pages.requirements.feature-list.index.215': 'EstimatedHours:',
  'auto.pages.pages.requirements.feature-list.index.216': 'Feature PointHours',
  'auto.pages.pages.requirements.feature-list.index.217': 'Estimation Standard',
  'auto.pages.pages.requirements.feature-list.index.218': '[Default]',
  'auto.pages.pages.requirements.feature-list.index.219': 'BatchEstimate',
  'auto.pages.pages.requirements.feature-list.index.220': 'Please CreateList',
  'auto.pages.pages.requirements.feature-list.index.221': 'StartBreakdown',
  'auto.pages.pages.requirements.feature-list.index.222': 'ConfirmClear',
  'auto.pages.pages.requirements.feature-list.index.223':
    'ClearCurrentRequirement List Feature items ？',
  'auto.pages.pages.requirements.feature-list.index.224':
    'Clear FeatureRequirement Item',
  'auto.pages.pages.requirements.feature-list.index.225': 'Clear',
  'auto.pages.pages.requirements.feature-list.index.226': 'ExcelImport',
  'auto.pages.pages.requirements.feature-list.index.227': 'Export Excel',
  'auto.pages.pages.requirements.feature-list.index.228': 'Export Word',
  'auto.pages.pages.requirements.feature-list.index.229': 'ExportMind Map',
  'auto.pages.pages.requirements.feature-list.index.230': 'Export',
  'auto.pages.pages.requirements.feature-list.index.231': 'EditList',
  'auto.pages.pages.requirements.feature-list.index.232': 'DeleteList',
  'auto.pages.pages.requirements.feature-list.index.233':
    'DeleteList「{p1}」？',
  'auto.pages.pages.requirements.feature-list.index.234':
    'Delete This action cannot be undone, Confirm',
  'auto.pages.pages.requirements.feature-list.index.235': 'Delete',
  'auto.pages.pages.requirements.feature-list.index.236': 'Cancel',
  'auto.pages.pages.requirements.feature-list.index.237': 'DefaultList',
  'auto.pages.pages.requirements.feature-list.index.238': 'Feature',
  'auto.pages.pages.requirements.feature-list.index.239':
    'CurrentProject Feature List',
  'auto.pages.pages.requirements.feature-list.index.240': 'CreateList',
  'auto.pages.pages.requirements.feature-list.index.241': 'FeatureModule',
  'auto.pages.pages.requirements.feature-list.index.242':
    'ConfirmClearAllModule？',
  'auto.pages.pages.requirements.feature-list.index.243': 'Clear',
  'auto.pages.pages.requirements.feature-list.index.244': 'Break down more',
  'auto.pages.pages.requirements.feature-list.index.245': 'BatchBreakdown',
  'auto.pages.pages.requirements.feature-list.index.246': 'Load...',
  'auto.pages.pages.requirements.feature-list.index.247': 'Sub-feature',
  'auto.pages.pages.requirements.feature-list.index.248':
    'Current FeatureModule, “Start breakdown”',
  'auto.pages.pages.requirements.feature-list.index.249': 'Break down more',
  'auto.pages.pages.requirements.feature-list.index.250': 'Feature',
  'auto.pages.pages.requirements.feature-list.index.251':
    'Clear Module Feature',
  'auto.pages.pages.requirements.feature-list.index.252':
    'ConfirmClearModule「{p1}」 AllFeature？',
  'auto.pages.pages.requirements.feature-list.index.253': 'Clear Feature',
  'auto.pages.pages.requirements.feature-list.index.254':
    'ConfirmClearList-wide Feature？',
  'auto.pages.pages.requirements.feature-list.index.255': 'Clear',
  'auto.pages.pages.requirements.feature-list.index.256': 'Break down more',
  'auto.pages.pages.requirements.feature-list.index.257': 'BatchBreakdown',
  'auto.pages.pages.requirements.feature-list.index.258': 'LoadFeatureColumn',
  'auto.pages.pages.requirements.feature-list.index.259': 'Feature Point',
  'auto.pages.pages.requirements.feature-list.index.260':
    'CurrentModule Feature',
  'auto.pages.pages.requirements.feature-list.index.261':
    'Please FeatureModule',
  'auto.pages.pages.requirements.feature-list.index.262': 'Break down more',
  'auto.pages.pages.requirements.feature-list.index.263': 'Feature Point',
  'auto.pages.pages.requirements.feature-list.index.264':
    'Clear Feature Feature Point',
  'auto.pages.pages.requirements.feature-list.index.265':
    'ConfirmClearFeature「{p1}」 AllFeature Point？',
  'auto.pages.pages.requirements.feature-list.index.266': 'Clear Feature Point',
  'auto.pages.pages.requirements.feature-list.index.267':
    'ConfirmClearList-wide Feature Point？',
  'auto.pages.pages.requirements.feature-list.index.268': 'Clear',
  'auto.pages.pages.requirements.feature-list.index.269': 'BatchEstimate',
  'auto.pages.pages.requirements.feature-list.index.270':
    'LoadFeature PointColumn',
  'auto.pages.pages.requirements.feature-list.index.271':
    'CurrentFeature Feature Point',
  'auto.pages.pages.requirements.feature-list.index.272': 'Please Feature',
  'auto.pages.pages.requirements.feature-list.index.273': 'Table View',
  'auto.pages.pages.requirements.feature-list.index.274': 'Mind Map',
  'auto.pages.pages.requirements.feature-list.index.275': 'CreateList',
  'auto.pages.pages.requirements.feature-list.index.276': 'EditList',
  'auto.pages.pages.requirements.feature-list.index.277': 'Create',
  'auto.pages.pages.requirements.feature-list.index.278': 'Save',
  'auto.pages.pages.requirements.feature-list.index.279': 'List',
  'auto.pages.pages.requirements.feature-list.index.280':
    'Please enter list name',
  'auto.pages.pages.requirements.feature-list.index.281': 'List 200',
  'auto.pages.pages.requirements.feature-list.index.282':
    'Please enter list name',
  'auto.pages.pages.requirements.feature-list.index.283': 'Version',
  'auto.pages.pages.requirements.feature-list.index.284':
    'please enter Version',
  'auto.pages.pages.requirements.feature-list.index.285': 'Version 50',
  'auto.pages.pages.requirements.feature-list.index.286': 'Example: 1.0.0',
  'auto.pages.pages.requirements.feature-list.index.287': 'Description',
  'auto.pages.pages.requirements.feature-list.index.288':
    'please enter ListDescription',
  'auto.pages.pages.requirements.feature-list.index.289':
    'Excel Import Settings{p1}',
  'auto.pages.pages.requirements.feature-list.index.290': 'Import ...',
  'auto.pages.pages.requirements.feature-list.index.291': 'ConfirmImport',
  'auto.pages.pages.requirements.feature-list.index.292': 'Ignore',
  'auto.pages.pages.requirements.feature-list.index.293':
    'please enter IgnoreRows',
  'auto.pages.pages.requirements.feature-list.index.294':
    'N+1 row Header .Current Rows: {p1}',
  'auto.pages.pages.requirements.feature-list.index.295': 'ModuleColumn',
  'auto.pages.pages.requirements.feature-list.index.296': 'ModuleColumnMapping',
  'auto.pages.pages.requirements.feature-list.index.297':
    'please select ModuleColumn',
  'auto.pages.pages.requirements.feature-list.index.298': 'FeatureColumn',
  'auto.pages.pages.requirements.feature-list.index.299':
    'please select FeatureColumn（Optional）',
  'auto.pages.pages.requirements.feature-list.index.300': 'Feature PointColumn',
  'auto.pages.pages.requirements.feature-list.index.301':
    'please select Feature PointColumn（Optional）',
  'auto.pages.pages.requirements.feature-list.index.302':
    'ModuleDescriptionColumn',
  'auto.pages.pages.requirements.feature-list.index.303':
    'please select ModuleDescriptionColumn（Optional）',
  'auto.pages.pages.requirements.feature-list.index.304':
    'FeatureDescriptionColumn',
  'auto.pages.pages.requirements.feature-list.index.305':
    'please select FeatureDescriptionColumn（Optional）',
  'auto.pages.pages.requirements.feature-list.index.306':
    'Feature PointDescriptionColumn',
  'auto.pages.pages.requirements.feature-list.index.307':
    'please select Feature PointDescriptionColumn（Optional）',
  'auto.pages.pages.requirements.feature-list.index.308': 'HeaderPreview（',
  'auto.pages.pages.requirements.feature-list.index.309': '）',
  'auto.pages.pages.requirements.feature-list.index.310':
    'CurrentHeader row , Please adjustIgnoreRows',
  'auto.pages.pages.requirements.feature-list.index.311':
    'Mapping Preview（ 8 row）',
  'auto.pages.pages.requirements.feature-list.index.312': 'Preview...',
  'auto.pages.pages.requirements.feature-list.index.313': 'Mapping Preview',
  'auto.pages.pages.requirements.feature-list.index.314':
    'Batch Effort Estimation',
  'auto.pages.pages.requirements.feature-list.index.315': 'Estimating......',
  'auto.pages.pages.requirements.feature-list.index.316': 'StartEstimate',
  'auto.pages.pages.requirements.feature-list.index.317': 'Estimation Standard',
  'auto.pages.pages.requirements.feature-list.index.318':
    'please select Estimation Standard',
  'auto.pages.pages.requirements.feature-list.index.319': '[Default]',
  'auto.pages.pages.requirements.feature-list.index.320':
    'please select Estimation Standard',
  'auto.pages.pages.requirements.feature-list.index.321': 'Estimation Scope',
  'auto.pages.pages.requirements.feature-list.index.322':
    'please select Estimation Scope',
  'auto.pages.pages.requirements.feature-list.index.323': 'All leaf items',
  'auto.pages.pages.requirements.feature-list.index.324':
    'Current module subtree',
  'auto.pages.pages.requirements.feature-list.index.325':
    'Current feature subtree',
  'auto.pages.pages.requirements.feature-list.index.326':
    'Estimate only items without hours',
  'auto.pages.pages.requirements.feature-list.index.327': 'EstimatePrompt',
  'auto.pages.pages.requirements.feature-list.index.328':
    'Optional: Estimate , 、 LowComplexity、',
  'auto.pages.pages.requirements.feature-list.index.329': 'Progress:',
  'auto.pages.pages.requirements.feature-list.index.330': ',  Success',
  'auto.pages.pages.requirements.feature-list.index.331': ', Failed',
  'auto.pages.pages.requirements.feature-list.index.332': ',',
  'auto.pages.pages.requirements.feature-list.index.333': 'Processing:',
  'auto.pages.pages.requirements.feature-list.index.334':
    'Estimating items in background. Completed count will be updated after task end.',
  'auto.pages.pages.requirements.feature-list.index.335':
    'Insert Requirement Item Below',
  'auto.pages.pages.requirements.feature-list.index.336': 'Title',
  'auto.pages.pages.requirements.feature-list.index.337': 'please enter Title',
  'auto.pages.pages.requirements.feature-list.index.338':
    'please enter Requirement ItemTitle',
  'auto.pages.pages.requirements.feature-list.index.339': 'Description',
  'auto.pages.pages.requirements.feature-list.index.340':
    'please enter Requirement ItemDescription',
  'auto.pages.pages.requirements.feature-list.index.341': 'Semantic Type',
  'auto.pages.pages.requirements.feature-list.index.342':
    'please select Semantic Type',
  'auto.pages.pages.requirements.feature-list.index.343':
    'Please select feature point tech type',
  'auto.pages.pages.requirements.feature-list.index.344':
    'Complexity Level（1-5）',
  'auto.pages.pages.requirements.feature-list.index.345':
    'Estimated Hours（ ）',
  'auto.pages.pages.requirements.feature-list.index.346': 'Actual Hours（ ）',
  'auto.pages.pages.requirements.feature-list.index.347': 'Task Breakdown',
  'auto.pages.pages.requirements.feature-list.index.348':
    'Task Breakdown , Example: 1) 2) Completed 3)',
  'auto.pages.pages.requirements.feature-list.index.349':
    'Batch Breakdown Settings - {p1}',
  'auto.pages.pages.requirements.feature-list.index.350': 'FeatureModuleColumn',
  'auto.pages.pages.requirements.feature-list.index.351': 'FeatureColumn',
  'auto.pages.pages.requirements.feature-list.index.352': 'Running......',
  'auto.pages.pages.requirements.feature-list.index.353': 'Complete and Close',
  'auto.pages.pages.requirements.feature-list.index.354': 'StartBatchBreakdown',
  'auto.pages.pages.requirements.feature-list.index.355': 'Breakdown Mode',
  'auto.pages.pages.requirements.feature-list.index.356': 'A、',
  'auto.pages.pages.requirements.feature-list.index.357': 'B、 Count',
  'auto.pages.pages.requirements.feature-list.index.358':
    'DefaultBreakdown RequirementCount',
  'auto.pages.pages.requirements.feature-list.index.359':
    'please enter Breakdown Count',
  'auto.pages.pages.requirements.feature-list.index.360': 'Breakdown Prompt',
  'auto.pages.pages.requirements.feature-list.index.361':
    'Optional: BatchBreakdown Prompt',
  'auto.pages.pages.requirements.feature-list.index.362': 'Example',
  'auto.pages.pages.requirements.feature-list.index.363':
    'FeatureColumnBreakdownScope',
  'auto.pages.pages.requirements.feature-list.index.364':
    'Module Feature items rowBatchBreakdown',
  'auto.pages.pages.requirements.feature-list.index.365':
    'BreakdownCurrent MediumModule Feature items',
  'auto.pages.pages.requirements.feature-list.index.366':
    'Current module features',
  'auto.pages.pages.requirements.feature-list.index.367':
    'All project features',
  'auto.pages.pages.requirements.feature-list.index.368':
    'Use project requirement overview as reference',
  'auto.pages.pages.requirements.feature-list.index.369':
    'Overwrite same-name items',
  'auto.pages.pages.requirements.feature-list.index.370':
    'Break down only items without children',
  'auto.pages.pages.requirements.feature-list.index.371': 'Progress:',
  'auto.pages.pages.requirements.feature-list.index.372': ',  Success',
  'auto.pages.pages.requirements.feature-list.index.373': ', Failed',
  'auto.pages.pages.requirements.feature-list.index.374': 'Processing:',
  'auto.pages.pages.requirements.feature-list.index.375':
    'Edit Requirement Item',
  'auto.pages.pages.requirements.feature-list.index.376': 'Title',
  'auto.pages.pages.requirements.feature-list.index.377': 'please enter Title',
  'auto.pages.pages.requirements.feature-list.index.378':
    'please enter Requirement ItemTitle',
  'auto.pages.pages.requirements.feature-list.index.379': 'Description',
  'auto.pages.pages.requirements.feature-list.index.380':
    'please enter Requirement ItemDescription',
  'auto.pages.pages.requirements.feature-list.index.381': 'Semantic Type',
  'auto.pages.pages.requirements.feature-list.index.382':
    'please select Semantic Type',
  'auto.pages.pages.requirements.feature-list.index.383':
    'Please select feature point tech type',
  'auto.pages.pages.requirements.feature-list.index.384':
    'Complexity Level（1-5）',
  'auto.pages.pages.requirements.feature-list.index.385':
    'Estimated Hours（ ）',
  'auto.pages.pages.requirements.feature-list.index.386': 'Actual Hours（ ）',
  'auto.pages.pages.requirements.feature-list.index.387': 'Task Breakdown',
  'auto.pages.pages.requirements.feature-list.index.388':
    'Task Breakdown , Example: 1) 2) Completed 3)',
  'auto.pages.pages.requirements.feature-list.index.389': 'AI Breakdown',
  'auto.pages.pages.requirements.feature-list.index.390': 'Cancel',
  'auto.pages.pages.requirements.feature-list.index.391':
    'Overwrite same-name items',
  'auto.pages.pages.requirements.feature-list.index.392': 'ConfirmApply (',
  'auto.pages.pages.requirements.feature-list.index.393':
    'Breakdown Parameters',
  'auto.pages.pages.requirements.feature-list.index.394': 'CurrentProject',
  'auto.pages.pages.requirements.feature-list.index.395': 'Project Name',
  'auto.pages.pages.requirements.feature-list.index.396': 'Project Description',
  'auto.pages.pages.requirements.feature-list.index.397': 'Save Project Info',
  'auto.pages.pages.requirements.feature-list.index.398': 'Breakdown Mode',
  'auto.pages.pages.requirements.feature-list.index.399': 'A、',
  'auto.pages.pages.requirements.feature-list.index.400': 'B、 Count',
  'auto.pages.pages.requirements.feature-list.index.401': 'C、',
  'auto.pages.pages.requirements.feature-list.index.402': 'Breakdown Count',
  'auto.pages.pages.requirements.feature-list.index.403':
    'please enter Breakdown Count',
  'auto.pages.pages.requirements.feature-list.index.404': '（ row Child）',
  'auto.pages.pages.requirements.feature-list.index.405':
    'Please enter at least one line',
  'auto.pages.pages.requirements.feature-list.index.406':
    'Example: \\n \\n \\n',
  'auto.pages.pages.requirements.feature-list.index.407': 'Breakdown Prompt',
  'auto.pages.pages.requirements.feature-list.index.408':
    'Optional: Breakdown , AI Requirement',
  'auto.pages.pages.requirements.feature-list.index.409': 'Example: 、 、',
  'auto.pages.pages.requirements.feature-list.index.410':
    'ProjectRequirement Overview',
  'auto.pages.pages.requirements.feature-list.index.411':
    'Add manual input results',
  'auto.pages.pages.requirements.feature-list.index.412': 'StartBreakdown',
  'auto.pages.pages.requirements.feature-list.index.413': 'Append manual input',
  'auto.pages.pages.requirements.feature-list.index.414': 'Break down more',
  'auto.pages.pages.requirements.feature-list.index.415':
    'Re-breakdownCompleted',
  'auto.pages.pages.requirements.feature-list.index.416': 'Re-breakdown',
  'auto.pages.pages.requirements.feature-list.index.417': 'Breakdown Results',
  'auto.pages.pages.requirements.feature-list.index.418': 'Total',
  'auto.pages.pages.requirements.feature-list.index.419': 'items',
  'auto.pages.pages.requirements.feature-list.index.420': ':',
  'auto.pages.pages.requirements.feature-list.index.421': 'Complexity Level: L',
  'auto.pages.pages.requirements.feature-list.index.422':
    '“Start breakdown”Generate',
  'auto.pages.pages.requirements.overview.index.1': 'SaaS',
  'auto.pages.pages.requirements.overview.index.2': 'Medium 、',
  'auto.pages.pages.requirements.overview.index.3':
    '# Requirement Overview\\n\\n## Project \\n### \\n### \\n### Succeeded \\n\\n## Scope \\n### Scope（In Scope）\\n### Scope（Out of Scope）\\n### \\n\\n## \\n### \\n### \\n### \\n\\n## FeatureRequirement Overview\\n### FeatureModule\\n### \\n### \\n\\n## FeatureRequirement\\n### \\n### \\n### \\n\\n## \\n### \\n### \\n### \\n\\n## \\n### \\n###',
  'auto.pages.pages.requirements.overview.index.4': 'Apply',
  'auto.pages.pages.requirements.overview.index.5': 'App、 、',
  'auto.pages.pages.requirements.overview.index.6':
    '# Requirement Overview\\n\\n## \\n### \\n### \\n### \\n\\n## Scope\\n### MVP Scope\\n### Version \\n### items \\n\\n## \\n### \\n### High Task \\n### \\n\\n## FeatureRequirement Overview\\n### \\n### / \\n### \\n\\n## \\n### \\n### \\n### \\n\\n## \\n### \\n### \\n### \\n\\n## \\n### \\n###',
  'auto.pages.pages.requirements.overview.index.7': '/',
  'auto.pages.pages.requirements.overview.index.8': '、 、Analyze',
  'auto.pages.pages.requirements.overview.index.9':
    '# Requirement Overview\\n\\n## \\n### \\n### \\n### Scope\\n\\n## Scope \\n### Scope\\n### \\n### \\n\\n## Requirement\\n### \\n### \\n### Analyze \\n\\n## \\n### Analyze \\n### \\n### \\n\\n## FeatureRequirement\\n### \\n### \\n### \\n\\n## \\n### \\n### \\n### \\n\\n## \\n### \\n###',
  'auto.pages.pages.requirements.overview.index.109': 'Translated text',
  'auto.pages.pages.requirements.overview.index.110': 'Details',
  'auto.pages.pages.requirements.overview.index.111':
    '# \\n\\n## Description\\n### \\n### \\n### Requirement\\n\\n## Feature\\n### Feature List\\n### \\n### MVP Feature \\n\\n## \\n### \\n### \\n### \\n\\n## \\n### \\n### \\n###',
  'auto.pages.pages.requirements.overview.index.10': 'Current .\\n Agent',
  'auto.pages.pages.requirements.overview.index.11': 'Please Save Start',
  'auto.pages.pages.requirements.overview.index.12': 'Failed, and retry',
  'auto.pages.pages.requirements.overview.index.13': 'Failed, Status',
  'auto.pages.pages.requirements.overview.index.14': 'Agent',
  'auto.pages.pages.requirements.overview.index.15': 'SwitchFailed',
  'auto.pages.pages.requirements.overview.index.16': 'Translated text',
  'auto.pages.pages.requirements.overview.index.17': 'Save',
  'auto.pages.pages.requirements.overview.index.18': 'Save',
  'auto.pages.pages.requirements.overview.index.19': 'Translated text',
  'auto.pages.pages.requirements.overview.index.20': 'Translated text',
  'auto.pages.pages.requirements.overview.index.21': 'Translated text',
  'auto.pages.pages.requirements.overview.index.22': 'Translated text',
  'auto.pages.pages.requirements.overview.index.23': 'Translated text',
  'auto.pages.pages.requirements.overview.index.24': 'Translated text',
  'auto.pages.pages.requirements.overview.index.25': 'Zen',
  'auto.pages.pages.requirements.overview.index.26': 'Translated text',
  'auto.pages.pages.requirements.overview.index.27': 'Translated text',
  'auto.pages.pages.requirements.overview.index.28': 'Translated text',
  'auto.pages.pages.requirements.overview.index.29': 'Translated text',
  'auto.pages.pages.requirements.overview.index.30': 'Translated text',
  'auto.pages.pages.requirements.overview.index.31':
    'Title, # / ## / ### Generate',
  'auto.pages.pages.requirements.overview.index.32': 'Translated text',
  'auto.pages.pages.requirements.overview.index.33': 'Translated text',
  'auto.pages.pages.requirements.overview.index.34': 'Translated text',
  'auto.pages.pages.requirements.overview.index.35': 'Translated text',
  'auto.pages.pages.requirements.overview.index.36': '...',
  'auto.pages.pages.requirements.overview.index.37': '（ , ）',
  'auto.pages.pages.requirements.overview.index.38': 'Requirement（ ）',
  'auto.pages.pages.requirements.overview.index.39': 'Agent',
  'auto.pages.pages.requirements.overview.index.40': 'Translated text',
  'auto.pages.pages.requirements.overview.index.41':
    '# Requirement Overview\\n\\n## \\n- Project level \\n\\n## Scope\\n- ProjectColumn \\n- Project \\n\\n## \\n-',
  'auto.pages.pages.requirements.overview.index.42': 'Load RequirementFailed',
  'auto.pages.pages.requirements.overview.index.43': 'Please Project',
  'auto.pages.pages.requirements.overview.index.44': 'please enter',
  'auto.pages.pages.requirements.overview.index.45': 'Please CreateRequirement',
  'auto.pages.pages.requirements.overview.index.46': 'Update',
  'auto.pages.pages.requirements.overview.index.47': 'Save RequirementFailed',
  'auto.pages.pages.requirements.overview.index.48': 'Please Project',
  'auto.pages.pages.requirements.overview.index.49':
    'Requirement Overview Create CurrentProject',
  'auto.pages.pages.requirements.overview.index.50': 'CreateRequirement Failed',
  'auto.pages.pages.requirements.overview.index.51': 'Delete',
  'auto.pages.pages.requirements.overview.index.52': 'Delete RequirementFailed',
  'auto.pages.pages.requirements.overview.index.53': 'Save',
  'auto.pages.pages.requirements.overview.index.54': 'Save',
  'auto.pages.pages.requirements.overview.index.55': 'Please Project',
  'auto.pages.pages.requirements.overview.index.56': 'Please Project',
  'auto.pages.pages.requirements.overview.index.57':
    'Please enter project name',
  'auto.pages.pages.requirements.overview.index.58': 'please select',
  'auto.pages.pages.requirements.overview.index.59':
    'Not generated , Please adjustPrompt and retry',
  'auto.pages.pages.requirements.overview.index.60': 'Draft{p1}',
  'auto.pages.pages.requirements.overview.index.61': 'AI Failed, and retry',
  'auto.pages.pages.requirements.overview.index.62': 'Please Project',
  'auto.pages.pages.requirements.overview.index.63':
    'Please enter project name',
  'auto.pages.pages.requirements.overview.index.64': 'Project Save',
  'auto.pages.pages.requirements.overview.index.65': 'Save Project InfoFailed',
  'auto.pages.pages.requirements.overview.index.66': 'Requirement',
  'auto.pages.pages.requirements.overview.index.67': 'Markdown , Confirm Scope',
  'auto.pages.pages.requirements.overview.index.68': 'AI',
  'auto.pages.pages.requirements.overview.index.69': 'CreateRequirement',
  'auto.pages.pages.requirements.overview.index.70':
    'Confirm deletionCurrent ？',
  'auto.pages.pages.requirements.overview.index.71': 'Delete',
  'auto.pages.pages.requirements.overview.index.72': 'Translated text',
  'auto.pages.pages.requirements.overview.index.73': 'Translated text',
  'auto.pages.pages.requirements.overview.index.74': 'Translated text',
  'auto.pages.pages.requirements.overview.index.75': 'Markdown',
  'auto.pages.pages.requirements.overview.index.76': 'Create',
  'auto.pages.pages.requirements.overview.index.77': 'Save',
  'auto.pages.pages.requirements.overview.index.78': 'Create',
  'auto.pages.pages.requirements.overview.index.79': 'Translated text',
  'auto.pages.pages.requirements.overview.index.80': 'Translated text',
  'auto.pages.pages.requirements.overview.index.81': 'Translated text',
  'auto.pages.pages.requirements.overview.index.82': 'Translated text',
  'auto.pages.pages.requirements.overview.index.83': 'Status',
  'auto.pages.pages.requirements.overview.index.84': 'Create',
  'auto.pages.pages.requirements.overview.index.85': 'Update',
  'auto.pages.pages.requirements.overview.index.86': 'AI',
  'auto.pages.pages.requirements.overview.index.87': 'Project Name',
  'auto.pages.pages.requirements.overview.index.88':
    'Please enter project name',
  'auto.pages.pages.requirements.overview.index.89': 'Project Description',
  'auto.pages.pages.requirements.overview.index.90':
    'Please enter project description',
  'auto.pages.pages.requirements.overview.index.91': 'Prompt （ ）',
  'auto.pages.pages.requirements.overview.index.92': 'Example: 、',
  'auto.pages.pages.requirements.overview.index.93': 'Save Project Info',
  'auto.pages.pages.requirements.overview.index.94': 'Cancel',
  'auto.pages.pages.requirements.overview.index.95': 'Translated text',
  'auto.pages.pages.requirements.overview.index.96': 'Requirement',
  'auto.pages.pages.requirements.overview.index.97': '（Markdown, Edit）',
  'auto.pages.pages.requirements.overview.index.98': 'please select Edit',
  'auto.pages.pages.requirements.overview.index.99': 'Markdown',
  'auto.pages.pages.requirements.overview.index.100':
    'CurrentProject Requirement',
  'auto.pages.pages.requirements.overview.index.101': 'CreateRequirement',
  'auto.pages.pages.requirements.overview.index.102': 'Save Update',
  'auto.pages.pages.requirements.overview.index.103': 'Create',
  'auto.pages.pages.requirements.overview.index.104': 'Translated text',
  'auto.pages.pages.requirements.overview.index.105': 'Translated text',
  'auto.pages.pages.requirements.overview.index.106': 'please enter',
  'auto.pages.pages.requirements.overview.index.107':
    'please enter （ 、Column 、 ）',
  'auto.pages.pages.requirements.overview.index.108':
    'Generate , .Current RequirementEntitySync',
  'auto.pages.pages.requirements.requirement-pool.index.1': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.2': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.3': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.4': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.5': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.6': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.7': 'AI',
  'auto.pages.pages.requirements.requirement-pool.index.8': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.9': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.10': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.11': 'Estimate',
  'auto.pages.pages.requirements.requirement-pool.index.12': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.13': 'Estimating...',
  'auto.pages.pages.requirements.requirement-pool.index.14': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.15': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.16': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.17': 'Requirement Item',
  'auto.pages.pages.requirements.requirement-pool.index.18': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.19': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.20': 'Estimate',
  'auto.pages.pages.requirements.requirement-pool.index.21': 'Status',
  'auto.pages.pages.requirements.requirement-pool.index.22': 'Update',
  'auto.pages.pages.requirements.requirement-pool.index.23': 'Create',
  'auto.pages.pages.requirements.requirement-pool.index.24': 'Actions',
  'auto.pages.pages.requirements.requirement-pool.index.25': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.26': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.27': 'Estimating...',
  'auto.pages.pages.requirements.requirement-pool.index.28': 'Edit',
  'auto.pages.pages.requirements.requirement-pool.index.29':
    'Confirm deletion Requirement Item？',
  'auto.pages.pages.requirements.requirement-pool.index.30': 'Delete',
  'auto.pages.pages.requirements.requirement-pool.index.31': 'Delete',
  'auto.pages.pages.requirements.requirement-pool.index.32': 'Cancel',
  'auto.pages.pages.requirements.requirement-pool.index.33': 'Delete ...',
  'auto.pages.pages.requirements.requirement-pool.index.34': 'Failed to delete',
  'auto.pages.pages.requirements.requirement-pool.index.35':
    'Deleted successfully',
  'auto.pages.pages.requirements.requirement-pool.index.36': 'Delete',
  'auto.pages.pages.requirements.requirement-pool.index.37': '...',
  'auto.pages.pages.requirements.requirement-pool.index.38': 'Failed to update',
  'auto.pages.pages.requirements.requirement-pool.index.39': 'Status Update',
  'auto.pages.pages.requirements.requirement-pool.index.40': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.41': 'All ({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.42': '({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.43':
    'Estimating... ({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.44': '({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.45': '({p1})',
  'auto.pages.pages.requirements.requirement-pool.index.46':
    'Please Requirement Item',
  'auto.pages.pages.requirements.requirement-pool.index.47': 'Batch Failed',
  'auto.pages.pages.requirements.requirement-pool.index.48': '{p1} Requirement',
  'auto.pages.pages.requirements.requirement-pool.index.49':
    'ConfirmBatch{p1}？',
  'auto.pages.pages.requirements.requirement-pool.index.50': '{p1} Requirement',
  'auto.pages.pages.requirements.requirement-pool.index.51': 'Confirm',
  'auto.pages.pages.requirements.requirement-pool.index.52': 'Cancel',
  'auto.pages.pages.requirements.requirement-pool.index.53': 'Requirement',
  'auto.pages.pages.requirements.requirement-pool.index.54':
    'Requirement, CompletedEstimate、',
  'auto.pages.pages.requirements.requirement-pool.index.55': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.56':
    'Title/Requirement Pool /',
  'auto.pages.pages.requirements.requirement-pool.index.57': 'Requirement',
  'auto.pages.pages.requirements.requirement-pool.index.58': 'please select',
  'auto.pages.pages.requirements.requirement-pool.index.59': 'Estimate',
  'auto.pages.pages.requirements.requirement-pool.index.60': 'please select',
  'auto.pages.pages.requirements.requirement-pool.index.61': 'Status',
  'auto.pages.pages.requirements.requirement-pool.index.62': 'please select',
  'auto.pages.pages.requirements.requirement-pool.index.63': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.64': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.65': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.66': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.67': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.68': 'Estimating...',
  'auto.pages.pages.requirements.requirement-pool.index.69': 'BatchEstimate',
  'auto.pages.pages.requirements.requirement-pool.index.70': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.71': 'Batch',
  'auto.pages.pages.requirements.requirement-pool.index.72': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.73': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.74': 'items',
  'auto.pages.pages.requirements.requirement-pool.index.75': 'Clear',
  'auto.pages.pages.requirements.requirement-pool.index.76': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.77': 'Batch',
  'auto.pages.pages.requirements.requirement-pool.index.78': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.79': 'Batch',
  'auto.pages.pages.requirements.requirement-pool.index.80': 'Total {p1}',
  'auto.pages.pages.requirements.requirement-pool.index.81':
    'Edit Requirement Item',
  'auto.pages.pages.requirements.requirement-pool.index.82': 'Requirement Item',
  'auto.pages.pages.requirements.requirement-pool.index.83': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.84': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.85': 'Save',
  'auto.pages.pages.requirements.requirement-pool.index.86': 'Cancel',
  'auto.pages.pages.requirements.requirement-pool.index.87': 'Save failed',
  'auto.pages.pages.requirements.requirement-pool.index.88':
    'Updated successfully',
  'auto.pages.pages.requirements.requirement-pool.index.89': 'Succeeded',
  'auto.pages.pages.requirements.requirement-pool.index.90': 'Requirement Item',
  'auto.pages.pages.requirements.requirement-pool.index.91':
    'please enter RequirementTitle',
  'auto.pages.pages.requirements.requirement-pool.index.92':
    'please enter Requirement Item',
  'auto.pages.pages.requirements.requirement-pool.index.93': 'Requirement',
  'auto.pages.pages.requirements.requirement-pool.index.94':
    'please select Requirement',
  'auto.pages.pages.requirements.requirement-pool.index.95': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.96': 'please enter',
  'auto.pages.pages.requirements.requirement-pool.index.97': 'please enter',
  'auto.pages.pages.requirements.requirement-pool.index.98': 'Estimate',
  'auto.pages.pages.requirements.requirement-pool.index.99':
    'please select Estimate',
  'auto.pages.pages.requirements.requirement-pool.index.100': 'Status',
  'auto.pages.pages.requirements.requirement-pool.index.101':
    'please select Status',
  'auto.pages.pages.requirements.requirement-pool.index.102': 'Translated text',
  'auto.pages.pages.requirements.requirement-pool.index.103': 'Estimate',
  'auto.pages.pages.requirements.role-analysis.index.1': 'Project',
  'auto.pages.pages.requirements.role-analysis.index.2': 'Load Failed',
  'auto.pages.pages.requirements.role-analysis.index.3':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.role-analysis.index.4': 'Project Save',
  'auto.pages.pages.requirements.role-analysis.index.5':
    'Save Project InfoFailed',
  'auto.pages.pages.requirements.role-analysis.index.6':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.role-analysis.index.7':
    'AI GenerateCompleted（referenced feature items {p1} ）, Please select',
  'auto.pages.pages.requirements.role-analysis.index.8': 'AI Failed',
  'auto.pages.pages.requirements.role-analysis.index.9':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.role-analysis.index.10': 'Please Preview',
  'auto.pages.pages.requirements.role-analysis.index.11': 'Save {p1}',
  'auto.pages.pages.requirements.role-analysis.index.12': 'Failed',
  'auto.pages.pages.requirements.role-analysis.index.13':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.role-analysis.index.14': 'Saved successfully',
  'auto.pages.pages.requirements.role-analysis.index.15': 'Save failed',
  'auto.pages.pages.requirements.role-analysis.index.16':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.role-analysis.index.17': 'Clear',
  'auto.pages.pages.requirements.role-analysis.index.18': 'Clear failed',
  'auto.pages.pages.requirements.role-analysis.index.19': 'Not filled',
  'auto.pages.pages.requirements.role-analysis.index.20': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.21': 'Not filled',
  'auto.pages.pages.requirements.role-analysis.index.22': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.23': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.24': 'FeatureScope',
  'auto.pages.pages.requirements.role-analysis.index.25': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.26': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.27': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.28': 'Actions',
  'auto.pages.pages.requirements.role-analysis.index.29': 'Edit',
  'auto.pages.pages.requirements.role-analysis.index.30': 'Confirm deletion ？',
  'auto.pages.pages.requirements.role-analysis.index.31': 'Confirm',
  'auto.pages.pages.requirements.role-analysis.index.32': 'Cancel',
  'auto.pages.pages.requirements.role-analysis.index.33': 'Delete',
  'auto.pages.pages.requirements.role-analysis.index.34': 'Clear',
  'auto.pages.pages.requirements.role-analysis.index.35': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.36': 'Not filled',
  'auto.pages.pages.requirements.role-analysis.index.37': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.38': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.39': 'FeatureScope',
  'auto.pages.pages.requirements.role-analysis.index.40': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.41': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.42': 'Project: {p1}',
  'auto.pages.pages.requirements.role-analysis.index.43': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.44': '/ / /Feature/',
  'auto.pages.pages.requirements.role-analysis.index.45': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.46': 'please enter',
  'auto.pages.pages.requirements.role-analysis.index.47': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.48': 'please enter',
  'auto.pages.pages.requirements.role-analysis.index.49': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.50': 'please enter',
  'auto.pages.pages.requirements.role-analysis.index.51': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.52': 'please enter',
  'auto.pages.pages.requirements.role-analysis.index.53': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.54': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.55': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.56': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.57': '({p1})',
  'auto.pages.pages.requirements.role-analysis.index.58': '({p1})',
  'auto.pages.pages.requirements.role-analysis.index.59': 'All({p1})',
  'auto.pages.pages.requirements.role-analysis.index.60': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.61': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.62':
    'Confirm deletion Medium {p1} ？',
  'auto.pages.pages.requirements.role-analysis.index.63': 'Confirm',
  'auto.pages.pages.requirements.role-analysis.index.64': 'Cancel',
  'auto.pages.pages.requirements.role-analysis.index.65': 'BatchDelete（',
  'auto.pages.pages.requirements.role-analysis.index.66': 'AI',
  'auto.pages.pages.requirements.role-analysis.index.67': 'Save',
  'auto.pages.pages.requirements.role-analysis.index.68':
    'ConfirmClearCurrentProject ？',
  'auto.pages.pages.requirements.role-analysis.index.69': 'Confirm',
  'auto.pages.pages.requirements.role-analysis.index.70': 'Cancel',
  'auto.pages.pages.requirements.role-analysis.index.71': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.72':
    'Role Analysis , “ ” “AIRole Analysis”Start',
  'auto.pages.pages.requirements.role-analysis.index.73': ':',
  'auto.pages.pages.requirements.role-analysis.index.74': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.75': 'Default',
  'auto.pages.pages.requirements.role-analysis.index.76': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.77': 'Column',
  'auto.pages.pages.requirements.role-analysis.index.78': 'Total {p1}',
  'auto.pages.pages.requirements.role-analysis.index.79': 'Edit',
  'auto.pages.pages.requirements.role-analysis.index.80': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.81': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.82': 'Cancel',
  'auto.pages.pages.requirements.role-analysis.index.83': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.84': 'please enter',
  'auto.pages.pages.requirements.role-analysis.index.85': 'Example: 、',
  'auto.pages.pages.requirements.role-analysis.index.86': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.87':
    'please enter Description',
  'auto.pages.pages.requirements.role-analysis.index.88': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.89': 'FeatureScope',
  'auto.pages.pages.requirements.role-analysis.index.90': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.91': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.92': 'Example:',
  'auto.pages.pages.requirements.role-analysis.index.93': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.94': 'Example: Project',
  'auto.pages.pages.requirements.role-analysis.index.95': 'AI',
  'auto.pages.pages.requirements.role-analysis.index.96': 'items',
  'auto.pages.pages.requirements.role-analysis.index.97': 'Project Name',
  'auto.pages.pages.requirements.role-analysis.index.98':
    'Please enter project name',
  'auto.pages.pages.requirements.role-analysis.index.99':
    'Please enter project name',
  'auto.pages.pages.requirements.role-analysis.index.100':
    'Project Description',
  'auto.pages.pages.requirements.role-analysis.index.101':
    'Please enter project description',
  'auto.pages.pages.requirements.role-analysis.index.102':
    'Prompt （ Generate）',
  'auto.pages.pages.requirements.role-analysis.index.103': 'Example: 、',
  'auto.pages.pages.requirements.role-analysis.index.104': 'Breakdown Count',
  'auto.pages.pages.requirements.role-analysis.index.105':
    'Please enter breakdown count',
  'auto.pages.pages.requirements.role-analysis.index.106': 'CountScope 1-20',
  'auto.pages.pages.requirements.role-analysis.index.107':
    'Feature List（ Project Feature List）',
  'auto.pages.pages.requirements.role-analysis.index.108': 'Save Project Info',
  'auto.pages.pages.requirements.role-analysis.index.109': 'Cancel',
  'auto.pages.pages.requirements.role-analysis.index.110': 'Preview',
  'auto.pages.pages.requirements.role-analysis.index.111': 'Preview',
  'auto.pages.pages.requirements.role-analysis.index.112': 'Column',
  'auto.pages.pages.requirements.role-analysis.index.113': '“GeneratePreview”',
  'auto.pages.pages.requirements.role-analysis.index.114': 'Translated text',
  'auto.pages.pages.requirements.role-analysis.index.115': 'Medium Column （',
  'auto.pages.pages.requirements.system-integration.index.1': 'Translated text',
  'auto.pages.pages.requirements.system-integration.index.2': 'Translated text',
  'auto.pages.pages.requirements.system-integration.index.3': 'Translated text',
  'auto.pages.pages.requirements.system-integration.index.4': 'Translated text',
  'auto.pages.pages.requirements.system-integration.index.5': 'Translated text',
  'auto.pages.pages.requirements.system-integration.index.6': 'Translated text',
  'auto.pages.pages.requirements.system-integration.index.7': 'Translated text',
  'auto.pages.pages.requirements.system-integration.index.8': 'Project',
  'auto.pages.pages.requirements.system-integration.index.9':
    'LoadSystem IntegrationAnalyzeFailed',
  'auto.pages.pages.requirements.system-integration.index.10':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.system-integration.index.11': 'Project Save',
  'auto.pages.pages.requirements.system-integration.index.12':
    'Failed to save project information',
  'auto.pages.pages.requirements.system-integration.index.13':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.system-integration.index.14':
    'AI GenerateCompleted（referenced feature items {p1} ）, Please select',
  'auto.pages.pages.requirements.system-integration.index.15': 'AI Failed',
  'auto.pages.pages.requirements.system-integration.index.16':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.system-integration.index.17':
    'Please Preview items',
  'auto.pages.pages.requirements.system-integration.index.18':
    'Save {p1} items',
  'auto.pages.pages.requirements.system-integration.index.19': 'Failed',
  'auto.pages.pages.requirements.system-integration.index.20':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.system-integration.index.21':
    'Saved successfully',
  'auto.pages.pages.requirements.system-integration.index.22': 'Save failed',
  'auto.pages.pages.requirements.system-integration.index.23':
    'No project detected. Please switch to a project from the left panel first',
  'auto.pages.pages.requirements.system-integration.index.24':
    'ClearSystem IntegrationAnalyze',
  'auto.pages.pages.requirements.system-integration.index.25': 'Clear failed',
  'auto.pages.pages.requirements.system-integration.index.26': 'Not filled',
  'auto.pages.pages.requirements.system-integration.index.27': '/',
  'auto.pages.pages.requirements.system-integration.index.28': 'Not filled',
  'auto.pages.pages.requirements.system-integration.index.29':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.30': 'Not filled',
  'auto.pages.pages.requirements.system-integration.index.31':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.32':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.33': '/',
  'auto.pages.pages.requirements.system-integration.index.34':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.35':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.36':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.37': '( )',
  'auto.pages.pages.requirements.system-integration.index.38': 'Status',
  'auto.pages.pages.requirements.system-integration.index.39':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.40':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.41':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.42':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.43':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.44':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.45':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.46':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.47':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.48':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.49': 'Status',
  'auto.pages.pages.requirements.system-integration.index.50': 'Actions',
  'auto.pages.pages.requirements.system-integration.index.51': 'Edit',
  'auto.pages.pages.requirements.system-integration.index.52': 'Delete',
  'auto.pages.pages.requirements.system-integration.index.53': '/',
  'auto.pages.pages.requirements.system-integration.index.54': 'Not filled',
  'auto.pages.pages.requirements.system-integration.index.55':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.56':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.57':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.58':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.59':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.60': 'Status',
  'auto.pages.pages.requirements.system-integration.index.61':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.62':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.63':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.64':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.65':
    'Project“{p1}”Detect Requirement',
  'auto.pages.pages.requirements.system-integration.index.66': 'AI',
  'auto.pages.pages.requirements.system-integration.index.67': 'items',
  'auto.pages.pages.requirements.system-integration.index.68': 'Save',
  'auto.pages.pages.requirements.system-integration.index.69':
    'ConfirmClearCurrentProjectSystem Integration ？',
  'auto.pages.pages.requirements.system-integration.index.70': 'Clear',
  'auto.pages.pages.requirements.system-integration.index.71': 'Delete （',
  'auto.pages.pages.requirements.system-integration.index.72':
    'System Integration , “AISystem IntegrationAnalyze” “ items”Start',
  'auto.pages.pages.requirements.system-integration.index.73': 'Edit items',
  'auto.pages.pages.requirements.system-integration.index.74': 'items',
  'auto.pages.pages.requirements.system-integration.index.75':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.76': 'Cancel',
  'auto.pages.pages.requirements.system-integration.index.77': '/',
  'auto.pages.pages.requirements.system-integration.index.78': 'please enter',
  'auto.pages.pages.requirements.system-integration.index.79':
    'Example: SAP ERP、 、',
  'auto.pages.pages.requirements.system-integration.index.80':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.81':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.82': '（ ）',
  'auto.pages.pages.requirements.system-integration.index.83':
    'Example: HTTPS+JSON、AMQP、MQTT、Modbus TCP',
  'auto.pages.pages.requirements.system-integration.index.84':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.85':
    'Example: OAuth2、AK/SK、BasicAuth、',
  'auto.pages.pages.requirements.system-integration.index.86': '/',
  'auto.pages.pages.requirements.system-integration.index.87':
    'Example: https://api.partner.com/v1/orders mq://cluster/topic',
  'auto.pages.pages.requirements.system-integration.index.88':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.89':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.90': 'Estimated（ ）',
  'auto.pages.pages.requirements.system-integration.index.91': 'Status',
  'auto.pages.pages.requirements.system-integration.index.92':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.93': 'items',
  'auto.pages.pages.requirements.system-integration.index.94': 'Status',
  'auto.pages.pages.requirements.system-integration.index.95':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.96': 'Example: 、 、',
  'auto.pages.pages.requirements.system-integration.index.97': '/',
  'auto.pages.pages.requirements.system-integration.index.98':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.99':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.100':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.101':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.102':
    'Translated text',
  'auto.pages.pages.requirements.system-integration.index.103':
    'AI System IntegrationAnalyze',
  'auto.pages.pages.requirements.system-integration.index.104': 'items',
  'auto.pages.pages.requirements.system-integration.index.105': 'Project Name',
  'auto.pages.pages.requirements.system-integration.index.106':
    'Please enter project name',
  'auto.pages.pages.requirements.system-integration.index.107':
    'Please enter project name',
  'auto.pages.pages.requirements.system-integration.index.108':
    'Project Description',
  'auto.pages.pages.requirements.system-integration.index.109':
    'Please enter project description',
  'auto.pages.pages.requirements.system-integration.index.110':
    'Prompt （ Generate）',
  'auto.pages.pages.requirements.system-integration.index.111':
    'Example: Detect 、 、 、 Medium',
  'auto.pages.pages.requirements.system-integration.index.112':
    'Breakdown itemsCount',
  'auto.pages.pages.requirements.system-integration.index.113':
    'Please enter breakdown count',
  'auto.pages.pages.requirements.system-integration.index.114':
    'CountScope 1-30',
  'auto.pages.pages.requirements.system-integration.index.115':
    'Feature List（ Project Feature List）',
  'auto.pages.pages.requirements.system-integration.index.116':
    'Save Project Info',
  'auto.pages.pages.requirements.system-integration.index.117': 'Cancel',
  'auto.pages.pages.requirements.system-integration.index.118': 'Preview',
  'auto.pages.pages.requirements.system-integration.index.119': 'Preview',
  'auto.pages.pages.requirements.system-integration.index.120': 'items Column',
  'auto.pages.pages.requirements.system-integration.index.121':
    '“GeneratePreview” items',
  'auto.pages.pages.requirements.system-integration.index.122': 'items',
  'auto.pages.pages.requirements.system-integration.index.123':
    'Medium Column （',
  'auto.pages.pages.task-management.index.1': '完成支付模块接口联调',
  'auto.pages.pages.task-management.index.2': '张三',
  'auto.pages.pages.task-management.index.3': '补充用户中心单元测试',
  'auto.pages.pages.task-management.index.4': '李四',
  'auto.pages.pages.task-management.index.5': '发布前回归清单确认',
  'auto.pages.pages.task-management.index.6': '王五',
  'auto.pages.pages.task-management.index.7': '任务',
  'auto.pages.pages.task-management.index.8': '负责人',
  'auto.pages.pages.task-management.index.9': '迭代',
  'auto.pages.pages.task-management.index.10': '优先级',
  'auto.pages.pages.task-management.index.11': '高',
  'auto.pages.pages.task-management.index.12': '中',
  'auto.pages.pages.task-management.index.13': '低',
  'auto.pages.pages.task-management.index.14': '状态',
  'auto.pages.pages.task-management.index.15': '待处理',
  'auto.pages.pages.task-management.index.16': '进行中',
  'auto.pages.pages.task-management.index.17': '已完成',
  'auto.pages.pages.task-management.index.18': '任务管理',
  'auto.pages.pages.task-management.index.19': '任务拆解、分派、跟踪与迭代推进',
  'auto.pages.pages.test-management.bug.index.1': '缺陷标题',
  'auto.pages.pages.test-management.bug.index.2': '严重程度',
  'auto.pages.pages.test-management.bug.index.3': '阻断',
  'auto.pages.pages.test-management.bug.index.4': '严重',
  'auto.pages.pages.test-management.bug.index.5': '主要',
  'auto.pages.pages.test-management.bug.index.6': '次要',
  'auto.pages.pages.test-management.bug.index.7': '优先级',
  'auto.pages.pages.test-management.bug.index.8': '状态',
  'auto.pages.pages.test-management.bug.index.9': '新建',
  'auto.pages.pages.test-management.bug.index.10': '处理中',
  'auto.pages.pages.test-management.bug.index.11': '已解决',
  'auto.pages.pages.test-management.bug.index.12': '已修复',
  'auto.pages.pages.test-management.bug.index.13': '已关闭',
  'auto.pages.pages.test-management.bug.index.14': '创建人',
  'auto.pages.pages.test-management.bug.index.15': '处理人',
  'auto.pages.pages.test-management.bug.index.16': '创建时间',
  'auto.pages.pages.test-management.bug.index.17': '操作',
  'auto.pages.pages.test-management.bug.index.18': '编辑',
  'auto.pages.pages.test-management.bug.index.19': '详情',
  'auto.pages.pages.test-management.bug.index.20': '新建缺陷',
  'auto.pages.pages.test-management.case.index.1': '用例名称',
  'auto.pages.pages.test-management.case.index.2': '用例级别',
  'auto.pages.pages.test-management.case.index.3': '测试类型',
  'auto.pages.pages.test-management.case.index.4': '功能测试',
  'auto.pages.pages.test-management.case.index.5': '性能测试',
  'auto.pages.pages.test-management.case.index.6': '接口测试',
  'auto.pages.pages.test-management.case.index.7': '安全测试',
  'auto.pages.pages.test-management.case.index.8': '状态',
  'auto.pages.pages.test-management.case.index.9': '草稿',
  'auto.pages.pages.test-management.case.index.10': '评审中',
  'auto.pages.pages.test-management.case.index.11': '待执行',
  'auto.pages.pages.test-management.case.index.12': '创建人',
  'auto.pages.pages.test-management.case.index.13': '更新时间',
  'auto.pages.pages.test-management.case.index.14': '操作',
  'auto.pages.pages.test-management.case.index.15': 'Mock: 编辑功能',
  'auto.pages.pages.test-management.case.index.16': '编辑',
  'auto.pages.pages.test-management.case.index.17': 'Mock: 执行用例',
  'auto.pages.pages.test-management.case.index.18': '执行',
  'auto.pages.pages.test-management.case.index.19': '确认删除？',
  'auto.pages.pages.test-management.case.index.20': '已删除（Mock）',
  'auto.pages.pages.test-management.case.index.21': '删除',
  'auto.pages.pages.test-management.case.index.22': 'Mock: 新建用例',
  'auto.pages.pages.test-management.case.index.23': '新建用例',
  'auto.pages.pages.test-management.case-library.index.1': '库名称',
  'auto.pages.pages.test-management.case-library.index.2': '描述',
  'auto.pages.pages.test-management.case-library.index.3': '用例总数',
  'auto.pages.pages.test-management.case-library.index.4': '个',
  'auto.pages.pages.test-management.case-library.index.5': '创建人',
  'auto.pages.pages.test-management.case-library.index.6': '更新时间',
  'auto.pages.pages.test-management.case-library.index.7': '操作',
  'auto.pages.pages.test-management.case-library.index.8': 'Mock: 编辑用例库',
  'auto.pages.pages.test-management.case-library.index.9': '编辑',
  'auto.pages.pages.test-management.case-library.index.10': 'Mock: 管理用例库',
  'auto.pages.pages.test-management.case-library.index.11': '管理',
  'auto.pages.pages.test-management.case-library.index.12': '确认删除用例库？',
  'auto.pages.pages.test-management.case-library.index.13': '已删除（Mock）',
  'auto.pages.pages.test-management.case-library.index.14': '删除',
  'auto.pages.pages.test-management.case-library.index.15': 'Mock: 新建用例库',
  'auto.pages.pages.test-management.case-library.index.16': '新建用例库',
  'auto.pages.pages.test-management.dashboard.index.1': '用例分布',
  'auto.pages.pages.test-management.dashboard.index.2': '严重程度',
  'auto.pages.pages.test-management.dashboard.index.3': '缺陷数量',
  'auto.pages.pages.test-management.dashboard.index.4': '测试名称',
  'auto.pages.pages.test-management.dashboard.index.5': '负责人',
  'auto.pages.pages.test-management.dashboard.index.6': '状态',
  'auto.pages.pages.test-management.dashboard.index.7': '已完成',
  'auto.pages.pages.test-management.dashboard.index.8': '进行中',
  'auto.pages.pages.test-management.dashboard.index.9': '失败',
  'auto.pages.pages.test-management.dashboard.index.10': '排队中',
  'auto.pages.pages.test-management.dashboard.index.11': '进度',
  'auto.pages.pages.test-management.dashboard.index.12': '开始时间',
  'auto.pages.pages.test-management.dashboard.index.13': '测试管理仪表盘',
  'auto.pages.pages.test-management.dashboard.index.14': '用例状态分布',
  'auto.pages.pages.test-management.dashboard.index.15': '缺陷严重程度分布',
  'auto.pages.pages.test-management.dashboard.index.16': '用例执行趋势',
  'auto.pages.pages.test-management.dashboard.index.17': '缺陷发现与修复趋势',
  'auto.pages.pages.test-management.dashboard.index.18': '近期测试任务',
  'auto.pages.pages.test-management.index.1': '项目切换后菜单状态保持',
  'auto.pages.pages.test-management.index.2': '需求概要AI生成结果可保存',
  'auto.pages.pages.test-management.index.3': '代码仓库授权失败回滚',
  'auto.pages.pages.test-management.order.index.1': '测试单标题',
  'auto.pages.pages.test-management.order.index.2': '测试类型',
  'auto.pages.pages.test-management.order.index.3': '全功能测试',
  'auto.pages.pages.test-management.order.index.4': '冒烟测试',
  'auto.pages.pages.test-management.order.index.5': '专项测试',
  'auto.pages.pages.test-management.order.index.6': '性能测试',
  'auto.pages.pages.test-management.order.index.7': '当前进度',
  'auto.pages.pages.test-management.order.index.8': '状态',
  'auto.pages.pages.test-management.order.index.9': '草稿',
  'auto.pages.pages.test-management.order.index.10': '执行中',
  'auto.pages.pages.test-management.order.index.11': '已完成',
  'auto.pages.pages.test-management.order.index.12': '已终止',
  'auto.pages.pages.test-management.order.index.13': '负责人',
  'auto.pages.pages.test-management.order.index.14': '计划完成日期',
  'auto.pages.pages.test-management.order.index.15': '操作',
  'auto.pages.pages.test-management.order.index.16': 'Mock: 编辑测试单',
  'auto.pages.pages.test-management.order.index.17': '编辑',
  'auto.pages.pages.test-management.order.index.18': 'Mock: 进入执行空间',
  'auto.pages.pages.test-management.order.index.19': '执行',
  'auto.pages.pages.test-management.order.index.20': 'Mock: 查看报告',
  'auto.pages.pages.test-management.order.index.21': '报告',
  'auto.pages.pages.test-management.order.index.22': 'Mock: 新建测试单',
  'auto.pages.pages.test-management.order.index.23': '新建测试单',
  'auto.pages.pages.test-management.report.index.1': '报告名称',
  'auto.pages.pages.test-management.report.index.2': '关联测试单',
  'auto.pages.pages.test-management.report.index.3': '通过率',
  'auto.pages.pages.test-management.report.index.4': '缺陷数',
  'auto.pages.pages.test-management.report.index.5': '负责人',
  'auto.pages.pages.test-management.report.index.6': '生成时间',
  'auto.pages.pages.test-management.report.index.7': '操作',
  'auto.pages.pages.test-management.report.index.8': 'Mock: 查看报告详情',
  'auto.pages.pages.test-management.report.index.9': '查看',
  'auto.pages.pages.test-management.report.index.10': 'Mock: 下载 PDF',
  'auto.pages.pages.test-management.report.index.11': '下载',
  'auto.pages.pages.test-management.report.index.12': '确认删除报告？',
  'auto.pages.pages.test-management.report.index.13': '报告已删除（Mock）',
  'auto.pages.pages.test-management.report.index.14': '删除',
  'auto.pages.pages.test-management.suite.index.1': '测试集名称',
  'auto.pages.pages.test-management.suite.index.2': '描述',
  'auto.pages.pages.test-management.suite.index.3': '包含用例数',
  'auto.pages.pages.test-management.suite.index.4': '个用例',
  'auto.pages.pages.test-management.suite.index.5': '创建人',
  'auto.pages.pages.test-management.suite.index.6': '创建时间',
  'auto.pages.pages.test-management.suite.index.7': '操作',
  'auto.pages.pages.test-management.suite.index.8': 'Mock: 编辑功能',
  'auto.pages.pages.test-management.suite.index.9': '编辑',
  'auto.pages.pages.test-management.suite.index.10': 'Mock: 管理用例',
  'auto.pages.pages.test-management.suite.index.11': '管理用例',
  'auto.pages.pages.test-management.suite.index.12': '确认删除？',
  'auto.pages.pages.test-management.suite.index.13': '已删除（Mock）',
  'auto.pages.pages.test-management.suite.index.14': '删除',
  'auto.pages.pages.test-management.suite.index.15': 'Mock: 新建测试集',
  'auto.pages.pages.test-management.suite.index.16': '新建测试集',
  'auto.component.components.Footer.index.1':
    '2026 珊瑚智成（北京）科技有限公司',
  'auto.component.components.Layout.SiderResizeHandle.1': '调整菜单宽度',
  'auto.component.components.LexicalBlockEditor.1': '请输入链接地址',
  'auto.component.components.LexicalBlockEditor.2': '撤销',
  'auto.component.components.LexicalBlockEditor.3': '重做',
  'auto.component.components.LexicalBlockEditor.4': '正文',
  'auto.component.components.LexicalBlockEditor.5': '标题 1',
  'auto.component.components.LexicalBlockEditor.6': '标题 2',
  'auto.component.components.LexicalBlockEditor.7': '标题 3',
  'auto.component.components.LexicalBlockEditor.8': '引用',
  'auto.component.components.LexicalBlockEditor.9': '代码块',
  'auto.component.components.LexicalBlockEditor.10': '无序列表',
  'auto.component.components.LexicalBlockEditor.11': '有序列表',
  'auto.component.components.LexicalBlockEditor.12': '任务列表',
  'auto.component.components.LexicalBlockEditor.13': '加粗',
  'auto.component.components.LexicalBlockEditor.14': '斜体',
  'auto.component.components.LexicalBlockEditor.15': '下划线',
  'auto.component.components.LexicalBlockEditor.16': '删除线',
  'auto.component.components.LexicalBlockEditor.17': '行内代码',
  'auto.component.components.LexicalBlockEditor.18': '取消链接',
  'auto.component.components.LexicalBlockEditor.19': '插入链接',
  'auto.component.components.LexicalBlockEditor.20': '无序列表',
  'auto.component.components.LexicalBlockEditor.21': '有序列表',
  'auto.component.components.LexicalBlockEditor.22': '插入表格',
  'auto.component.components.LexicalBlockEditor.23': '上方插入行',
  'auto.component.components.LexicalBlockEditor.24': '行↑',
  'auto.component.components.LexicalBlockEditor.25': '下方插入行',
  'auto.component.components.LexicalBlockEditor.26': '行↓',
  'auto.component.components.LexicalBlockEditor.27': '左侧插入列',
  'auto.component.components.LexicalBlockEditor.28': '列←',
  'auto.component.components.LexicalBlockEditor.29': '右侧插入列',
  'auto.component.components.LexicalBlockEditor.30': '列→',
  'auto.component.components.LexicalBlockEditor.31': '左对齐',
  'auto.component.components.LexicalBlockEditor.32': '居中',
  'auto.component.components.LexicalBlockEditor.33': '右对齐',
  'auto.component.components.LexicalBlockEditor.34': '请输入链接地址',
  'auto.component.components.LexicalBlockEditor.35': '加粗',
  'auto.component.components.LexicalBlockEditor.36': '斜体',
  'auto.component.components.LexicalBlockEditor.37': '下划线',
  'auto.component.components.LexicalBlockEditor.38': '删除线',
  'auto.component.components.LexicalBlockEditor.39': '下标',
  'auto.component.components.LexicalBlockEditor.40': '上标',
  'auto.component.components.LexicalBlockEditor.41': '行内代码',
  'auto.component.components.LexicalBlockEditor.42': '取消链接',
  'auto.component.components.LexicalBlockEditor.43': '插入链接',
  'auto.component.components.LexicalBlockEditor.44': '正文',
  'auto.component.components.LexicalBlockEditor.45': '段落',
  'auto.component.components.LexicalBlockEditor.46': '标题1',
  'auto.component.components.LexicalBlockEditor.47': '一级标题',
  'auto.component.components.LexicalBlockEditor.48': '标题2',
  'auto.component.components.LexicalBlockEditor.49': '二级标题',
  'auto.component.components.LexicalBlockEditor.50': '标题3',
  'auto.component.components.LexicalBlockEditor.51': '三级标题',
  'auto.component.components.LexicalBlockEditor.52': '有序',
  'auto.component.components.LexicalBlockEditor.53': '序号',
  'auto.component.components.LexicalBlockEditor.54': '无序',
  'auto.component.components.LexicalBlockEditor.55': '圆点',
  'auto.component.components.LexicalBlockEditor.56': '任务',
  'auto.component.components.LexicalBlockEditor.57': '清单',
  'auto.component.components.LexicalBlockEditor.58': '表格',
  'auto.component.components.LexicalBlockEditor.59': '分割线',
  'auto.component.components.LexicalBlockEditor.60': '引用',
  'auto.component.components.LexicalBlockEditor.61': '代码',
  'auto.component.components.LexicalBlockEditor.62': '代码块',
  'auto.component.components.LexicalBlockEditor.63': '拖动排序',
  'auto.component.components.LexicalBlockEditor.64': '放置到此处',
  'auto.component.components.LexicalBlockEditor.65': '请输入概要内容',
  'auto.component.components.RichTextEditor.index.1': '请输入内容...',
  'auto.pages.pages.requirements.concept-analysis.group.index.1':
    'CurrentProject',
  'auto.pages.pages.requirements.concept-analysis.group.index.2':
    'CurrentProject',
  'auto.pages.pages.requirements.concept-analysis.group.index.3': 'Load Failed',
  'auto.pages.pages.requirements.concept-analysis.group.index.4':
    'Please Project',
  'auto.pages.pages.requirements.concept-analysis.group.index.5':
    'please enter （ ）',
  'auto.pages.pages.requirements.concept-analysis.group.index.6':
    'Create Failed',
  'auto.pages.pages.requirements.concept-analysis.group.index.7':
    'Create {{p1}} , Failed {{p2}}',
  'auto.pages.pages.requirements.concept-analysis.group.index.8':
    'Create {{p1}}',
  'auto.pages.pages.requirements.concept-analysis.group.index.9':
    'Create Failed',
  'auto.pages.pages.requirements.concept-analysis.group.index.10':
    'Create Failed',
  'auto.pages.pages.requirements.concept-analysis.group.index.11': 'Update',
  'auto.pages.pages.requirements.concept-analysis.group.index.12':
    'Update Failed',
  'auto.pages.pages.requirements.concept-analysis.group.index.13': 'Delete',
  'auto.pages.pages.requirements.concept-analysis.group.index.14':
    'Delete Failed',
  'auto.pages.pages.requirements.concept-analysis.group.index.15': 'Please',
  'auto.pages.pages.requirements.concept-analysis.group.index.16': 'Save',
  'auto.pages.pages.requirements.concept-analysis.group.index.17':
    'Save Failed',
  'auto.pages.pages.requirements.concept-analysis.group.index.18':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.group.index.19':
    'Project: {{p1}}',
  'auto.pages.pages.requirements.concept-analysis.group.index.20': 'Column',
  'auto.pages.pages.requirements.concept-analysis.group.index.21': 'Create',
  'auto.pages.pages.requirements.concept-analysis.group.index.22':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.group.index.23':
    'Confirm deletion ？',
  'auto.pages.pages.requirements.concept-analysis.group.index.24': 'Delete',
  'auto.pages.pages.requirements.concept-analysis.group.index.25': ': {{p1}}',
  'auto.pages.pages.requirements.concept-analysis.group.index.26':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.group.index.27': 'Save',
  'auto.pages.pages.requirements.concept-analysis.group.index.28':
    'please select Edit',
  'auto.pages.pages.requirements.concept-analysis.group.index.29':
    '. Current .',
  'auto.pages.pages.requirements.concept-analysis.group.index.30':
    'Chinese Name',
  'auto.pages.pages.requirements.concept-analysis.group.index.31': 'Create',
  'auto.pages.pages.requirements.concept-analysis.group.index.32': 'Create',
  'auto.pages.pages.requirements.concept-analysis.group.index.33':
    ', Batch （ ）\nExample: \n \n',
  'auto.pages.pages.requirements.concept-analysis.group.index.34':
    'Description（Optional, BatchCreate Apply ）',
  'auto.pages.pages.requirements.concept-analysis.management.index.1':
    'Please keep at least , “ ｜ ”',
  'auto.pages.pages.requirements.concept-analysis.management.index.2':
    '{{p1}} Preview',
  'auto.pages.pages.requirements.concept-analysis.management.index.3':
    'Breakdown Mode: （ 100）',
  'auto.pages.pages.requirements.concept-analysis.management.index.4':
    'Breakdown Mode: Count（{{p1}}）',
  'auto.pages.pages.requirements.concept-analysis.management.index.5':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.6':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.7':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.8':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.9':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.10':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.11':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.12': 'Apply',
  'auto.pages.pages.requirements.concept-analysis.management.index.13':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.14':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.15':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.16':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.17':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.18': 'Apply',
  'auto.pages.pages.requirements.concept-analysis.management.index.19':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.20':
    'Confirm deletion',
  'auto.pages.pages.requirements.concept-analysis.management.index.21':
    'Confirm deletion',
  'auto.pages.pages.requirements.concept-analysis.management.index.22':
    'Cancel',
  'auto.pages.pages.requirements.concept-analysis.management.index.23':
    'Delete .Current Delete',
  'auto.pages.pages.requirements.concept-analysis.management.index.24': ',',
  'auto.pages.pages.requirements.concept-analysis.management.index.25': '.',
  'auto.pages.pages.requirements.concept-analysis.management.index.26': ':',
  'auto.pages.pages.requirements.concept-analysis.management.index.27':
    '{{p1}}',
  'auto.pages.pages.requirements.concept-analysis.management.index.28':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.29':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.30': '.',
  'auto.pages.pages.requirements.concept-analysis.management.index.31': '（ ）',
  'auto.pages.pages.requirements.concept-analysis.management.index.32': ',',
  'auto.pages.pages.requirements.concept-analysis.management.index.33':
    'please select',
  'auto.pages.pages.requirements.concept-analysis.management.index.34':
    'please select',
  'auto.pages.pages.requirements.concept-analysis.management.index.35':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.36':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.37': 'Draft',
  'auto.pages.pages.requirements.concept-analysis.management.index.38':
    'In Progress',
  'auto.pages.pages.requirements.concept-analysis.management.index.39':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.40':
    '（Optional Create）',
  'auto.pages.pages.requirements.concept-analysis.management.index.41':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.42':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.43': 'Apply',
  'auto.pages.pages.requirements.concept-analysis.management.index.44':
    'Markdown ; , Count .',
  'auto.pages.pages.requirements.concept-analysis.management.index.45':
    'Markdown ,',
  'auto.pages.pages.requirements.concept-analysis.management.index.46':
    'Breakdown Mode',
  'auto.pages.pages.requirements.concept-analysis.management.index.47': 'A、',
  'auto.pages.pages.requirements.concept-analysis.management.index.48':
    'B、 Count',
  'auto.pages.pages.requirements.concept-analysis.management.index.49': 'C、',
  'auto.pages.pages.requirements.concept-analysis.management.index.50':
    'please enter 1-100',
  'auto.pages.pages.requirements.concept-analysis.management.index.51':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.management.index.52':
    'please enter List',
  'auto.pages.pages.requirements.concept-analysis.management.index.53':
    ', “ ｜ ” ; .',
  'auto.pages.pages.requirements.concept-analysis.management.index.54':
    'Example: \nRequirement ｜ Requirement \nFeature List｜ Column',
  'auto.pages.pages.requirements.concept-analysis.relation.index.1':
    'CurrentProject',
  'auto.pages.pages.requirements.concept-analysis.relation.index.2':
    'CurrentProject',
  'auto.pages.pages.requirements.concept-analysis.relation.index.3':
    'Load Failed',
  'auto.pages.pages.requirements.concept-analysis.relation.index.4':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.5':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.6':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.7':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.8':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.9':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.10':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.11':
    'please select',
  'auto.pages.pages.requirements.concept-analysis.relation.index.12':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.13':
    'please select',
  'auto.pages.pages.requirements.concept-analysis.relation.index.14':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.15':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.16':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.17': 'Actions',
  'auto.pages.pages.requirements.concept-analysis.relation.index.18': 'Delete',
  'auto.pages.pages.requirements.concept-analysis.relation.index.19':
    'Please Project',
  'auto.pages.pages.requirements.concept-analysis.relation.index.20':
    '{p1} Missing , and retry',
  'auto.pages.pages.requirements.concept-analysis.relation.index.21':
    '{p1} （ = ）,',
  'auto.pages.pages.requirements.concept-analysis.relation.index.22':
    ': “{p1}” （{p2} / {p3}）',
  'auto.pages.pages.requirements.concept-analysis.relation.index.23':
    'Saved successfully',
  'auto.pages.pages.requirements.concept-analysis.relation.index.24':
    'Save failed',
  'auto.pages.pages.requirements.concept-analysis.relation.index.25':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.26':
    'Project: {p1}',
  'auto.pages.pages.requirements.concept-analysis.relation.index.27':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.28': ':',
  'auto.pages.pages.requirements.concept-analysis.relation.index.29': ':',
  'auto.pages.pages.requirements.concept-analysis.relation.index.30': ':',
  'auto.pages.pages.requirements.concept-analysis.relation.index.31':
    '“ +\n ” , 、 .',
  'auto.pages.pages.requirements.concept-analysis.relation.index.32':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.33':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.34':
    'Translated text',
  'auto.pages.pages.requirements.concept-analysis.relation.index.35':
    'Delete （',
  'auto.pages.pages.requirements.concept-analysis.relation.index.36': 'Save',
  'auto.pages.pages.project.agent-management.index.1':
    'Failed to load project-bound agents',
  'auto.pages.pages.project.agent-management.index.2':
    'Failed to load bindable agents',
  'auto.pages.pages.project.agent-management.index.3':
    'Agent updated successfully',
  'auto.pages.pages.project.agent-management.index.4':
    'Agent created and bound successfully',
  'auto.pages.pages.project.agent-management.index.5': 'Bound successfully',
  'auto.pages.pages.project.agent-management.index.6': 'Failed to bind',
  'auto.pages.pages.project.agent-management.index.7':
    'Unbound from current project',
  'auto.pages.pages.project.agent-management.index.8': 'Failed to unbind',
  'auto.pages.pages.project.agent-management.index.9':
    'Failed to load secret info',
  'auto.pages.pages.project.agent-management.index.10': 'Secrets updated',
  'auto.pages.pages.project.agent-management.index.11': 'Name',
  'auto.pages.pages.project.agent-management.index.12': 'Status',
  'auto.pages.pages.project.agent-management.index.13': 'Actions',
  'auto.pages.pages.project.agent-management.index.14': 'Edit',
  'auto.pages.pages.project.agent-management.index.15':
    'Confirm unbinding this Agent from the current project?',
  'auto.pages.pages.project.agent-management.index.16': 'Unbind',
  'auto.pages.pages.project.agent-management.index.17': 'Name',
  'auto.pages.pages.project.agent-management.index.18': 'Status',
  'auto.pages.pages.project.agent-management.index.19': 'Actions',
  'auto.pages.pages.project.agent-management.index.20':
    'Bind to current project',
  'auto.pages.pages.project.agent-management.index.21': 'Agent Management',
  'auto.pages.pages.project.agent-management.index.22':
    'Manage agent bindings and secrets in the current project context',
  'auto.pages.pages.project.agent-management.index.23':
    'Search name / URL / host',
  'auto.pages.pages.project.agent-management.index.24': 'Status',
  'auto.pages.pages.project.agent-management.index.25': 'Refresh',
  'auto.pages.pages.project.agent-management.index.26': 'Bind Existing Agent',
  'auto.pages.pages.project.agent-management.index.27': 'Quick Create Agent',
  'auto.pages.pages.project.agent-management.index.28': 'Bind Existing Agent',
  'auto.pages.pages.project.agent-management.index.29':
    'Search name / URL / host',
  'auto.pages.pages.project.agent-management.index.30': 'Status',
  'auto.pages.pages.project.agent-management.index.31': 'Refresh',
  'auto.pages.pages.project.agent-management.index.32': 'Edit Agent',
  'auto.pages.pages.project.agent-management.index.33': 'Quick Create Agent',
  'auto.pages.pages.project.agent-management.index.34': 'Name',
  'auto.pages.pages.project.agent-management.index.35':
    'Please enter agent name',
  'auto.pages.pages.project.agent-management.index.36':
    'Please select provider',
  'auto.pages.pages.project.agent-management.index.37': 'Please enter Base URL',
  'auto.pages.pages.project.agent-management.index.38': 'Status',
  'auto.pages.pages.project.agent-management.index.39': 'Description',
  'auto.pages.pages.project.agent-management.index.40':
    'Configure Secrets{{p1}}',
  'auto.pages.pages.project.agent-management.index.41':
    'Current secret keys (key names only, values hidden)',
  'auto.pages.pages.project.agent-management.index.42': 'Please enter key',
  'auto.pages.pages.project.agent-management.index.43': 'e.g. OPENAI_API_KEY',
  'auto.pages.pages.project.agent-management.index.44': 'Please enter value',
  'auto.pages.pages.project.agent-management.index.45':
    'Enter plaintext value (hidden after save)',
  'auto.pages.pages.project.agent-management.index.46': 'Delete',
  'auto.pages.pages.project.agent-management.index.47': 'Add Secret',

  // Codebase detail drawer
  'pages.codebase.detail.title': 'Codebase Details',
  'pages.codebase.detail.tab.token': 'Token Settings',
  'pages.codebase.detail.tab.commits': 'Commit History',
  'pages.codebase.detail.tab.readme': 'README Preview',
  'pages.codebase.detail.branch.placeholder': 'Select branch',
  'pages.codebase.detail.noProjectId':
    'Configure GitLab Project ID to view details',
  'pages.codebase.token.create': 'Create Token',
  'pages.codebase.token.name': 'Token Name',
  'pages.codebase.token.scopes': 'Scopes',
  'pages.codebase.token.expiresAt': 'Expires At',
  'pages.codebase.token.accessLevel': 'Access Level',
  'pages.codebase.token.status': 'Status',
  'pages.codebase.token.active': 'Active',
  'pages.codebase.token.revoked': 'Revoked',
  'pages.codebase.token.expired': 'Expired',
  'pages.codebase.token.createdAt': 'Created At',
  'pages.codebase.token.createdSuccess': 'Token created successfully',
  'pages.codebase.token.createdWarning':
    'This token value will only be shown once. Copy it now before closing.',
  'pages.codebase.token.empty': 'No project tokens',
  'pages.codebase.token.neverExpires': 'Never expires',
  'pages.codebase.commit.hash': 'Commit Hash',
  'pages.codebase.commit.message': 'Message',
  'pages.codebase.commit.author': 'Author',
  'pages.codebase.commit.date': 'Date',
  'pages.codebase.commit.stats': 'Stats',
  'pages.codebase.commit.empty': 'No commits found',
  'pages.codebase.readme.empty': 'No README found on this branch',
  'pages.codebase.readme.loading': 'Loading README...',
  'pages.codebase.readme.error':
    'Failed to load README. Check GitLab configuration.',
  'pages.codebase.detail.viewDetail': 'Details',
  'auto.pages.pages.projects.import.1':
    'Only .xlsx Excel files are supported for upload',
  'auto.pages.pages.projects.import.2':
    'Please select the Excel file to import first',
  'auto.pages.pages.projects.import.3':
    'Import completed successfully. {p1} project(s) imported',
  'auto.pages.pages.projects.import.4':
    'Partial import succeeded: {p1} succeeded, {p2} failed',
  'auto.pages.pages.projects.import.5':
    'Import failed. Please check the error details',
  'auto.pages.pages.projects.import.6': 'Batch Import Projects',
  'auto.pages.pages.projects.import.7': 'Download Template',
  'auto.pages.pages.projects.import.8': 'Cancel',
  'auto.pages.pages.projects.import.9': 'Start Import',
  'auto.pages.pages.projects.import.10': 'Import Instructions',
  'auto.pages.pages.projects.import.11':
    'Use an .xlsx file. The first-row headers must include Chinese Name and Identifier; English Name, Prefix, Logo, and Description are optional.',
  'auto.pages.pages.projects.import.12':
    'The system imports row by row and returns failure reasons for each failed row; blank rows are skipped automatically.',
  'auto.pages.pages.projects.import.13':
    'Click or drag an Excel file here to upload',
  'auto.pages.pages.projects.import.14':
    'Only one .xlsx file is supported per import. It is recommended to download the template first and fill it in before importing.',
  'auto.pages.pages.projects.import.15': 'Import Result',
  'auto.pages.pages.projects.import.16':
    '{p1} data row(s): {p2} succeeded, {p3} failed, {p4} blank row(s) skipped.',
  'auto.pages.pages.projects.import.17': 'Row',
  'auto.pages.pages.projects.import.18': 'Chinese Name',
  'auto.pages.pages.projects.import.19': 'Identifier',
  'auto.pages.pages.projects.import.20': 'Failure Reason',
  'auto.pages.pages.projects.import.21': 'Batch Import',
  'auto.pages.pages.projects.import.preview.1': 'Row',
  'auto.pages.pages.projects.import.preview.2': 'Chinese Name',
  'auto.pages.pages.projects.import.preview.3': 'English Name',
  'auto.pages.pages.projects.import.preview.4': 'Identifier',
  'auto.pages.pages.projects.import.preview.5': 'Tags',
  'auto.pages.pages.projects.import.preview.6': 'Group',
  'auto.pages.pages.projects.import.preview.7': 'Description',
  'auto.pages.pages.projects.import.preview.8': 'Pre-check Result',
  'auto.pages.pages.projects.import.preview.9': 'Ready to Import',
  'auto.pages.pages.projects.import.preview.10': 'Failed to parse Excel',
  'auto.pages.pages.projects.import.preview.11': 'Import Preview',
  'auto.pages.pages.projects.import.preview.12':
    '{p1} data row(s) parsed, {p2} blank row(s) skipped, {p3} row(s) need correction.',
  'auto.pages.pages.projects.import.preview.13':
    'This preview shows the local parsing result. The server still de-duplicates by project name during import, so projects with duplicate names will be skipped automatically.',
};
